import React from 'react';
import { notifEventBus } from "../notifBus.js";
import { detaillerTachePrestation } from "./TaskForm.jsx";
import { useState, useEffect, useRef, useMemo, useCallback, Fragment} from "react"
import { TT, CL, GP, ROOM_TYPES, BILL_TYPES, SUPA_URL, SUPA_KEY } from "../constants.js";
import { fd, feur, fileToDataUrl, today, aD, bornesSemaine, compressToDataUrl, iD, labelJourASCII, lundiDeISO, numSemaineISO, detectPmsVendor, pmsLabel} from "../utils.js";
import { Ic } from "./Ic.jsx";
import { M } from "./M.jsx";
import { supaGet, supaSet, supaSetStrict, useSt, getSignedFactureUrl, uploadFileToFacturesBucket , SUPA_TOKEN } from "../supabase.js";
import { calcSejour, buildFactureSnapshot, regenererPDFDepuisFacture, montantFactureActuel, SejourForm, SEJOUR_EMPTY, envoyerFactureParEmail} from "./SecProp.jsx";
import { generateFacturX, bytesToBase64, SERIE_CONCIERGERIE, prochainCompteur, formatNumero, avancerCompteur } from "../facturxCore.js";
import { reconcilePms, fetchPmsIcal} from "./SecRapports.jsx";
import { validerLigneLibre, ajouterLignesLibres, totalLignesLibres, termesInterditsDans, SECTIONS_LIBRES } from "../lignesLibresPresta.js";


// ── Aide à la facturation (admin) ──
function AideFacturation({sejours,biens,clients,factures,setFactures,compteursFacture,setCompteursFacture}){
  const now2=new Date();
  const[mois,setMois]=useState(now2.getMonth()===0?11:now2.getMonth()-1);
  const[annee,setAnnee]=useState(now2.getMonth()===0?now2.getFullYear()-1:now2.getFullYear());
  const[selClient,setSelClient]=useState('all');
  const[mode,setMode]=useState('mois'); // 'mois' | 'trim' | 'perso'
  const[trim,setTrim]=useState(Math.floor((now2.getMonth())/3)); // 0..3
  const[dDebut,setDDebut]=useState('');
  const[dFin,setDFin]=useState('');
  const MOIS=['Janv','Févr','Mars','Avr','Mai','Juin','Juil','Août','Sept','Oct','Nov','Déc'];
  const MOIS_LONG=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  const TRIM_LBL=['T1 (Janv–Mars)','T2 (Avr–Juin)','T3 (Juil–Sept)','T4 (Oct–Déc)'];

  // Libellé de la période active (réutilisé partout : titres, PDF, noms de fichiers)
  const periodeLabel=mode==='mois'?(MOIS_LONG[mois]+' '+annee)
    :mode==='trim'?(TRIM_LBL[trim].split(' ')[0]+' '+annee)
    :(dDebut&&dFin?('du '+dDebut.split('-').reverse().join('/')+' au '+dFin.split('-').reverse().join('/')):'Période personnalisée');
  const periodeFichier=mode==='mois'?(MOIS_LONG[mois]+'-'+annee)
    :mode==='trim'?('T'+(trim+1)+'-'+annee)
    :((dDebut||'debut')+'_'+(dFin||'fin'));

  // Teste si un séjour tombe dans la période active (toujours sur la date de départ)
  const dansPeriode=(s)=>{
    if(!s.dateDepart&&!s.dateArrivee)return false;
    const d=new Date(s.dateDepart||s.dateArrivee);
    if(mode==='mois')return d.getMonth()===mois&&d.getFullYear()===annee;
    if(mode==='trim')return Math.floor(d.getMonth()/3)===trim&&d.getFullYear()===annee;
    // perso
    if(!dDebut||!dFin)return false;
    const deb=new Date(dDebut+'T00:00:00'),fin=new Date(dFin+'T23:59:59');
    return d>=deb&&d<=fin;
  };

  const STATUTS_EXCLUS_TS_ADM=['ignore','a_completer','annule_eviivo','annulee'];
  const sejoursDuMois=sejours.filter(s=>dansPeriode(s)&&(selClient==='all'||s.cid===selClient)&&!STATUTS_EXCLUS_TS_ADM.includes(s.statut)).sort((a,b)=>(a.dateArrivee||a.dateDepart||'').localeCompare(b.dateArrivee||b.dateDepart||''));

  const parClient=useMemo(()=>{
    const map={};
    sejoursDuMois.forEach(s=>{
      const bien=biens.find(b=>b.id===s.bid);
      if(!bien)return;
      const c=clients.find(x=>x.id===s.cid)||{id:s.cid,name:'Propriétaire inconnu'};
      if(!map[c.id])map[c.id]={client:c,lignes:[]};
      const calc=calcSejour(s,bien,c);
      map[c.id].lignes.push({s,bien,calc});
    });
    return Object.values(map);
  },[sejoursDuMois,biens,clients]);

  return(<div>
    {/* Filtres période : 3 modes */}
    <div style={{display:'flex',gap:10,marginBottom:16,flexWrap:'wrap',alignItems:'center'}}>
      <div style={{display:'flex',gap:4,background:'var(--bg)',borderRadius:9,padding:3}}>
        {[['mois','Mois'],['trim','Trimestre'],['perso','Plage perso']].map(([m,lbl])=>(
          <button key={m} onClick={()=>setMode(m)} className="st" style={{background:mode===m?'var(--or)':'transparent',color:mode===m?'#fff':'var(--si)',border:'none',padding:'6px 12px',fontSize:12,fontWeight:mode===m?700:500}}>{lbl}</button>
        ))}
      </div>
      {mode==='mois'&&<>
        <button onClick={()=>{if(mois===0){setMois(11);setAnnee(a=>a-1);}else setMois(m=>m-1);}} className="wn">‹</button>
        <button onClick={()=>{if(mois===11){setMois(0);setAnnee(a=>a+1);}else setMois(m=>m+1);}} className="wn">›</button>
        <div className="D" style={{fontSize:18,minWidth:150}}>{MOIS_LONG[mois]} {annee}</div>
      </>}
      {mode==='trim'&&<>
        <select value={trim} onChange={e=>setTrim(Number(e.target.value))} style={{width:'auto',minWidth:160,fontSize:13}}>
          {TRIM_LBL.map((l,i)=><option key={i} value={i}>{l}</option>)}
        </select>
        <select value={annee} onChange={e=>setAnnee(Number(e.target.value))} style={{width:'auto',fontSize:13}}>
          {[annee-1,annee,annee+1].map(a=><option key={a} value={a}>{a}</option>)}
        </select>
      </>}
      {mode==='perso'&&<>
        <div style={{display:'flex',gap:6,alignItems:'center'}}>
          <label style={{fontSize:12,color:'var(--si)'}}>Du</label>
          <input type="date" value={dDebut} onChange={e=>setDDebut(e.target.value)} style={{width:'auto',fontSize:13}}/>
          <label style={{fontSize:12,color:'var(--si)'}}>au</label>
          <input type="date" value={dFin} onChange={e=>setDFin(e.target.value)} style={{width:'auto',fontSize:13}}/>
        </div>
      </>}
      <select value={selClient} onChange={e=>setSelClient(e.target.value)} style={{width:'auto',minWidth:180,fontSize:13}}>
        <option value="all">Tous les propriétaires</option>
        {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
    </div>

    {parClient.length===0&&<div className="empty">Aucun séjour saisi pour cette période.</div>}

    {parClient.map(({client,lignes})=>{
      const totPrest=lignes.reduce((s,l)=>s+l.calc.totalPrestations,0);
      const totServices=lignes.reduce((s,l)=>s+l.calc.fraisServices,0);
      const totHT=lignes.reduce((s,l)=>s+l.calc.totalHT,0);
      const totTTC=lignes.reduce((s,l)=>s+l.calc.totalTTC,0);
      const totDebours=lignes.reduce((s,l)=>s+l.calc.totalDebours,0);
      const totVersements=lignes.reduce((s,l)=>s+Number(l.s.versementProprio||0),0);
      const totNuitees=lignes.reduce((s,l)=>s+Number(l.s.nuitees||0),0);
      // Base de référence pour les % = ce que le locataire a payé, hors taxe de séjour (qui appartient à la mairie)
      const totBaseRef=lignes.reduce((s,l)=>s+(Number(l.s.versementOTA||0)-Number(l.s.taxeSejour||0)),0);
      const soldeNet=totVersements-totTTC;
      // €/nuit net propriétaire (sur la période)
      const netParNuit=totNuitees>0?Math.round(soldeNet/totNuitees*100)/100:0;
      // Répartition en % de la base de référence (versement OTA − taxe)
      // % propriétaire : net réel (il décaisse le TTC). % conciergerie : HT seulement (la TVA transite vers l'État, ce n'est pas notre revenu).
      const pctProprio=totBaseRef>0?Math.round(soldeNet/totBaseRef*1000)/10:null;
      const pctConcierge=totBaseRef>0?Math.round(totHT/totBaseRef*1000)/10:null;
      // Compteur 120 jours : nuitées de l'année pour les biens du client qui ont le flag actif
      const anneeRef=mode==='perso'?(dFin?new Date(dFin).getFullYear():annee):annee;
      const nuitéesAnnee=sejours.filter(s=>{
        if(!s.dateDepart&&!s.dateArrivee)return false;
        const d=new Date(s.dateDepart||s.dateArrivee);
        const bien=biens.find(b=>b.id===s.bid);
        return d.getFullYear()===anneeRef&&s.cid===client.id&&bien?.limite120jours;
      }).reduce((sum,s)=>sum+Number(s.nuitees||0),0);
      const biensAvecLimite=biens.filter(b=>b.cid===client.id&&b.limite120jours);

      // ── Lot C : facture existante pour cette période+client ──
      const factureExistante=(factures||[]).find(f=>{
        if(f.cid!==client.id)return false;
        // Correspondance par periodeLabel (exact) OU par composantes de période
        if(f.periodeLabel===periodeLabel)return true;
        const p=f.periode;
        if(!p)return false;
        if(p.mode==='mois'&&mode==='mois')return p.mois===mois&&p.annee===annee;
        if(p.mode==='trim'&&mode==='trim')return p.trim===trim&&p.annee===annee;
        if(p.mode==='perso'&&mode==='perso')return p.dDebut===dDebut&&p.dFin===dFin;
        return false;
      });
      // Émission auto : attribue FC-{année}-{NNN} en lisant/incrémentant le compteur annuel.
      // Le numéro est figé sur la facture, le compteur est incrémenté de façon atomique.
      const emettreFacture=fac=>{
        const annee=new Date().getFullYear();
        const cpt=prochainCompteur(compteursFacture,SERIE_CONCIERGERIE,annee);
        const numero=formatNumero(SERIE_CONCIERGERIE,annee,cpt);
        if(!window.confirm(
          'Émettre cette facture sous le numéro :\n\n    '+numero+'\n\n'+
          '• Ce numéro est définitif (numérotation séquentielle légale).\n'+
          '• C\'est ce numéro que vous reporterez dans Pennylane à l\'import.\n'+
          '• Le compteur passera ensuite à '+(cpt+1)+'.\n\n'+
          'Confirmer l\'émission ?'
        ))return;
        // 1) Fige le numéro + un snapshot des montants sur la facture
        const snapshot=buildFactureSnapshot(fac.lignesIds,sejours,biens,clients);
        setFactures(prev=>prev.map(f=>f.id===fac.id
          ?{...f,statut:'emise',numeroDefinitif:numero,dateEmission:new Date().toISOString(),snapshotLignes:snapshot}
          :f));
        // 2) Incrémente le compteur de l'année
        setCompteursFacture(prev=>avancerCompteur(prev,SERIE_CONCIERGERIE,annee));
      };

      return(<div key={client.id} style={{marginBottom:28}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12,flexWrap:'wrap',gap:10}}>
          <div><div className="D" style={{fontSize:17,color:'var(--pk)'}}>{client.name}</div><div style={{fontSize:11,color:'var(--si)'}}>{lignes.length} séjour{lignes.length>1?'s':''} · {periodeLabel}</div></div>
          <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
            <div style={{background:'#e1f7ee',border:'1px solid var(--mn)',borderRadius:9,padding:'7px 14px',textAlign:'right'}}><div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>Total TTC à facturer</div><div className="D" style={{fontSize:20,color:'var(--ok)'}}>{feur(totTTC)}</div></div>
            <button onClick={()=>{
              const ML2=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
              const css2='*{box-sizing:border-box;margin:0;padding:0;}'
                +'body{font-family:Arial,sans-serif;font-size:9.5px;color:#2a2520;background:#fff;padding:18px 22px;}'
                +'@page{size:A4 landscape;margin:12mm 14mm;}'
                +'.header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:16px;padding-bottom:10px;border-bottom:2px solid #FF8617;}'
                +'.logo{font-size:18px;font-weight:900;color:#FF8617;}'
                +'.sub{font-size:9px;color:#6b5d52;}'
                +'.client{text-align:right;font-size:10px;line-height:1.7;}'
                +'table{width:100%;border-collapse:collapse;margin-bottom:12px;}'
                +'th{background:#2a2520;color:#fff;padding:5px;text-align:left;font-size:8px;font-weight:700;text-transform:uppercase;}'
                +'td{padding:4px 5px;border-bottom:1px solid #f0e8de;font-size:8.5px;vertical-align:top;}'
                +'tbody tr:nth-child(even){background:#faf6f0;}'
                +'.num{text-align:right;}.ok{color:#3a9e5f;font-weight:700;}.or{color:#FF8617;font-weight:700;}.dg{color:#e84545;font-weight:700;}.si{color:#6b5d52;font-size:8px;}'
                +'tfoot td{background:#fff4d6;font-weight:700;border-top:2px solid #FF8617;padding:6px 5px;}'
                +'.solde{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-top:12px;}'
                +'.bloc{border:1.5px solid #e8ddd0;border-radius:7px;padding:8px 12px;text-align:center;}'
                +'.lbl{font-size:8px;text-transform:uppercase;color:#6b5d52;margin-bottom:3px;}'
                +'.val{font-size:14px;font-weight:800;}'
                +'.footer{margin-top:16px;padding-top:8px;border-top:1px solid #e8ddd0;font-size:8px;color:#6b5d52;text-align:center;}'
                +'.badge{display:inline-block;padding:1px 5px;border-radius:999px;font-size:8px;font-weight:700;}'
                +'@media print{button{display:none;}}';
              const totN2=lignes.reduce(function(a,l){return a+Number(l.s.nuitees||0);},0);
              const totTaxe2=lignes.reduce(function(a,l){return a+Number(l.s.taxeSejour||0);},0);
              const totFraisOTA2=lignes.reduce(function(a,l){return a+Number(l.s.fraisOTA||0);},0);
              const totMenage2=lignes.reduce(function(a,l){return a+Number(l.s.fraisMenageLocataire||0);},0);
              let rows2='';
              lignes.forEach(function(item){
                const s=item.s;const bien=item.bien;const calc=item.calc;
                const net=Number(s.versementProprio||0)-calc.totalTTC;
                const otaBg=s.ota==='AIRBNB'?'#ffe0f0':s.ota==='BOOKING'?'#e0f0ff':'#e8e8e8';
                const loc=s.nomLocataire?(s.nomLocataire+(s.nationalite?' ('+s.nationalite+')':'')):'—';
                const taxeLabel=Number(s.taxeSejour||0)>0?(s.taxeCollecteeParOTA?'<br><span class="si">(via OTA)</span>':'<br><span class="si">(arriv&eacute;e)</span>'):'';
                rows2+='<tr>';
                rows2+='<td><strong>'+(bien?bien.name:'—')+'</strong><br><span class="si">'+loc+'</span></td>';
                rows2+='<td style="font-size:8.5px">'+(s.dateArrivee||'—')+'<br>&#8594; '+(s.dateDepart||'—')+'</td>';
                rows2+='<td class="num">'+s.nuitees+'</td>';
                rows2+='<td class="num">'+(calc.prixNuitee>0?feur(calc.prixNuitee):'—')+'</td>';
                rows2+='<td class="num"><span class="badge" style="background:'+otaBg+'">'+s.ota+'</span></td>';
                rows2+='<td class="num">'+(Number(s.fraisOTA||0)>0?feur(s.fraisOTA):'—')+'</td>';
                rows2+='<td class="num">'+(Number(s.fraisMenageLocataire||0)>0?feur(s.fraisMenageLocataire):'—')+'</td>';
                rows2+='<td class="num">'+(Number(s.taxeSejour||0)>0?feur(s.taxeSejour)+taxeLabel:'—')+'</td>';
                rows2+='<td class="num ok">'+feur(s.versementProprio)+'</td>';
                rows2+='<td class="num or">'+feur(calc.totalTTC)+'</td>';
                rows2+='<td class="num '+(net>=0?'ok':'dg')+'">'+feur(net)+'</td>';
                rows2+='</tr>';
              });
              const sc=soldeNet>=0?'ok':'dg';
              const sb=soldeNet>=0?'#86BD92':'#e84545';
              let html2='<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8">';
              html2+='<title>Releve '+periodeLabel+' '+client.name+'</title>';
              html2+='<style>'+css2+'</style></head><body>';
              html2+='<div class="header"><div><div class="logo">LA CONCIERGERIE</div><div class="sub">10, rue de la porte neuve &middot; 68000 Colmar<br>contact@conciergerie-alsace.com</div></div>';
              html2+='<div class="client"><strong>R&eacute;capitulatif de prestations</strong><br>'+periodeLabel+'<br><strong style="color:#FF8617;">'+client.name+'</strong></div></div>';
              html2+='<table><thead><tr>';
              html2+='<th>Bien / Locataire</th><th>Dates</th><th class="num">Nuits</th><th class="num">Prix/nuit</th><th class="num">OTA</th>';
              html2+='<th class="num">Frais OTA</th><th class="num">M&eacute;nage locataire</th><th class="num">Taxe s&eacute;jour</th>';
              html2+='<th class="num">Versement propri&eacute;taire</th><th class="num">Frais de services TTC</th><th class="num">Net propri&eacute;taire</th>';
              html2+='</tr></thead><tbody>'+rows2+'</tbody>';
              html2+='<tfoot><tr><td colspan="2"><strong>Totaux '+periodeLabel+'</strong></td><td class="num">'+totN2+'</td><td></td><td></td>';
              html2+='<td class="num">'+feur(totFraisOTA2)+'</td><td class="num">'+feur(totMenage2)+'</td><td class="num">'+feur(totTaxe2)+'</td>';
              html2+='<td class="num ok">'+feur(totVersements)+'</td><td class="num or">'+feur(totTTC)+'</td><td class="num '+sc+'">'+feur(soldeNet)+'</td></tr></tfoot></table>';
              html2+='<div class="solde"><div class="bloc"><div class="lbl">Vers&eacute; par l\'OTA</div><div class="val ok">'+feur(totVersements)+'</div><div style="font-size:8px;color:#6b5d52">directement au propri&eacute;taire</div></div>';
              html2+='<div class="bloc"><div class="lbl">Frais de services TTC</div><div class="val dg">&minus; '+feur(totTTC)+'</div><div style="font-size:8px;color:#6b5d52">La Conciergerie &mdash; r&eacute;f. facture</div></div>';
              html2+='<div class="bloc" style="border-color:'+sb+'"><div class="lbl">Revenu net locatif</div><div class="val '+sc+'">'+feur(soldeNet)+'</div></div></div>';
              html2+='<div class="footer">La Conciergerie &middot; SARL &middot; SIREN 943.325.951 &middot; TVA FR52943325951<br>R&eacute;capitulatif de prestations. Facture de prestations transmise s&eacute;par&eacute;ment.</div>';
              html2+='</body></html>';
              const blob2=new Blob([html2],{type:'text/html;charset=utf-8'});
              const url2=URL.createObjectURL(blob2);
              const a2=document.createElement('a');
              a2.href=url2;a2.download='releve-'+periodeFichier+'-'+client.name.replace(/\s+/g,'_')+'.html';
              document.body.appendChild(a2);a2.click();document.body.removeChild(a2);
              setTimeout(()=>URL.revokeObjectURL(url2),1000);
            }} className="btn bgh sm">📄 PDF récap</button>
            <button onClick={()=>{
              // ── PDF "Export saisie compta" : lignes prêtes à ressaisir dans Pennylane ──
              const ML3=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
              const esc=t=>String(t==null?'':t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
              const cssC='*{box-sizing:border-box;margin:0;padding:0;}'
                +'body{font-family:Arial,sans-serif;font-size:10px;color:#2a2520;background:#fff;padding:18px 22px;}'
                +'@page{size:A4 portrait;margin:14mm 14mm;}'
                +'.header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px;padding-bottom:10px;border-bottom:2px solid #FF8617;}'
                +'.logo{font-size:17px;font-weight:900;color:#FF8617;}'
                +'.sub{font-size:9px;color:#6b5d52;line-height:1.5;}'
                +'.client{text-align:right;font-size:10px;line-height:1.7;}'
                +'.sejbloc{margin-bottom:10px;border:1px solid #e8ddd0;border-radius:6px;overflow:hidden;page-break-inside:avoid;}'
                +'.sejtitle{background:#fff4d6;padding:5px 9px;font-size:9.5px;font-weight:700;color:#9a6a10;border-bottom:1px solid #f0d98a;}'
                +'table{width:100%;border-collapse:collapse;}'
                +'th{background:#2a2520;color:#fff;padding:4px 7px;text-align:left;font-size:8px;font-weight:700;text-transform:uppercase;}'
                +'td{padding:4px 7px;border-bottom:1px solid #f0e8de;font-size:9px;}'
                +'tbody tr:nth-child(even){background:#faf6f0;}'
                +'.num{text-align:right;}.qte{text-align:center;}.tva{text-align:center;color:#6b5d52;}'
                +'.deb{color:#6b5d52;font-style:italic;}'
                +'.tot{margin-top:14px;border-top:2px solid #FF8617;padding-top:8px;display:flex;justify-content:flex-end;gap:24px;font-size:11px;}'
                +'.tot b{color:#FF8617;}'
                +'.footer{margin-top:18px;padding-top:8px;border-top:1px solid #e8ddd0;font-size:8px;color:#6b5d52;text-align:center;line-height:1.6;}'
                +'@media print{button{display:none;}}';
              let blocs='';
              let nbLignes=0;
              lignes.forEach(function(item){
                const s=item.s;const bien=item.bien;const calc=item.calc;
                let rws='';
                const addRow=(label,qte,pu,tva,cls)=>{
                  nbLignes++;
                  rws+='<tr'+(cls?' class="'+cls+'"':'')+'><td>'+esc(label)+'</td><td class="qte">'+qte+'</td><td class="num">'+feur(pu)+'</td><td class="tva">'+tva+'</td><td class="num">'+feur(pu*qte)+'</td></tr>';
                };
                if(calc.menageBase>0)addRow(bien.name+' — Ménage',1,calc.menageBase,'20%');
                if(calc.majUrgent>0)addRow('Majoration urgent',1,calc.majUrgent,'20%');
                if(calc.majDimanche>0)addRow('Majoration dimanche/férié',1,calc.majDimanche,'20%');
                if(calc.checkin>0)addRow('Check-in',1,calc.checkin,'20%');
                if(calc.checkout>0)addRow('Check-out',1,calc.checkout,'20%');
                if(calc.linge2p>0)addRow('Location linge — parure 2 pers.',s.parures2p,Number(bien.tarifLinge2p),'20%');
                if(calc.linge1p>0)addRow('Location linge — parure 1 pers.',s.parures1p,Number(bien.tarifLinge1p),'20%');
                if(calc.kit>0)addRow('Kit accueil / Pack bienvenue',1,calc.kit,'20%');
                if(calc.fraisServices>0)addRow('Commission de service',1,calc.fraisServices,'20%');
                if(calc.remiseProprio>0)addRow(calc.remiseLabel||'Remise fidélité',1,-calc.remiseProprio,'20%','deb');
                (s.prestationsSupp||[]).filter(p=>p.label&&p.montant).forEach(p=>addRow(p.label,1,Number(p.montant),'20%','psupp'));
                (s.debours||[]).filter(d=>d.label&&d.montant).forEach(d=>addRow(d.label,1,Number(d.montant),'—','deb'));
                if(!rws)return;
                const loc=s.nomLocataire?(' · '+esc(s.nomLocataire)+(s.nationalite?' ('+esc(s.nationalite)+')':'')):'';
                blocs+='<div class="sejbloc"><div class="sejtitle">Séjour du '+esc(s.dateArrivee||'?')+' au '+esc(s.dateDepart||'?')+' — '+esc(bien.name)+loc+'</div>';
                blocs+='<table><thead><tr><th>Désignation</th><th class="qte">Qté</th><th class="num">PU HT</th><th class="tva">TVA</th><th class="num">Montant HT</th></tr></thead><tbody>'+rws+'</tbody></table></div>';
              });
              let htmlC='<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8">';
              htmlC+='<title>Saisie compta '+esc(periodeFichier)+' '+esc(client.name)+'</title>';
              htmlC+='<style>'+cssC+'</style></head><body>';
              htmlC+='<div class="header"><div><div class="logo">LA CONCIERGERIE</div><div class="sub">Export saisie comptable<br>10, rue de la porte neuve · 68000 Colmar</div></div>';
              htmlC+='<div class="client"><strong>'+esc(periodeLabel)+'</strong><br><strong style="color:#FF8617;">'+esc(client.name)+'</strong><br><span style="font-size:9px;color:#6b5d52">'+lignes.length+' séjour(s) · '+nbLignes+' ligne(s)</span></div></div>';
              htmlC+=blocs;
              htmlC+='<div class="tot"><div>Total prestations HT : <b>'+feur(totHT-totDebours)+'</b></div><div>Débours : <b>'+feur(totDebours)+'</b></div><div>Total TTC : <b>'+feur(totTTC)+'</b></div></div>';
              htmlC+='<div class="footer">La Conciergerie · SARL · SIREN 943.325.951 · TVA FR52943325951<br>Document interne d\'aide à la saisie comptable — à ressaisir dans le logiciel de facturation.</div>';
              htmlC+='</body></html>';
              const blobC=new Blob([htmlC],{type:'text/html;charset=utf-8'});
              const urlC=URL.createObjectURL(blobC);
              const aC=document.createElement('a');
              aC.href=urlC;aC.download='saisie-compta-'+periodeFichier+'-'+client.name.replace(/\s+/g,'_')+'.html';
              document.body.appendChild(aC);aC.click();document.body.removeChild(aC);
              setTimeout(()=>URL.revokeObjectURL(urlC),1000);
            }} className="btn bgh sm" title="Lignes prêtes à ressaisir en compta">🧾 Export saisie</button>
            <button onClick={()=>{
              generateFacturX({
                client,lignes,periodeLabel,periodeFichier,
                periode:{mode,mois,annee,trim,dDebut,dFin},
                onSave:fac=>{
                  if(typeof setFactures==='function'){
                    setFactures(prev=>{
                      const exists=prev.findIndex(f=>f.numeroBrouillon===fac.numeroBrouillon&&f.cid===fac.cid&&f.statut==='brouillon');
                      return exists>=0?prev.map((f,i)=>i===exists?fac:f):[...prev,fac];
                    });
                  }
                },
              }).catch(e=>{console.error(e);alert("Erreur génération Factur-X : "+e.message);});
            }} className="btn bor sm" style={{fontWeight:700,color:'var(--pk)'}} title="Générer la facture Factur-X (PDF + XML)">🧾 Facture Factur-X</button>
          </div>
        </div>

        {/* ── Bandeau statut facture (Lot C) ── */}
        {factureExistante&&(
          <div style={{marginBottom:12,borderRadius:9,padding:'10px 14px',display:'flex',alignItems:'center',gap:12,flexWrap:'wrap',
            background:factureExistante.statut==='emise'?'#e1f7ee':'#fff4d6',
            border:`1.5px solid ${factureExistante.statut==='emise'?'var(--mn)':'#e5c977'}`}}>
            <span style={{fontSize:18}}>{factureExistante.statut==='emise'?'✅':'📄'}</span>
            <div style={{flex:1,minWidth:200}}>
              {factureExistante.statut==='emise'?(
                <div>
                  <span style={{fontWeight:700,fontSize:13,color:'var(--ok)'}}>Facture émise</span>
                  <span style={{fontSize:12,color:'var(--si)',marginLeft:8}}>{factureExistante.numeroDefinitif}</span>
                  <span style={{fontSize:11,color:'var(--si)',marginLeft:8}}>· émise le {new Date(factureExistante.dateEmission).toLocaleDateString('fr-FR')}</span>
                </div>
              ):(
                <div>
                  <span style={{fontWeight:700,fontSize:13,color:'#7a5a00'}}>Brouillon généré</span>
                  <span style={{fontSize:11,color:'var(--si)',marginLeft:8}}>N° provisoire : {factureExistante.numeroBrouillon}</span>
                  <div style={{fontSize:11,color:'var(--si)',marginTop:2}}>Cliquez « Émettre » → l'app attribue le n° FC définitif → reportez-le dans Pennylane à l'import</div>
                </div>
              )}
            </div>
            {factureExistante.statut==='brouillon'&&(
              <button onClick={()=>emettreFacture(factureExistante)} className="btn bmn sm" style={{fontWeight:700}}>
                📤 Émettre la facture
              </button>
            )}
            {factureExistante.statut==='emise'&&(
              <button onClick={()=>regenererPDFDepuisFacture(factureExistante,client,lignes,{mode,mois,annee,trim,dDebut,dFin})
                .catch(e=>alert('Erreur PDF : '+e.message))} className="btn bmn sm">
                ⬇ Régénérer PDF
              </button>
            )}
          </div>
        )}

        {/* Compteur 120 jours si activé */}
        {biensAvecLimite.length>0&&<div style={{background:nuitéesAnnee>=120?'#fde8e8':nuitéesAnnee>=100?'#fff4d6':'#e1f7ee',border:`1.5px solid ${nuitéesAnnee>=120?'var(--dg)':nuitéesAnnee>=100?'var(--ye)':'var(--mn)'}`,borderRadius:9,padding:'8px 14px',marginBottom:12,display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
          <span style={{fontSize:18}}>{nuitéesAnnee>=120?'🚨':nuitéesAnnee>=100?'⚠️':'📅'}</span>
          <div><div style={{fontWeight:700,fontSize:12}}>Compteur 120 jours — {anneeRef}</div>
          <div style={{fontSize:11,color:'var(--si)'}}>{nuitéesAnnee} nuit{nuitéesAnnee>1?'s':''} louée{nuitéesAnnee>1?'s':''} sur 120 max · {Math.max(0,120-nuitéesAnnee)} nuit{Math.max(0,120-nuitéesAnnee)>1?'s':''} restante{Math.max(0,120-nuitéesAnnee)>1?'s':''}</div></div>
          <div style={{marginLeft:'auto',fontWeight:800,fontSize:16,color:nuitéesAnnee>=120?'var(--dg)':nuitéesAnnee>=100?'#b85d10':'var(--ok)'}}>{Math.round(nuitéesAnnee/120*100)}%</div>
        </div>}

        {/* Tableau des séjours */}
        <div style={{overflowX:'auto',marginBottom:14}}>
          <table className="tbl">
            <thead><tr><th>Séjour</th><th>OTA</th><th>Nuitées</th><th>Versement OTA→Propriétaire</th><th>Prestations</th><th>Frais de service</th><th>Débours</th><th>Total HT</th><th>TTC</th><th>€/nuit net</th><th>% prop.</th><th>% concierg.</th></tr></thead>
            <tbody>
              {lignes.map(({s,bien,calc},li)=>{
                const baseRefL=Number(s.versementOTA||0)-Number(s.taxeSejour||0);
                const netL=Number(s.versementProprio||0)-calc.totalTTC;
                const nuitsL=Number(s.nuitees||0);
                const netNuitL=nuitsL>0?Math.round(netL/nuitsL*100)/100:0;
                const pctPropL=baseRefL>0?Math.round(netL/baseRefL*1000)/10:null;
                const pctConcL=baseRefL>0?Math.round(calc.totalHT/baseRefL*1000)/10:null;
                return(
                <tr key={s.id} style={{background:li%2===1?'var(--bg)':'transparent'}}>
                  <td style={{borderLeft:'3px solid var(--or)'}}><div style={{fontWeight:700,fontSize:12}}>{bien.name}</div><div style={{fontSize:10,color:'var(--si)'}}>{s.dateArrivee} → {s.dateDepart}</div><div style={{fontSize:10,color:'var(--si)'}}>{s.adultes} adu.{s.enfants>0?` ${s.enfants} enf.`:''}{s.nomLocataire?` · ${s.nomLocataire}`:''}{s.nationalite?` (${s.nationalite})`:''}</div></td>
                  <td><span style={{background:s.ota==='AIRBNB'?'#ffe0f0':s.ota==='BOOKING'?'#e0f0ff':'#e8e8e8',color:'var(--ink)',fontSize:10,fontWeight:700,padding:'2px 6px',borderRadius:999}}>{s.ota}</span></td>
                  <td style={{textAlign:'center'}}>{s.nuitees}</td>
                  <td style={{fontWeight:600,color:'var(--ok)'}}>{feur(s.versementProprio)}</td>
                  <td>{calc.totalPrestations>0?<div>{feur(calc.totalPrestations)}<div style={{fontSize:9,color:'var(--si)'}}>{[calc.menage>0?'ménage':null,(calc.checkin+calc.checkout)>0?'CI/CO':null,(calc.linge2p+calc.linge1p)>0?'linge':null,calc.kit>0?'kit':null].filter(Boolean).join(' · ')}</div></div>:'—'}</td>
                  <td style={{fontWeight:700,color:'var(--or)'}}>{calc.fraisServices>0?feur(calc.fraisServices):'—'}{calc.remiseProprio>0&&<div style={{fontSize:9,color:'var(--ok)'}}>🎁 −{feur(calc.remiseProprio)}</div>}</td>
                  <td style={{color:'var(--dg)'}}>{calc.totalDebours!==0?feur(calc.totalDebours):'—'}</td>
                  <td style={{fontWeight:700}}>{feur(calc.totalHT)}</td>
                  <td style={{fontWeight:800,color:'var(--ok)'}}>{feur(calc.totalTTC)}</td>
                  <td style={{fontWeight:700,color:netNuitL>=0?'var(--ok)':'var(--dg)'}}>{nuitsL>0?feur(netNuitL):'—'}</td>
                  <td style={{fontWeight:700,color:'var(--bl)'}}>{pctPropL!=null?pctPropL+'%':'—'}</td>
                  <td style={{fontWeight:700,color:'var(--or)'}}>{pctConcL!=null?pctConcL+'%':'—'}</td>
                </tr>
              );})}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3}>Totaux {periodeLabel}</td>
                <td style={{fontWeight:700,color:'var(--ok)'}}>{feur(totVersements)}</td>
                <td style={{fontWeight:700,color:'var(--or)'}}>{feur(totPrest)}</td>
                <td style={{color:'var(--or)',fontWeight:700}}>{feur(totServices)}</td>
                <td style={{color:'var(--dg)'}}>{feur(totDebours)}</td>
                <td style={{fontWeight:700}}>{feur(totHT)}</td>
                <td style={{fontWeight:800,color:'var(--ok)'}}>{feur(totTTC)}</td>
                <td style={{fontWeight:700,color:netParNuit>=0?'var(--ok)':'var(--dg)'}}>{totNuitees>0?feur(netParNuit):'—'}</td>
                <td style={{fontWeight:700,color:'var(--bl)'}}>{pctProprio!=null?pctProprio+'%':'—'}</td>
                <td style={{fontWeight:700,color:'var(--or)'}}>{pctConcierge!=null?pctConcierge+'%':'—'}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div style={{fontSize:10.5,color:'var(--si)',marginBottom:14,lineHeight:1.6,padding:'0 4px'}}>
          <strong>€/nuit net</strong> : revenu propriétaire après déduction de nos frais TTC, par nuit. <strong>% prop.</strong> et <strong>% concierg.</strong> sont calculés sur ce que le locataire a payé hors taxe de séjour (versement OTA − taxe). Le % conciergerie porte sur notre revenu HT (la TVA collectée ne nous revient pas) ; l'écart entre les deux pourcentages et 100 % correspond à la TVA et aux frais OTA.
        </div>

        {/* Bloc solde net propriétaire */}
        <div style={{background:'var(--bg)',border:'1.5px solid var(--ls)',borderRadius:10,padding:'12px 16px',marginBottom:14}}>
          <div style={{fontWeight:700,fontSize:12,marginBottom:10}}>📊 Solde net propriétaire — {periodeLabel}</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8,fontSize:12}}>
            <div style={{background:'var(--wh)',borderRadius:8,padding:'8px 12px',textAlign:'center'}}>
              <div style={{fontSize:10,color:'var(--si)',marginBottom:2}}>Versé par l'OTA</div>
              <div style={{fontWeight:800,fontSize:16,color:'var(--ok)'}}>{feur(totVersements)}</div>
              <div style={{fontSize:10,color:'var(--si)'}}>directement au propriétaire</div>
            </div>
            <div style={{background:'var(--wh)',borderRadius:8,padding:'8px 12px',textAlign:'center'}}>
              <div style={{fontSize:10,color:'var(--si)',marginBottom:2}}>Frais de services TTC</div>
              <div style={{fontWeight:800,fontSize:16,color:'var(--dg)'}}>− {feur(totTTC)}</div>
              <div style={{fontSize:10,color:'var(--si)'}}>à régler à La Conciergerie</div>
            </div>
            <div style={{background:soldeNet>=0?'#e1f7ee':'#fde8e8',border:`1.5px solid ${soldeNet>=0?'var(--mn)':'var(--dg)'}`,borderRadius:8,padding:'8px 12px',textAlign:'center'}}>
              <div style={{fontSize:10,color:'var(--si)',marginBottom:2}}>Revenu net locatif</div>
              <div style={{fontWeight:800,fontSize:16,color:soldeNet>=0?'var(--ok)':'var(--dg)'}}>{feur(soldeNet)}</div>
              <div style={{fontSize:10,color:'var(--si)'}}>après déduction des frais</div>
            </div>
          </div>
        </div>

        {/* Bloc copier pour Legalstart */}
        <div style={{background:'#fff4d6',border:'1.5px solid var(--ye)',borderRadius:10,padding:'12px 16px'}}>
          <div style={{fontWeight:700,fontSize:12,marginBottom:8}}>📋 Lignes à saisir dans Legalstart</div>
          <div style={{display:'flex',flexDirection:'column',gap:4,fontFamily:'monospace',fontSize:11,background:'var(--wh)',borderRadius:7,padding:'10px 12px',color:'var(--ink)',lineHeight:1.8}}>
            {lignes.map(({s,bien,calc})=>(<Fragment key={s.id}>
              <div style={{fontWeight:700,color:'var(--or)',marginTop:6}}>— Séjour du {s.dateArrivee} au {s.dateDepart}{s.nomLocataire?` · ${s.nomLocataire}`:''} —</div>
              {calc.menageBase>0&&<div>  {bien.name} ménage · 1 unité · {feur(calc.menageBase)} HT · TVA 20%</div>}
              {calc.majUrgent>0&&<div style={{color:'var(--or)'}}>  Majoration urgent · 1 unité · {feur(calc.majUrgent)} HT · TVA 20%</div>}
              {calc.majDimanche>0&&<div style={{color:'var(--or)'}}>  Majoration dimanche/férié · 1 unité · {feur(calc.majDimanche)} HT · TVA 20%</div>}
              {calc.checkin>0&&<div>  Check-in · 1 unité · {feur(calc.checkin)} HT · TVA 20%</div>}
              {calc.checkout>0&&<div>  Check-out · 1 unité · {feur(calc.checkout)} HT · TVA 20%</div>}
              {calc.linge2p>0&&<div>  Location linge parure 2 pers. · {s.parures2p} unités · {feur(Number(bien.tarifLinge2p))} HT · TVA 20%</div>}
              {calc.linge1p>0&&<div>  Location linge parure 1 pers. · {s.parures1p} unités · {feur(Number(bien.tarifLinge1p))} HT · TVA 20%</div>}
              {calc.kit>0&&<div>  Kit accueil / Pack bienvenue · 1 unité · {feur(calc.kit)} HT · TVA 20%</div>}
              {calc.fraisServices>0&&<div style={{color:'var(--or)',fontWeight:600}}>  Commission de service · 1 unité · {feur(calc.fraisServices)} HT · TVA 20%</div>}
              {calc.remiseProprio>0&&<div style={{color:'var(--ok)',fontWeight:600}}>  {calc.remiseLabel||'Remise fidélité'} · 1 unité · −{feur(calc.remiseProprio)} HT · TVA 20%</div>}
              {(s.prestationsSupp||[]).filter(p=>p.label&&p.montant).map((p,i)=><div key={i} style={{color:'#0369a1'}}>  {p.label} · 1 unité · {feur(Number(p.montant))} HT · TVA 20%</div>)}
              {(s.debours||[]).filter(d=>d.label&&d.montant).map((d,i)=><div key={i} style={{color:'var(--dg)'}}>  {d.label} · 1 unité · {feur(Number(d.montant))} · Hors champ TVA</div>)}
            </Fragment>))}
          </div>
        </div>
      </div>);
    })}
  </div>);
}

// ── Reçu de séjour locataire (HTML Blob download) ──
async function genererRecuLocataire(s, bien, clients) {
  if(!s||!bien){alert('Données manquantes.');return;}
  if(s.aReprendre){
    if(!window.confirm('⚠️ Ce séjour est marqué « À revalider » — des informations ne sont pas encore définitives (ex : frais OTA).\n\nLe reçu portera la mention PROVISOIRE.\n\nGénérer quand même ?')) return;
  }
  const proprio = (clients||[]).find(c=>c.id===s.cid)||null;
  const calc = calcSejour(s,bien);
  const {PDFDocument,StandardFonts,rgb} = window.PDFLib;
  const fmt = d=>{if(!d)return'—';const p=d.split('-');return p[2]+'/'+p[1]+'/'+p[0];};
  const san = s=>(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^\x20-\x7E]/g,' ');
  const eur = n=>Number(n||0).toFixed(2).replace('.',',')+' EUR';
  const r2  = n=>Math.round(n*100)/100;

  const pdf  = await PDFDocument.create();
  const font = await pdf.embedFont(StandardFonts.Helvetica);
  const bold = await pdf.embedFont(StandardFonts.HelveticaBold);

  const ACCENT=rgb(0.20,0.35,0.55), NOIR=rgb(0.16,0.145,0.125), GRIS=rgb(0.45,0.40,0.36), CLAIR=rgb(0.96,0.97,0.99);
  const M=50, PW=595, PH=842;
  let page=pdf.addPage([PW,PH]); let y=PH-50;
  const RW=PW-M*2;

  const txt =(str,x,yy,f=font,sz=9,c=NOIR)=>page.drawText(san(str),{x,y:yy,size:sz,font:f,color:c});
  const txtR=(str,xR,yy,f=font,sz=9,c=NOIR)=>{const s2=san(str);page.drawText(s2,{x:xR-f.widthOfTextAtSize(s2,sz),y:yy,size:sz,font:f,color:c});};
  const line=(x1,yy,x2,c=rgb(0.85,0.87,0.90),w=0.5)=>page.drawLine({start:{x:x1,y:yy},end:{x:x2,y:yy},thickness:w,color:c});

  // ── FILIGRANE PROVISOIRE (si séjour à revalider) ──────────────────────
  if(s.aReprendre){
    page.drawText('PROVISOIRE',{x:90,y:430,size:70,font:bold,color:rgb(0.95,0.85,0.85),rotate:window.PDFLib.degrees(45)});
  }

  // ── BANDEAU TITRE ─────────────────────────────────────────────────────
  page.drawRectangle({x:0,y:y-8,width:PW,height:58,color:ACCENT});
  page.drawText(san('RECU DE SEJOUR'),{x:M,y:y+18,size:22,font:bold,color:rgb(1,1,1)});
  const numRecu='R'+(s.dateArrivee||'').replace(/-/g,'')+'-'+String(s.id||'').slice(-4).toUpperCase();
  page.drawText(san('N° '+numRecu),{x:M,y:y+2,size:9,font,color:rgb(0.85,0.88,0.93)});
  // Date d'émission à droite dans le bandeau
  const dEmis=fmt(new Date().toISOString().split('T')[0]);
  page.drawText(san('Emis le '+dEmis),{x:PW-M-110,y:y+2,size:9,font,color:rgb(0.85,0.88,0.93)});
  y-=46;

  // ── BAILLEUR / LOCATAIRE ──────────────────────────────────────────────
  let yTop=y;
  // Gauche : bailleur
  txt('BAILLEUR',M,yTop,bold,8,ACCENT); yTop-=14;
  const propNom=proprio?proprio.name:'Propriétaire';
  txt(propNom,M,yTop,bold,11,NOIR); yTop-=12;
  let yL=yTop;
  if(proprio?.addr){txt(proprio.addr,M,yL,font,8.5,GRIS);yL-=11;}
  if(proprio?.cp||proprio?.ville){txt(((proprio.cp||'')+' '+(proprio.ville||'')).trim(),M,yL,font,8.5,GRIS);yL-=11;}
  if(proprio?.email){txt(proprio.email,M,yL,font,8.5,GRIS);yL-=11;}
  if(proprio?.phone){txt(proprio.phone,M,yL,font,8.5,GRIS);yL-=11;}

  // Droite : locataire
  let yR=y;
  const colR=M+RW/2+10;
  txt('LOCATAIRE',colR,yR,bold,8,ACCENT); yR-=14;
  const nomLoc=s.nomLocataire||'Locataire';
  const natLoc=s.nationalite?(' ('+s.nationalite+')'):'';
  txt(nomLoc+natLoc,colR,yR,bold,11,NOIR); yR-=12;

  y=Math.min(yL,yR)-10;
  line(M,y,PW-M,rgb(0.85,0.87,0.90),0.8); y-=22;

  // ── INFOS SÉJOUR (encadré) ────────────────────────────────────────────
  const nuits=Number(s.nuitees||0);
  const prixNuit=calc.prixNuitee>0?eur(r2(calc.prixNuitee)):'—';
  const boxH=70;
  page.drawRectangle({x:M,y:y-boxH+14,width:RW,height:boxH,color:CLAIR,borderColor:rgb(0.85,0.87,0.90),borderWidth:0.5});
  let yb=y;
  txt('LOGEMENT',M+14,yb,font,7.5,GRIS);
  txt(bien.name,M+14,yb-12,bold,11,NOIR);
  yb-=34;
  const infos=[['Arrivee',fmt(s.dateArrivee)],['Depart',fmt(s.dateDepart)],['Duree',nuits+' nuit'+(nuits>1?'s':'')],['Prix / nuit',prixNuit]];
  const iw=RW/4;
  infos.forEach((it,i)=>{
    const xx=M+14+i*iw;
    txt(it[0].toUpperCase(),xx,yb,font,7.5,GRIS);
    txt(it[1],xx,yb-12,bold,9.5,NOIR);
  });
  y-=boxH+18;

  // ── TABLEAU DÉTAIL ────────────────────────────────────────────────────
  // En-tête tableau
  page.drawRectangle({x:M,y:y-3,width:RW,height:16,color:ACCENT});
  txt('DESIGNATION',M+10,y+1,bold,8,rgb(1,1,1));
  txtR('MONTANT',M+RW-10,y+1,bold,8,rgb(1,1,1));
  y-=20;

  const versOTA   =Number(s.versementOTA||0);
  const taxe      =Number(s.taxeSejour||0);
  const menageLoc =Number(s.fraisMenageLocataire||0);

  const addRow=(label,montant,zebra)=>{
    if(zebra)page.drawRectangle({x:M,y:y-4,width:RW,height:15,color:rgb(0.975,0.978,0.985)});
    txt(label,M+10,y,font,9,NOIR);
    txtR(eur(r2(montant)),M+RW-10,y,font,9,NOIR);
    y-=16;
  };

  let z=0;
  addRow('Hebergement ('+nuits+' nuit'+(nuits>1?'s':'')+')',versOTA,z++%2);
  if(menageLoc>0)addRow('Frais de menage de fin de sejour',menageLoc,z++%2);
  if(taxe>0)addRow('Taxe de sejour'+(s.taxeCollecteeParOTA?'':' (reglee a l arrivee)'),taxe,z++%2);

  y-=2;
  line(M,y,PW-M,rgb(0.85,0.87,0.90),0.8); y-=6;

  // Total
  const totalLoc=r2(versOTA+(s.taxeCollecteeParOTA?0:taxe)+menageLoc);
  page.drawRectangle({x:M+RW-230,y:y-22,width:230,height:24,color:ACCENT});
  txt('TOTAL VERSE',M+RW-220,y-14,bold,10,rgb(1,1,1));
  txtR(eur(totalLoc),M+RW-12,y-14,bold,11,rgb(1,1,1));
  y-=44;

  // ── MENTION DISCRÈTE ─────────────────────────────────────────────────
  txt(san('Recu remis a titre de justificatif de paiement pour le sejour mentionne ci-dessus.'),M,y,font,8,GRIS);
  y-=12;
  if(taxe>0)txt(san('La taxe de sejour est reversee a la collectivite.'),M,y,font,8,GRIS);

  pdf.setTitle(san('Recu de sejour - '+nomLoc+' - '+bien.name));
  const bytes=await pdf.save();
  const blob=new Blob([bytes],{type:'application/pdf'});
  const url=URL.createObjectURL(blob);
  const a=document.createElement('a');
  a.href=url;
  a.download='recu-sejour-'+(s.dateArrivee||'')+'_'+san(bien.name||'bien').replace(/\s+/g,'_')+'.pdf';
  document.body.appendChild(a);a.click();document.body.removeChild(a);
  setTimeout(()=>URL.revokeObjectURL(url),2000);
}

// ── Récapitulatif annuel propriétaire ──

// ── Export PDF du récap annuel (HTML + impression navigateur) ──
function exportRecapPDF({annee,parMois,totaux,MOIS_LONG,clientNom}){
  const eur=n=>n!=null&&n!==0?Number(n).toFixed(2).replace('.',',')+' €':'—';
  const moy=(v,n)=>n>0?eur(v/n):'—';
  let rows='';
  parMois.forEach(m=>{
    const dim=m.nbSejours===0?'opacity:0.45;':'';
    rows+='<tr style="'+dim+'">'
      +'<td class="mois"><b>'+MOIS_LONG[m.mois]+'</b></td>'
      +'<td class="c">'+(m.nbSejours||'—')+'</td>'
      +'<td class="c">'+(m.nuitees||'—')+'</td>'
      +'<td class="n">'+moy(m.versements,m.nuitees)+'</td>'
      +'<td class="n ok">'+eur(m.versements)+'</td>'
      +'<td class="n dg">'+eur(m.fraisOTA)+'</td>'
      +'<td class="n">'+eur(m.taxeSejour)+'</td>'
      +'<td class="n or">'+eur(m.fraisServices)+'</td>'
      +'<td class="n">'+eur(m.prestations)+'</td>'
      +'<td class="n"><b>'+eur(m.totalFacture)+'</b></td>'
      +'<td class="n"><b style="color:'+(m.marge>=0?'#15a34a':'#dc2626')+'">'+(m.nbSejours>0?eur(m.marge):'—')+'</b></td>'
      +'</tr>';
  });
  const totSej=parMois.reduce((s,m)=>s+m.nbSejours,0);
  const css='*{box-sizing:border-box;margin:0;padding:0;}'
    +'body{font-family:Arial,sans-serif;font-size:10px;color:#2a2520;padding:20px 24px;}'
    +'@page{size:A4 landscape;margin:10mm 12mm;}'
    +'.header{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid #FF8617;padding-bottom:8px;margin-bottom:14px;}'
    +'.logo{font-size:20px;font-weight:bold;color:#FF8617;}'
    +'.sub{font-size:9px;color:#6b5d52;margin-top:2px;}'
    +'.titre{font-size:15px;font-weight:bold;}'
    +'.titre span{color:#FF8617;}'
    +'table{width:100%;border-collapse:collapse;}'
    +'th{background:#2a2520;color:#fff;font-size:8px;text-transform:uppercase;letter-spacing:.04em;padding:6px 5px;text-align:left;}'
    +'th.c,th.n{text-align:right;}'
    +'td{padding:5px;border-bottom:1px solid #f0e8de;font-size:9.5px;}'
    +'td.c{text-align:center;}td.n{text-align:right;}'
    +'td.ok{color:#15a34a;font-weight:600;}td.dg{color:#dc2626;}td.or{color:#FF8617;font-weight:600;}'
    +'tfoot td{border-top:2px solid #2a2520;background:#fdf6ee;font-weight:bold;padding:7px 5px;}'
    +'.foot{margin-top:14px;font-size:7.5px;color:#6b5d52;text-align:center;}';
  const html='<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Recap annuel '+annee+'</title><style>'+css+'</style></head><body>'
    +'<div class="header"><div><div class="logo">LA CONCIERGERIE</div><div class="sub">Recapitulatif annuel des prestations</div></div>'
    +'<div style="text-align:right"><div class="titre">Recap <span>'+annee+'</span></div><div class="sub">'+clientNom+'</div></div></div>'
    +'<table><thead><tr>'
    +'<th>Mois</th><th class="c">Sejours</th><th class="c">Nuitees</th><th class="n">Moy./nuit</th>'
    +'<th class="n">Versements OTA</th><th class="n">Frais OTA</th><th class="n">Taxe sejour</th>'
    +'<th class="n">Frais services TTC</th><th class="n">Prestations TTC</th><th class="n">Facture TTC</th><th class="n">Marge proprietaire</th>'
    +'</tr></thead><tbody>'+rows+'</tbody>'
    +'<tfoot><tr>'
    +'<td><b>Total '+annee+'</b></td>'
    +'<td class="c">'+totSej+'</td>'
    +'<td class="c">'+totaux.nuitees+'</td>'
    +'<td class="n">'+moy(totaux.versements,totaux.nuitees)+'</td>'
    +'<td class="n" style="color:#15a34a">'+eur(totaux.versements)+'</td>'
    +'<td class="n" style="color:#dc2626">'+eur(totaux.fraisOTA)+'</td>'
    +'<td class="n">'+eur(totaux.taxeSejour)+'</td>'
    +'<td class="n" style="color:#FF8617">'+eur(totaux.fraisServices)+'</td>'
    +'<td class="n">'+eur(totaux.prestations)+'</td>'
    +'<td class="n">'+eur(totaux.totalFacture)+'</td>'
    +'<td class="n" style="color:'+(totaux.marge>=0?'#15a34a':'#dc2626')+'">'+eur(totaux.marge)+'</td>'
    +'</tr></tfoot></table>'
    +'<div class="foot">LA CONCIERGERIE | SARL au capital de 100,00 EUR | N SIREN 943.325.951 | N de TVA FR52943325951 | Edite le '+new Date().toLocaleDateString('fr-FR')+'</div>'
    +'</body></html>';
  const w=window.open('','_blank');
  if(!w){alert('Veuillez autoriser les pop-ups pour exporter le PDF.');return;}
  w.document.write(html);
  w.document.close();
  setTimeout(()=>{w.print();},400);
}


function RecapAnnuel({sejours,biens,clients,clientId}){
  const now2=new Date();
  const[annee,setAnnee]=useState(now2.getFullYear());
  const[selClient,setSelClient]=useState(clientId||'all');
  const MOIS_LONG=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  const effClient=clientId||selClient;
  const myBiens=effClient&&effClient!=='all'?biens.filter(b=>b.cid===effClient):biens;

  const parMois=useMemo(()=>{
    return Array.from({length:12},(_,m)=>{
      const msejours=sejours.filter(s=>{
        const ref=s.dateDepart||s.dateArrivee;
        if(!ref)return false;
        const d=new Date(ref);
        return d.getMonth()===m&&d.getFullYear()===annee&&myBiens.some(mb=>mb.id===s.bid);
      });
      const nuitees=msejours.reduce((s,x)=>s+Number(x.nuitees||0),0);
      const versements=msejours.reduce((s,x)=>s+Number(x.versementProprio||0),0);
      const fraisOTA=msejours.reduce((s,x)=>s+Number(x.fraisOTA||0),0);
      const taxeSejour=msejours.reduce((s,x)=>s+Number(x.taxeSejour||0),0);
      const calcAll=msejours.map(s=>{const b=biens.find(x=>x.id===s.bid);const c=(clients||[]).find(x=>x.id===s.cid);return b?calcSejour(s,b,c):{totalPrestations:0,fraisServices:0,fraisServicesNet:0,remiseProprio:0,totalHT:0,totalTTC:0};});
      const prestations=calcAll.reduce((s,c)=>s+c.totalPrestations,0);
      const fraisServices=calcAll.reduce((s,c)=>s+c.fraisServices,0);
      const totalRemises=calcAll.reduce((s,c)=>s+c.remiseProprio,0);
      const totalFacture=calcAll.reduce((s,c)=>s+c.totalTTC,0);
      const marge=versements-totalFacture;
      return{mois:m,nbSejours:msejours.length,nuitees,versements,fraisOTA,taxeSejour,prestations,fraisServices,totalRemises,totalFacture,marge};
    });
  },[sejours,biens,clients,annee,myBiens]);

  const totaux=parMois.reduce((acc,m)=>({
    nuitees:acc.nuitees+m.nuitees,versements:acc.versements+m.versements,
    fraisOTA:acc.fraisOTA+m.fraisOTA,taxeSejour:acc.taxeSejour+m.taxeSejour,
    prestations:acc.prestations+m.prestations,fraisServices:acc.fraisServices+m.fraisServices,
    totalFacture:acc.totalFacture+m.totalFacture,marge:acc.marge+m.marge,
  }),{nuitees:0,versements:0,fraisOTA:0,taxeSejour:0,prestations:0,fraisServices:0,totalFacture:0,marge:0});

  return(<div>
    <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:16,flexWrap:'wrap'}}>
      <button onClick={()=>setAnnee(a=>a-1)} className="wn">‹</button>
      <button onClick={()=>setAnnee(a=>a+1)} className="wn">›</button>
      <div className="D" style={{fontSize:20}}>{annee}</div>
      {!clientId&&<select value={selClient} onChange={e=>setSelClient(e.target.value)} style={{width:'auto',minWidth:180,fontSize:13}}>
        <option value="all">Tous les propriétaires</option>
        {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
      </select>}
      <button onClick={()=>exportRecapPDF({annee,parMois,totaux,MOIS_LONG,clientNom:(effClient&&effClient!=='all'?(clients.find(c=>c.id===effClient)||{}).name:'Tous les propriétaires')})} className="btn bgh sm" style={{marginLeft:'auto'}} title="Exporter le tableau en PDF">📄 Export PDF</button>
    </div>
    {/* KPIs annuels */}
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:10,marginBottom:20}}>
      {[{l:'Nuitées',v:totaux.nuitees,e:'🌙',c:'var(--bl)'},{l:'Versements OTA',v:feur(totaux.versements),e:'💶',c:'var(--ok)'},{l:'Frais OTA',v:feur(totaux.fraisOTA),e:'📤',c:'var(--dg)'},{l:'Prestations TTC',v:feur(totaux.prestations),e:'🧹',c:'var(--or)'},{l:'Frais de services TTC',v:feur(totaux.fraisServices),e:'%',c:'var(--or)'},{l:'Total facturé TTC',v:feur(totaux.totalFacture),e:'🧾',c:'var(--pk)'},{l:'Revenu net propriétaire',v:feur(totaux.marge),e:'📈',c:totaux.marge>=0?'var(--ok)':'var(--dg)'}].map((k,i)=>(
        <div key={i} className="scard" style={{borderTop:`3px solid ${k.c}`,padding:'12px 14px'}}>
          <div style={{fontSize:18,marginBottom:4}}>{k.e}</div>
          <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)',marginBottom:2}}>{k.l}</div>
          <div className="D" style={{fontSize:18,color:k.c}}>{k.v}</div>
        </div>
      ))}
    </div>
    <div style={{overflowX:'auto'}}>
      <table className="tbl">
        <thead><tr><th>Mois</th><th>Séjours</th><th>Nuitées</th><th>Moy./nuit</th><th>Versements OTA</th><th>Frais OTA</th><th>Taxe séjour</th><th>Frais services TTC</th><th>Prestations TTC</th><th>Facturé TTC</th><th>Marge propriétaire</th></tr></thead>
        <tbody>
          {parMois.map(m=>(
            <tr key={m.mois} style={{opacity:m.nbSejours===0?0.4:1}}>
              <td><strong>{MOIS_LONG[m.mois]}</strong></td>
              <td style={{textAlign:'center'}}>{m.nbSejours||'—'}</td>
              <td style={{textAlign:'center'}}>{m.nuitees||'—'}</td>
              <td>{m.nuitees>0?feur(m.versements/m.nuitees):'—'}</td>
              <td style={{color:'var(--ok)',fontWeight:600}}>{m.versements>0?feur(m.versements):'—'}</td>
              <td style={{color:'var(--dg)'}}>{m.fraisOTA>0?feur(m.fraisOTA):'—'}</td>
              <td>{m.taxeSejour>0?feur(m.taxeSejour):'—'}</td>
              <td style={{color:'var(--or)',fontWeight:600}}>{m.fraisServices>0?feur(m.fraisServices):'—'}</td>
              <td>{m.prestations>0?feur(m.prestations):'—'}</td>
              <td style={{fontWeight:700}}>{m.totalFacture>0?feur(m.totalFacture):'—'}</td>
              <td style={{fontWeight:700,color:m.marge>=0?'var(--ok)':'var(--dg)'}}>{m.nbSejours>0?feur(m.marge):'—'}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td><strong>Total {annee}</strong></td>
            <td style={{textAlign:'center'}}>{parMois.reduce((s,m)=>s+m.nbSejours,0)}</td>
            <td style={{textAlign:'center'}}>{totaux.nuitees}</td>
            <td>{totaux.nuitees>0?feur(totaux.versements/totaux.nuitees):'—'}</td>
            <td style={{color:'var(--ok)',fontWeight:700}}>{feur(totaux.versements)}</td>
            <td style={{color:'var(--dg)'}}>{feur(totaux.fraisOTA)}</td>
            <td>{feur(totaux.taxeSejour)}</td>
            <td style={{color:'var(--or)',fontWeight:700}}>{feur(totaux.fraisServices)}</td>
            <td style={{fontWeight:700}}>{feur(totaux.prestations)}</td>
            <td style={{fontWeight:800}}>{feur(totaux.totalFacture)}</td>
            <td style={{fontWeight:800,color:totaux.marge>=0?'var(--ok)':'var(--dg)'}}>{feur(totaux.marge)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>);
}

// ── Justificatifs d'une facture (relevés OTA, pièces comptables) ──
// mode='admin' : permet le dépôt (upload) + l'ouverture. mode='client' : lecture seule.
// onChange(newJustifs) remonte la nouvelle liste au parent (admin uniquement).
function JustifsFacture({facture,mode,onChange}){
  const justifs=facture.justifs||[];
  const[uploading,setUploading]=useState(false);
  const[opening,setOpening]=useState(null);
  const annee=facture.periode?.annee||new Date(facture.dateCreation||Date.now()).getFullYear();

  const ouvrir=async j=>{
    setOpening(j.id);
    try{
      const url=await getSignedFactureUrl(j.path);
      window.open(url,'_blank','noopener');
    }catch(e){alert('Impossible d\'ouvrir le justificatif : '+e.message);}
    setOpening(null);
  };

  const onPick=async e=>{
    const files=Array.from(e.target.files||[]);
    e.target.value='';
    if(!files.length)return;
    const noms=files.map(f=>f.name).join('\n• ');
    if(!window.confirm(`Déposer ${files.length} justificatif(s) sur la facture ${facture.numeroDefinitif||facture.numeroBrouillon} ?\n\n• ${noms}\n\nCes fichiers seront visibles par le propriétaire.`))return;
    setUploading(true);
    const ajouts=[];
    for(const file of files){
      try{
        const path=await uploadFileToFacturesBucket(file,facture.cid,annee);
        ajouts.push({id:'j'+Date.now()+Math.random().toString(36).slice(2,6),nom:file.name,path,ct:file.type||'',dateUpload:new Date().toISOString()});
      }catch(err){alert('Échec dépôt « '+file.name+' » : '+err.message);}
    }
    setUploading(false);
    if(ajouts.length&&typeof onChange==='function')onChange([...justifs,...ajouts]);
  };

  // Retrait logique : on enlève le justificatif de la liste de la facture.
  // Le fichier reste dans le Storage (pas de suppression physique), mais devient invisible.
  const retirer=j=>{
    if(!window.confirm(`Retirer le justificatif « ${j.nom} » de cette facture ?\n\nIl ne sera plus visible (ni par vous, ni par le propriétaire).`))return;
    if(typeof onChange==='function')onChange(justifs.filter(x=>x.id!==j.id));
  };

  return(<div style={{marginTop:8,paddingTop:8,borderTop:'1px dashed var(--bd,#e5e5e5)',width:'100%'}}>
    <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap',marginBottom:justifs.length?6:0}}>
      <span style={{fontSize:11,fontWeight:700,color:'var(--si)',textTransform:'uppercase',letterSpacing:'.04em'}}>📎 Justificatifs{justifs.length>0&&` (${justifs.length})`}</span>
      {mode==='admin'&&(
        <label className="btn bgh sm" style={{cursor:uploading?'wait':'pointer',margin:0,fontSize:12,opacity:uploading?.6:1}}>
          {uploading?'Dépôt en cours…':'➕ Déposer'}
          <input type="file" multiple accept="application/pdf,image/*" onChange={onPick} disabled={uploading} style={{display:'none'}}/>
        </label>
      )}
    </div>
    {justifs.length===0?(
      mode==='admin'
        ? <div style={{fontSize:11,color:'var(--si)'}}>Aucun justificatif déposé (relevés OTA, pièces comptables…).</div>
        : null
    ):(
      <div style={{display:'flex',flexDirection:'column',gap:4}}>
        {justifs.map(j=>(
          <div key={j.id} style={{display:'flex',alignItems:'center',gap:8,fontSize:12,background:'var(--bg,#f7f7f7)',borderRadius:7,padding:'5px 9px'}}>
            <span>{(j.ct||'').includes('pdf')?'📄':(j.ct||'').includes('image')?'🖼️':'📎'}</span>
            <span style={{flex:1,minWidth:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={j.nom}>{j.nom}</span>
            <button onClick={()=>ouvrir(j)} disabled={opening===j.id} className="btn bor sm" style={{fontSize:11,padding:'3px 9px'}}>
              {opening===j.id?'Ouverture…':'👁 Voir'}
            </button>
            {mode==='admin'&&(
              <button onClick={()=>retirer(j)} className="btn bgh sm" style={{fontSize:11,padding:'3px 9px',color:'var(--dg)'}} title="Retirer ce justificatif">🗑</button>
            )}
          </div>
        ))}
      </div>
    )}
  </div>);
}

// ── Avoir rattaché à une facture (correction partielle après émission) ──
// mode='admin' : saisie/modification de l'avoir. mode='client' : lecture seule.
// onChange(avoir|null) remonte l'avoir au parent (admin uniquement).
function AvoirFacture({facture,mode,onChange}){
  const avoir=facture.avoir||null;
  const[edit,setEdit]=useState(false);
  const[num,setNum]=useState(avoir?.numero||'');
  const[montant,setMontant]=useState(avoir?.montantHT!=null?String(avoir.montantHT):'');
  const[motif,setMotif]=useState(avoir?.motif||'');

  const tva=v=>Math.round(Number(v||0)*0.2*100)/100;
  const ttc=v=>Math.round(Number(v||0)*1.2*100)/100;
  const fe=n=>(Math.round(Number(n||0)*100)/100).toFixed(2).replace('.',',')+' €';

  const enregistrer=()=>{
    if(!num.trim()){alert('Indiquez le numéro de l\'avoir (Pennylane).');return;}
    const m=Number(montant);
    if(!m||m<=0){alert('Indiquez un montant HT positif pour l\'avoir.');return;}
    if(typeof onChange==='function')onChange({numero:num.trim(),montantHT:m,motif:motif.trim(),dateSaisie:new Date().toISOString()});
    setEdit(false);
  };
  const supprimer=()=>{
    if(!window.confirm('Retirer l\'avoir enregistré sur cette facture ?'))return;
    if(typeof onChange==='function')onChange(null);
    setEdit(false);
  };

  // Côté propriétaire : on n'affiche que s'il y a un avoir
  if(mode==='client'&&!avoir)return null;

  return(<div style={{marginTop:8,paddingTop:8,borderTop:'1px dashed var(--bd,#e5e5e5)',width:'100%'}}>
    <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap',marginBottom:avoir?6:0}}>
      <span style={{fontSize:11,fontWeight:700,color:'#0369a1',textTransform:'uppercase',letterSpacing:'.04em'}}>↩️ Avoir</span>
      {mode==='admin'&&!edit&&(
        <button onClick={()=>{setNum(avoir?.numero||'');setMontant(avoir?.montantHT!=null?String(avoir.montantHT):'');setMotif(avoir?.motif||'');setEdit(true);}} className="btn bgh sm" style={{fontSize:12}}>
          {avoir?'✏️ Modifier':'➕ Enregistrer un avoir'}
        </button>
      )}
    </div>

    {edit?(
      <div style={{display:'flex',flexDirection:'column',gap:8,background:'#f0f7ff',borderRadius:8,padding:'10px 12px'}}>
        <div style={{fontSize:11,color:'var(--si)'}}>Avoir partiel émis dans Pennylane. Saisissez son numéro, son montant <b>HT</b> et le motif. Le TTC sera calculé automatiquement (TVA 20%).</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 130px',gap:8}}>
          <div><label className="fl">N° de l'avoir (Pennylane)</label>
            <input type="text" value={num} onChange={e=>setNum(e.target.value)} placeholder="ex: AV-2026-001"/></div>
          <div><label className="fl">Montant HT (€)</label>
            <input type="number" step="0.01" min="0" value={montant} onChange={e=>setMontant(e.target.value)} placeholder="25.03"/></div>
        </div>
        <div><label className="fl">Motif</label>
          <input type="text" value={motif} onChange={e=>setMotif(e.target.value)} placeholder="ex: Réclamation client Booking — commission recalculée"/></div>
        {Number(montant)>0&&<div style={{fontSize:11,color:'#0369a1'}}>TTC : <b>{fe(ttc(montant))}</b> (dont {fe(tva(montant))} TVA)</div>}
        <div style={{display:'flex',gap:6}}>
          <button onClick={enregistrer} className="btn bmn sm">✓ Enregistrer</button>
          <button onClick={()=>setEdit(false)} className="btn bgh sm">Annuler</button>
          {avoir&&<button onClick={supprimer} className="btn bgh sm" style={{color:'var(--dg)',marginLeft:'auto'}}>🗑 Retirer l'avoir</button>}
        </div>
      </div>
    ):(
      avoir&&(
        <div style={{fontSize:12,background:'#f0f7ff',borderRadius:7,padding:'7px 10px',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
          <span style={{fontWeight:700,color:'#0369a1'}}>{avoir.numero}</span>
          <span>− {fe(avoir.montantHT)} HT <span style={{color:'var(--si)'}}>({fe(ttc(avoir.montantHT))} TTC)</span></span>
          {avoir.motif&&<span style={{color:'var(--si)'}}>· {avoir.motif}</span>}
        </div>
      )
    )}
  </div>);
}


// ── Modal de relance d'une facture impayée ──
// Mêmes destinataires que EnvoiFactureModal, mais sujet "RELANCE", PDF re-généré,
// et champ note libre tracé dans f.relances [{ts, note, dest}].
function RelanceFactureModal({fac,client,fallbackLignes,onC,onSent,onDeleteRelance}){
  const principal=(client?.email||'').trim();
  const secondaires=(Array.isArray(client?.accesSecondaires)?client.accesSecondaires:[])
    .map(a=>({label:a.label||'Accès secondaire',email:(a.email||'').trim()}))
    .filter(a=>a.email);
  const[sel,setSel]=useState(()=>{
    const m={};
    if(principal)m[principal]=true;
    secondaires.forEach(a=>{m[a.email]=false;});
    return m;
  });
  const[extra,setExtra]=useState('');
  const[note,setNote]=useState('');
  const[politesse,setPolitesse]=useState(client?.name||'');
  const[signature,setSignature]=useState('La Conciergerie');
  const[sending,setSending]=useState(false);
  const[result,setResult]=useState(null);

  const toggle=em=>setSel(s=>({...s,[em]:!s[em]}));
  const destinataires=()=>{
    const list=Object.keys(sel).filter(em=>sel[em]);
    const ex=extra.trim().toLowerCase();
    if(ex&&/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(ex)&&!list.includes(ex))list.push(ex);
    return list;
  };
  const extraValide=()=>{const ex=extra.trim().toLowerCase();return!ex||/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(ex);};

  const envoyer=async()=>{
    const dest=destinataires();
    if(dest.length===0){alert('Sélectionnez au moins un destinataire.');return;}
    if(!window.confirm(`Envoyer la RELANCE pour la facture ${fac.numeroDefinitif||''} à :\n${dest.join('\n')}\n\nConfirmer ?`))return;
    setSending(true);setResult(null);
    try{
      // Re-générer le PDF et envoyer avec sujet RELANCE
      const pFichier=(fac.periodeLabel||'facture').replace(/\s+/g,'_').replace(/[^a-zA-Z0-9_\-]/g,'');
      let res;
      if(fac.profil==='prestations'){
        res=await generateFacturX({
          client,
          periodeLabel:fac.periodeLabel||'',
          periodeFichier:pFichier,
          periode:fac.periode||null,
          numeroOverride:fac.numeroDefinitif,
          gabarit:'prestations',
          sections:fac.sectionsPresta||[],
          titrePrefixe:fac.titrePrefixe||'Interventions ',
          returnBlob:true,
        });
      }else{
        const lignes=(fac.snapshotLignes&&fac.snapshotLignes.length)?fac.snapshotLignes:fallbackLignes;
        res=await generateFacturX({
          client,
          lignes,
          periodeLabel:fac.periodeLabel||'',
          periodeFichier:pFichier,
          periode:fac.periode||null,
          numeroOverride:fac.numeroDefinitif,
          returnBlob:true,
        });
      }
      if(!res||!res.bytes)throw new Error('PDF non généré.');
      const pdfBase64=bytesToBase64(res.bytes);
      const periode=fac.periodeLabel||'';
      const salut=(politesse||'').trim()||client?.name||'';
      const sig=(signature||'').trim()||'La Conciergerie';
      const subject=`RELANCE — Facture La Conciergerie${periode?(' — '+periode):''}${fac.numeroDefinitif?' ('+fac.numeroDefinitif+')':''}`;
      const htmlContent=
        '<div style="font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#2a2520;line-height:1.6;">'
        +`<p>Bonjour${salut?(' '+salut):''},</p>`
        +'<p>Sauf erreur de notre part, la facture ci-jointe reste en attente de règlement à ce jour.</p>'
        +(note.trim()?`<p style="background:#fff8e1;border-left:3px solid #f59e0b;padding:10px 14px;border-radius:6px;margin:14px 0;">${note.trim().replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>')}</p>`:'')
        +'<p>Vous trouverez à nouveau votre facture en pièce jointe. Pour toute question, vous pouvez répondre directement à cet email.</p>'
        +'<p style="margin:10px 0;"><a href="https://app.conciergerie-alsace.com" target="_blank" style="display:inline-block;background:#FF8617;color:#ffffff;text-decoration:none;font-weight:bold;padding:11px 22px;border-radius:10px;font-size:14px;">Accéder à mon espace</a></p>'
        +`<p style="margin-top:18px;">Bien cordialement,<br><strong>${sig.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</strong><br><span style="color:#6b5d52;font-size:12px;">Service de conciergerie — Colmar, Alsace</span></p>`
        +'</div>';
      const results=[];
      for(const toEmail of dest){
        const r=await fetch(`${SUPA_URL}/functions/v1/send-invoice-email`,{
          method:'POST',
          headers:{'Content-Type':'application/json','Authorization':`Bearer ${SUPA_TOKEN||SUPA_KEY}`,'apikey':SUPA_KEY},
          body:JSON.stringify({toEmail,toName:client?.name||'',subject,htmlContent,pdfBase64,pdfFilename:res.fileName,replyTo:'client@conciergerie-alsace.com'}),
        });
        const data=await r.json().catch(()=>({}));
        results.push({email:toEmail,ok:r.ok,error:r.ok?null:(data?.error||data?.details?.message||`HTTP ${r.status}`)});
      }
      setResult(results);
      const tousOk=results.every(r=>r.ok);
      if(tousOk&&typeof onSent==='function')onSent(dest,note.trim());
    }catch(e){
      setResult([{email:'—',ok:false,error:e.message}]);
    }finally{setSending(false);}
  };

  // Historique relances existantes
  const relances=Array.isArray(fac.relances)?fac.relances:[];

  return(<M onC={onC} title="🔔 Relancer la facture" col="#f59e0b" ch={
    <div style={{display:'flex',flexDirection:'column',gap:14}}>
      <div style={{fontSize:13,color:'var(--si)'}}>
        Facture <strong>{fac.numeroDefinitif}</strong> · {client?.name||'—'} · {fac.periodeLabel||'—'}
        <span style={{marginLeft:10,background:'#fff4d6',color:'#92400e',padding:'2px 8px',borderRadius:999,fontSize:11,fontWeight:700}}>📤 Émise · non réglée</span>
      </div>

      {relances.length>0&&(
        <div style={{background:'#fffbf0',border:'1px solid #fde68a',borderRadius:9,padding:'10px 13px'}}>
          <div style={{fontSize:11,fontWeight:700,color:'#92400e',marginBottom:6,textTransform:'uppercase',letterSpacing:'.06em'}}>Historique des relances</div>
          <div style={{display:'flex',flexDirection:'column',gap:5}}>
            {relances.map((r,i)=>(
              <div key={i} style={{fontSize:12,color:'var(--si)',display:'flex',alignItems:'flex-start',gap:6}}>
                <div style={{flex:1}}>
                  <span style={{fontWeight:600,color:'#92400e'}}>Relance {i+1}</span>
                  {' · '}{new Date(r.ts).toLocaleString('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}
                  {r.dest&&r.dest.length>0&&<span style={{color:'var(--si)'}}> → {r.dest.join(', ')}</span>}
                  {r.note&&<div style={{marginTop:2,fontStyle:'italic',color:'#6b5d52'}}>"{r.note}"</div>}
                </div>
                {typeof onDeleteRelance==='function'&&(
                  <button onClick={()=>{if(window.confirm(`Supprimer la relance ${i+1} du ${new Date(r.ts).toLocaleDateString('fr-FR')} ?`))onDeleteRelance(i);}} className="btn bgh sm" style={{fontSize:10,padding:'2px 6px',color:'#b91c1c',flexShrink:0}} title="Supprimer cette relance">🗑</button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {result?(
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {result.map((r,i)=>(
            <div key={i} style={{background:r.ok?'#e6f4ea':'#fde0e0',border:`1px solid ${r.ok?'#a7d7b8':'#f5b0b0'}`,borderRadius:9,padding:'9px 13px',fontSize:12.5,color:r.ok?'#1e5631':'#8a1010'}}>
              {r.ok?'✅':'⚠️'} {r.email}{!r.ok&&` — ${r.error}`}
            </div>
          ))}
          <button onClick={onC} className="btn bor" style={{justifyContent:'center',marginTop:4}}>Fermer</button>
        </div>
      ):(
        <>
          <div>
            <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)',marginBottom:8,fontWeight:700}}>Destinataires</div>
            <div style={{display:'flex',flexDirection:'column',gap:8}}>
              {principal&&(
                <label style={{display:'flex',alignItems:'center',gap:9,fontSize:13,cursor:'pointer',background:'var(--bg)',borderRadius:8,padding:'9px 11px'}}>
                  <input type="checkbox" checked={!!sel[principal]} onChange={()=>toggle(principal)} style={{width:16,height:16,cursor:'pointer'}}/>
                  <span><strong>Propriétaire</strong> · {principal}</span>
                </label>
              )}
              {!principal&&<div style={{fontSize:12,color:'#b45309',background:'#fef3c7',borderRadius:8,padding:'8px 11px'}}>⚠️ Aucun email principal renseigné pour ce propriétaire.</div>}
              {secondaires.map((a,i)=>(
                <label key={i} style={{display:'flex',alignItems:'center',gap:9,fontSize:13,cursor:'pointer',background:'var(--bg)',borderRadius:8,padding:'9px 11px'}}>
                  <input type="checkbox" checked={!!sel[a.email]} onChange={()=>toggle(a.email)} style={{width:16,height:16,cursor:'pointer'}}/>
                  <span><strong>{a.label}</strong> · {a.email}</span>
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="fl">Note personnalisée (optionnelle)</label>
            <textarea
              placeholder="Ex: N'hésitez pas à nous contacter si vous avez des questions sur cette facture."
              value={note}
              onChange={e=>setNote(e.target.value)}
              style={{width:'100%',minHeight:72,resize:'vertical',fontFamily:'inherit',fontSize:13}}
            />
            <div style={{fontSize:11,color:'var(--si)',marginTop:3}}>Apparaîtra dans l'email entre les paragraphes d'intro et de clôture. Tracée dans l'historique.</div>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
            <div>
              <label className="fl">Formule de politesse</label>
              <input type="text" placeholder="ex: Madame Martin" value={politesse} onChange={e=>setPolitesse(e.target.value)} style={{width:'100%'}}/>
            </div>
            <div>
              <label className="fl">Signature</label>
              <input type="text" placeholder="ex: Claire — La Conciergerie" value={signature} onChange={e=>setSignature(e.target.value)} style={{width:'100%'}}/>
            </div>
          </div>

          <div>
            <label className="fl">Ajouter une adresse ponctuelle (optionnel)</label>
            <input type="email" placeholder="ex: comptable@cabinet.fr" value={extra} onChange={e=>setExtra(e.target.value)} style={{width:'100%'}}/>
            {!extraValide()&&<div style={{fontSize:11,color:'#b91c1c',marginTop:4}}>Adresse email invalide.</div>}
          </div>

          <button onClick={envoyer} disabled={sending||!extraValide()} className="btn" style={{background:'#f59e0b',color:'#fff',fontWeight:700,justifyContent:'center',marginTop:4}}>
            {sending?'⏳ Envoi en cours…':'🔔 Envoyer la relance (avec PDF)'}
          </button>
        </>
      )}
    </div>
  }/>);
}

// ── Fenêtre d'envoi d'une facture par email (sélection des destinataires au cas par cas) ──
function EnvoiFactureModal({fac,client,fallbackLignes,onC,onSent}){
  // Destinataires candidats : email principal + accès secondaires.
  const principal=(client?.email||'').trim();
  const secondaires=(Array.isArray(client?.accesSecondaires)?client.accesSecondaires:[])
    .map(a=>({label:a.label||'Accès secondaire',email:(a.email||'').trim()}))
    .filter(a=>a.email);
  // État : map email -> coché. Principal coché par défaut.
  const[sel,setSel]=useState(()=>{
    const m={};
    if(principal)m[principal]=true;
    secondaires.forEach(a=>{m[a.email]=false;});
    return m;
  });
  const[extra,setExtra]=useState(''); // adresse ponctuelle ajoutée à la main
  const[politesse,setPolitesse]=useState(client?.name||''); // formule de politesse personnalisable
  const[signature,setSignature]=useState('La Conciergerie'); // signature personnalisable
  const[sending,setSending]=useState(false);
  const[result,setResult]=useState(null); // tableau de résultats après envoi

  const toggle=em=>setSel(s=>({...s,[em]:!s[em]}));

  const destinataires=()=>{
    const list=Object.keys(sel).filter(em=>sel[em]);
    const ex=extra.trim().toLowerCase();
    if(ex&&/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(ex)&&!list.includes(ex))list.push(ex);
    return list;
  };

  const envoyer=async()=>{
    const dest=destinataires();
    if(dest.length===0){alert('Sélectionnez au moins un destinataire.');return;}
    if(!window.confirm(`Envoyer la facture ${fac.numeroDefinitif||''} à :\n${dest.join('\n')}\n\nConfirmer ?`))return;
    setSending(true);setResult(null);
    try{
      const res=await envoyerFactureParEmail(fac,client,fallbackLignes,dest,client?.name||'',politesse,signature);
      setResult(res);
      const tousOk=res.every(r=>r.ok);
      if(tousOk&&typeof onSent==='function')onSent(dest);
    }catch(e){
      setResult([{email:'—',ok:false,error:e.message}]);
    }finally{setSending(false);}
  };

  const extraValide=()=>{const ex=extra.trim().toLowerCase();return!ex||/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(ex);};

  return(<M onC={onC} title="📧 Envoyer la facture" col="var(--pk)" ch={
    <div style={{display:'flex',flexDirection:'column',gap:14}}>
      <div style={{fontSize:13,color:'var(--si)'}}>
        Facture <strong>{fac.numeroDefinitif||fac.numeroBrouillon}</strong> · {client?.name||'—'} · {fac.periodeLabel||'—'}
      </div>

      {result?(
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {result.map((r,i)=>(
            <div key={i} style={{background:r.ok?'#e6f4ea':'#fde0e0',border:`1px solid ${r.ok?'#a7d7b8':'#f5b0b0'}`,borderRadius:9,padding:'9px 13px',fontSize:12.5,color:r.ok?'#1e5631':'#8a1010'}}>
              {r.ok?'✅':'⚠️'} {r.email}{!r.ok&&` — ${r.error}`}
            </div>
          ))}
          <button onClick={onC} className="btn bor" style={{justifyContent:'center',marginTop:4}}>Fermer</button>
        </div>
      ):(
        <>
          <div>
            <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)',marginBottom:8,fontWeight:700}}>Destinataires</div>
            <div style={{display:'flex',flexDirection:'column',gap:8}}>
              {principal&&(
                <label style={{display:'flex',alignItems:'center',gap:9,fontSize:13,cursor:'pointer',background:'var(--bg)',borderRadius:8,padding:'9px 11px'}}>
                  <input type="checkbox" checked={!!sel[principal]} onChange={()=>toggle(principal)} style={{width:16,height:16,cursor:'pointer'}}/>
                  <span><strong>Propriétaire</strong> · {principal}</span>
                </label>
              )}
              {!principal&&<div style={{fontSize:12,color:'#b45309',background:'#fef3c7',borderRadius:8,padding:'8px 11px'}}>⚠️ Aucun email principal renseigné pour ce propriétaire.</div>}
              {secondaires.map((a,i)=>(
                <label key={i} style={{display:'flex',alignItems:'center',gap:9,fontSize:13,cursor:'pointer',background:'var(--bg)',borderRadius:8,padding:'9px 11px'}}>
                  <input type="checkbox" checked={!!sel[a.email]} onChange={()=>toggle(a.email)} style={{width:16,height:16,cursor:'pointer'}}/>
                  <span><strong>{a.label}</strong> · {a.email}</span>
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="fl">Formule de politesse</label>
            <input type="text" placeholder="ex: Madame Martin" value={politesse} onChange={e=>setPolitesse(e.target.value)} style={{width:'100%'}}/>
            <div style={{fontSize:11,color:'var(--si)',marginTop:4}}>Le mail commencera par : « Bonjour {(politesse||'').trim()||'…'}, »</div>
          </div>

          <div>
            <label className="fl">Signature</label>
            <input type="text" placeholder="ex: Claire — La Conciergerie" value={signature} onChange={e=>setSignature(e.target.value)} style={{width:'100%'}}/>
            <div style={{fontSize:11,color:'var(--si)',marginTop:4}}>Le mail se terminera par : « Bien cordialement, {(signature||'').trim()||'…'} »</div>
          </div>

          <div>
            <label className="fl">Ajouter une adresse ponctuelle (optionnel)</label>
            <input type="email" placeholder="ex: comptable@cabinet.fr" value={extra} onChange={e=>setExtra(e.target.value)} style={{width:'100%'}}/>
            {!extraValide()&&<div style={{fontSize:11,color:'#b91c1c',marginTop:4}}>Adresse email invalide.</div>}
          </div>

          <button onClick={envoyer} disabled={sending||!extraValide()} className="btn bpk" style={{justifyContent:'center',fontWeight:700,marginTop:4}}>
            {sending?'⏳ Envoi en cours…':'📧 Envoyer la facture'}
          </button>
        </>
      )}
    </div>
  }/>);
}

// ── Section facturation dans admin ──
// ── Modale d'import d'une facture externe (ex. Legalstart) ──
// Upload le PDF dans le bucket privé "factures", crée un objet de type 'externe' dans factures7.
// La facture externe est visible dans l'espace propriétaire mais n'entre PAS dans les calculs de gestion.
function ImportFactureExterneModal({clients,setFactures,onC}){
  const[cid,setCid]=useState(clients[0]?.id||'');
  const[numero,setNumero]=useState('');
  const[libelle,setLibelle]=useState('');
  const[dateEmission,setDateEmission]=useState(today());
  const[montantTTC,setMontantTTC]=useState('');
  const[fichier,setFichier]=useState(null);
  const[saving,setSaving]=useState(false);
  const[err,setErr]=useState('');

  const onFile=e=>{
    const f=e.target.files?.[0];
    if(!f)return;
    if(f.type!=='application/pdf'){setErr('Seuls les fichiers PDF sont acceptés.');return;}
    if(f.size>10*1024*1024){setErr('Fichier trop volumineux (max 10 Mo).');return;}
    setFichier(f);setErr('');
  };

  const save=async()=>{
    if(!cid){setErr('Choisissez un propriétaire.');return;}
    if(!numero.trim()){setErr('Saisissez le numéro de facture.');return;}
    if(!libelle.trim()){setErr('Saisissez un libellé (ex. Séjour privé juin 2025).');return;}
    if(!montantTTC||isNaN(Number(montantTTC.replace(',','.')))||Number(montantTTC.replace(',','.'))<0){setErr('Montant TTC invalide.');return;}
    if(!fichier){setErr('Sélectionnez le fichier PDF de la facture.');return;}
    setSaving(true);setErr('');
    try{
      const annee=dateEmission?dateEmission.slice(0,4):String(new Date().getFullYear());
      // Upload dans le bucket privé "factures" (même bucket que les justificatifs)
      const pdfPath=await uploadFileToFacturesBucket(fichier,cid,annee);
      const fac={
        id:'fac-'+Date.now()+'-'+Math.random().toString(36).slice(2,7),
        type:'externe',
        cid,
        statut:'emise',                       // une facture externe est directement émise
        numeroDefinitif:numero.trim(),
        periodeLabel:libelle.trim(),
        dateEmission:dateEmission?new Date(dateEmission).toISOString():new Date().toISOString(),
        datePaiement:null,
        montantTTC:Math.round(Number(montantTTC.replace(',','.'))*100)/100,
        pdfPath,                              // chemin dans le bucket "factures"
        dateCreation:new Date().toISOString(),
        lignesIds:[],
        snapshotLignes:[],
      };
      setFactures(prev=>[...prev,fac]);
      onC();
    }catch(e){
      setErr('Erreur upload : '+e.message);
    }finally{setSaving(false);}
  };

  return(<M onC={onC} title="📎 Importer une facture externe" col="var(--or)" ch={
    <div style={{display:'flex',flexDirection:'column',gap:14}}>
      <div style={{background:'#fff4d6',borderRadius:9,padding:'10px 14px',fontSize:12,color:'#7a5a00',border:'1px solid #e5c977'}}>
        Cette facture sera visible dans l'espace propriétaire mais <strong>n'entrera pas dans les calculs de gestion</strong> (CA, marges, analyses). À utiliser pour les factures émises hors application (Legalstart, Pennylane, etc.).
      </div>
      <div>
        <label className="fl">Propriétaire</label>
        <select value={cid} onChange={e=>setCid(e.target.value)} style={{width:'100%',fontSize:13}}>
          {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <div style={{display:'flex',gap:10}}>
        <div style={{flex:1}}>
          <label className="fl">Numéro de facture</label>
          <input value={numero} onChange={e=>setNumero(e.target.value)} placeholder="ex. LS-2025-001" style={{width:'100%',fontSize:13}}/>
        </div>
        <div style={{flex:1}}>
          <label className="fl">Date d'émission</label>
          <input type="date" value={dateEmission} onChange={e=>setDateEmission(e.target.value)} style={{width:'100%',fontSize:13}}/>
        </div>
      </div>
      <div>
        <label className="fl">Libellé (affiché au propriétaire)</label>
        <input value={libelle} onChange={e=>setLibelle(e.target.value)} placeholder="ex. Séjour privé juin 2025" style={{width:'100%',fontSize:13}}/>
      </div>
      <div>
        <label className="fl">Montant total TTC (€)</label>
        <input value={montantTTC} onChange={e=>setMontantTTC(e.target.value)} placeholder="ex. 450.00" type="text" inputMode="decimal" style={{width:'100%',fontSize:13}}/>
      </div>
      <div>
        <label className="fl">Fichier PDF de la facture</label>
        <input type="file" accept="application/pdf" onChange={onFile} style={{fontSize:13}}/>
        {fichier&&<div style={{fontSize:11,color:'var(--ok)',marginTop:4}}>✓ {fichier.name} ({(fichier.size/1024).toFixed(0)} Ko)</div>}
      </div>
      {err&&<div style={{background:'#fde0e0',color:'var(--dg)',padding:'8px 12px',borderRadius:7,fontSize:12}}>{err}</div>}
      <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
        <button onClick={onC} className="btn bgh">Annuler</button>
        <button onClick={save} className="btn bor" disabled={saving}>{saving?'⏳ Upload en cours…':'📎 Importer'}</button>
      </div>
    </div>
  }/>);
}

// ══════════════ FACTURATION PRESTATIONS — MODULE (Morceau 2) ══════════════
// Agrege les TACHES du planning (st) d'un client "prestations", pas les sejours.
// Tri strict : semaine -> jour de sortie -> rang du bien (rangFacturation).
// 4 sections figees : Menages / Check-in / Prestations annexes / Majoration (agregee).
// Reutilise generateFacturX en gabarit 'prestations'. Anti-double-facturation derive
// des factures emises/payees de profil 'prestations' (lignesIds = ids de taches).
function FacturationPrestations({clients,biens,st,rep,als,feries,factures,setFactures,compteursFacture,setCompteursFacture}){
  const r2=n=>Math.round((Number(n)+Number.EPSILON)*100)/100;
  // Clients en profil prestations uniquement.
  const clientsPresta=useMemo(()=>(clients||[]).filter(c=>c.profilFacturation==='prestations'),[clients]);
  const[selClient,setSelClient]=useState(()=>clientsPresta[0]?.id||'');
  // Si la liste change et que la selection n'est plus valide, on recale.
  const cli=clientsPresta.find(c=>c.id===selClient)||clientsPresta[0]||null;
  const cid=cli?.id||'';
  const modeRegroupement=cli?(cli.modeRegroupement||'semaine'):'semaine';

  // ── Periode : semaine ISO (defaut) ou mois ──
  const[modePeriode,setModePeriode]=useState('semaine'); // 'semaine' | 'mois'
  const today=new Date();
  const[lundi,setLundi]=useState(()=>lundiDeISO(iD(today)));
  const[mois,setMois]=useState(today.getMonth());
  const[annee,setAnnee]=useState(today.getFullYear());
  const MOIS_LONG=['Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];
  const MOIS_FR=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];

  // Bornes de la periode active (sur le JOUR DE SORTIE pour les menages, la date pour le reste).
  const[debP,finP]=useMemo(()=>{
    if(modePeriode==='semaine')return bornesSemaine(lundi);
    const d0=new Date(annee,mois,1),d1=new Date(annee,mois+1,0);
    return[iD(d0),iD(d1)];
  },[modePeriode,lundi,mois,annee]);

  // Libelles periode (pour titre PDF et nom de fichier).
  const numSem=modePeriode==='semaine'?numSemaineISO(lundi):0;
  const periodeLabel=modePeriode==='semaine'?('semaine '+numSem):(MOIS_LONG[mois]+' '+annee);
  const periodeLabelFR=modePeriode==='semaine'?('Semaine '+numSem+' · '+debP.split('-').reverse().join('/')+' → '+finP.split('-').reverse().join('/')):(MOIS_FR[mois]+' '+annee);
  const periodeFichier=modePeriode==='semaine'?('S'+String(numSem).padStart(2,'0')+'-'+annee):(MOIS_LONG[mois]+'-'+annee);

  // ── Anti-double-facturation : ids de taches deja facturees (factures prestations emises/payees) ──
  const tachesFacturees=useMemo(()=>{
    const ids=new Set();
    (factures||[]).filter(f=>f.profil==='prestations'&&(f.statut==='emise'||f.statut==='payee')).forEach(f=>{
      (f.lignesIds||[]).forEach(id=>ids.add(id));
    });
    return ids;
  },[factures]);

  // ── Une tache est-elle dans la periode ? Sur le jour de sortie pour un menage, sinon sa date. ──
  const jourRef=t=>(t.type==='full'||t.type==='quick')?(t.jourSortie||t.date):t.date;
  const dansPeriode=t=>{const j=jourRef(t);return j&&j>=debP&&j<=finP;};
  // Menage "a risque" : un menage (full/quick) sans jour de sortie renseigne. On ne le facture
  // pas par defaut (il est decoche + signale "a dater"), car sa semaine de facturation est incertaine.
  const menageNonDate=t=>(t.type==='full'||t.type==='quick')&&!t.jourSortie;

  // Biens du client selectionne (pour filtrer ses taches et recuperer le rang).
  const biensClient=useMemo(()=>(biens||[]).filter(b=>b.cid===cid),[biens,cid]);
  const bienIds=useMemo(()=>new Set(biensClient.map(b=>b.id)),[biensClient]);
  const bienById=id=>biensClient.find(b=>b.id===id)||(biens||[]).find(b=>b.id===id)||null;

  // Types de taches facturables en prestations.
  const TYPES_FACT=['full','quick','checkin','intervention'];

  // ── Taches facturables du client (toutes, hors annulees / deja facturees) ──
  // Binome : la moitie "binomeRole==='binome'" d'une tache liee n'est jamais facturable — c'est
  // la MEME prestation que celle de son titulaire, deja comptee une fois via ce dernier (cf. caTask
  // dans TaskForm.jsx, meme regle).
  const tachesClient=useMemo(()=>{
    return (st||[])
      .filter(t=>t.st!=='cancelled'&&bienIds.has(t.bid)&&TYPES_FACT.includes(t.type)&&!tachesFacturees.has(t.id)&&t.binomeRole!=='binome');
  },[st,bienIds,tachesFacturees]);

  // Taches de la periode + taches hors periode (filet anti-oubli).
  const tachesPeriode=useMemo(()=>tachesClient.filter(dansPeriode),[tachesClient,debP,finP]);
  const tachesHorsPeriode=useMemo(()=>tachesClient.filter(t=>!dansPeriode(t)),[tachesClient,debP,finP]);

  // Tri : semaine(lundi du jourRef) -> jour de sortie/date -> rang du bien.
  const trier=arr=>[...arr].sort((a,b)=>{
    const sa=lundiDeISO(jourRef(a)),sb=lundiDeISO(jourRef(b));
    if(sa!==sb)return sa<sb?-1:1;
    const ja=jourRef(a),jb=jourRef(b);
    if(ja!==jb)return ja<jb?-1:1;
    const ra=Number(bienById(a.bid)?.rangFacturation)||9999;
    const rb=Number(bienById(b.bid)?.rangFacturation)||9999;
    if(ra!==rb)return ra-rb;
    // Check-in apres menage a egalite, par stabilite d'affichage.
    const ord={full:0,quick:0,checkin:1,intervention:2};
    return (ord[a.type]||9)-(ord[b.type]||9);
  });

  // ── Selection (cochage) : Map id -> bool. Par defaut, toutes les taches de la periode cochees. ──
  const[coche,setCoche]=useState({});
  const[showHors,setShowHors]=useState(false);
  const[notesTaches,setNotesTaches]=useState({});
  // Reinitialise la selection quand client/periode change : on coche tout ce qui est dans la periode.
  React.useEffect(()=>{
    const init={};
    tachesPeriode.forEach(t=>{init[t.id]=!menageNonDate(t);}); // menages non dates : decoches par defaut
    setCoche(init);
    setNotesTaches({});
  // eslint volontaire : depend de la liste recomposee
  },[cid,debP,finP,tachesPeriode.length]);

  const toggle=id=>setCoche(c=>({...c,[id]:!c[id]}));

  // ── Lignes libres (v240) : lignes saisies a la main, ajoutees a la facture avec les taches cochees.
  // Conservees tant que le client et la periode ne changent pas. Logique pure : lignesLibresPresta.js.
  const[libres,setLibres]=useState([]);
  const[formLibre,setFormLibre]=useState({libelle:'',date:'',quantite:'1',prix:'',section:SECTIONS_LIBRES[0]});
  const[erreurLibre,setErreurLibre]=useState('');
  React.useEffect(()=>{setLibres([]);setErreurLibre('');},[cid,debP,finP]);
  const ajouterLibre=()=>{
    const v=validerLigneLibre({libelle:formLibre.libelle,quantite:formLibre.quantite,prix:formLibre.prix,section:formLibre.section,dtLabel:formLibre.date?labelJourASCII(formLibre.date):''});
    if(!v.ok){setErreurLibre(v.erreur);return;}
    const interdits=termesInterditsDans(v.ligne.d);
    if(interdits.length&&!window.confirm('⚠️ Le libellé contient « '+interdits.join(' », « ')+' » : ces termes sont interdits (pas de carte G). Utilise plutôt « Frais de service » ou « Récapitulatif de prestations ».\n\nAjouter quand même cette ligne ?'))return;
    setLibres(ls=>[...ls,{...v.ligne,cle:Date.now()+'-'+ls.length}]);
    setFormLibre(f=>({...f,libelle:'',date:'',quantite:'1',prix:''}));
    setErreurLibre('');
  };
  const retirerLibre=cle=>setLibres(ls=>ls.filter(l=>l.cle!==cle));

  // Detail calcule par tache (memo leger : recalcul a chaque rendu, volumes faibles).
  const detailDe=t=>detaillerTachePrestation(t,bienById(t.bid),rep,als,feries);

  // ── Construction des 4 sections a partir des taches cochees ──
  const construireSections=()=>{
    const tachesSel=trier(tachesClient.filter(t=>coche[t.id]));
    const menages=[],checkins=[],annexes=[];
    let majoDimanche=0,majoFerie=0;
    const idsUtilises=[];
    tachesSel.forEach(t=>{
      const d=detailDe(t);
      if(!d)return;
      idsUtilises.push(t.id);
      const jourLbl=labelJourASCII(d.jour);
      // dt = date dediee (colonne Date). unite=true pour menages/check-in/extras (comptables a l'unite),
      // false pour les interventions a l'heure (ne pas additionner les "quantites" heures dans le sous-total).
      d.lignes.forEach(l=>{
        // Intervention a l'heure = section annexe SANS marqueur d'unite (ni _annexe extra, ni _uniteAnnexe menage).
        const estIntervention=(d.section==='annexe'&&!l._annexe&&!l._uniteAnnexe);
        const isFirst=d.lignes.indexOf(l)===0;
        const note=isFirst?(notesTaches[t.id]||''):'';
        const ligne={d:l.d,dt:jourLbl,q:l.q,pu:l.pu,unite:!estIntervention,note,...(l.urgent?{urgent:true}:{})};
        // Ligne principale d'un menage normal -> Menages. Tout le reste (extras _annexe d'un menage,
        // intervention a l'heure, menage de bien annexe) -> Prestations annexes.
        if(d.section==='menages'&&!l._annexe)menages.push(ligne);
        else if(d.section==='checkin')checkins.push(ligne);
        else annexes.push(ligne);
      });
      if(Number(d.majoration)>0){
        if(d.majoType==='ferie')majoFerie+=Number(d.majoration);
        else majoDimanche+=Number(d.majoration);
      }
    });
    const sections=[];
    if(menages.length)sections.push({lbl:'Ménages',lignes:menages});
    if(checkins.length)sections.push({lbl:'Check-in',lignes:checkins});
    if(annexes.length)sections.push({lbl:'Prestations annexes',lignes:annexes});
    // Majoration : deux lignes agregees distinctes (dimanche / jour ferie), sans date.
    const lignesMajo=[];
    if(r2(majoDimanche)>0)lignesMajo.push({d:'Majoration dimanche',dt:'',q:1,pu:r2(majoDimanche),unite:true});
    if(r2(majoFerie)>0)lignesMajo.push({d:'Majoration jour ferie',dt:'',q:1,pu:r2(majoFerie),unite:true});
    if(lignesMajo.length)sections.push({lbl:'Majoration',lignes:lignesMajo});
    // Lignes libres (v240) : inserees dans leur section, dans l'ordre fixe du gabarit. Aucun id de tache.
    const avecLibres=ajouterLignesLibres(sections,libres);
    return {sections:avecLibres.sections,idsUtilises,total:avecLibres.total};
  };

  // Apercu live des totaux (sans generer le PDF).
  const apercu=useMemo(()=>{
    let ht=0,nb=0;
    trier(tachesClient.filter(t=>coche[t.id])).forEach(t=>{
      const d=detailDe(t);if(!d)return;nb++;
      d.lignes.forEach(l=>{ht+=l.pu*l.q;});
      ht+=Number(d.majoration||0);
    });
    return {ht:r2(ht),ttc:r2(ht*1.2),nb};
  },[coche,tachesClient,rep,als]);

  const[busy,setBusy]=useState(false);

  // ── Generation Factur-X (brouillon) ──
  const genererFacture=async()=>{
    if(!cli){alert('Selectionnez un client prestations.');return;}
    const{sections,idsUtilises,total}=construireSections();
    if(!sections.length){alert('Aucune tache cochee a facturer.');return;}
    setBusy(true);
    try{
      await generateFacturX({
        client:cli,
        periodeLabel,
        periodeFichier,
        periode:{mode:modePeriode,lundi,mois,annee,numSem,deb:debP,fin:finP,profil:'prestations'},
        gabarit:'prestations',
        sections,
        lignesIdsOverride:idsUtilises,
        titrePrefixe:modePeriode==='semaine'?'Interventions ':'Interventions ',
        onSave:fac=>{
          if(typeof setFactures==='function'){
            setFactures(prev=>{
              // Anti-doublon : un brouillon prestations identique (meme client, meme periodeLabel) est remplace.
              const i=prev.findIndex(f=>f.profil==='prestations'&&f.cid===fac.cid&&f.periodeLabel===fac.periodeLabel&&f.statut==='brouillon');
              return i>=0?prev.map((f,k)=>k===i?fac:f):[...prev,fac];
            });
          }
        },
      });
    }catch(e){console.error(e);alert('Erreur generation Factur-X : '+e.message);}
    finally{setBusy(false);}
  };

  // Brouillon existant pour cette periode+client ?
  const brouillonExistant=(factures||[]).find(f=>f.profil==='prestations'&&f.cid===cid&&f.periodeLabel===periodeLabel&&f.statut==='brouillon');
  const factureEmise=(factures||[]).find(f=>f.profil==='prestations'&&f.cid===cid&&f.periodeLabel===periodeLabel&&(f.statut==='emise'||f.statut==='payee'));

  // ── Rendu ──
  if(!clientsPresta.length){
    return(<div className="empty">Aucun client en profil « prestations » pour l'instant. Configurez un client en profil prestations (fiche client) pour activer la facturation à la semaine.</div>);
  }

  const LigneTache=({t,enHors})=>{
    const d=detailDe(t);
    const bien=bienById(t.bid);
    const lblType=t.type==='checkin'?'Check-in':t.type==='intervention'?'Intervention':'Ménage';
    const jour=jourRef(t);
    const aDater=menageNonDate(t);
    const montant=d?r2(d.lignes.reduce((a,l)=>a+l.pu*l.q,0)+Number(d.majoration||0)):0;
    return(<div onClick={()=>toggle(t.id)} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',borderRadius:8,cursor:'pointer',
      background:coche[t.id]?'#f0faf0':(aDater?'#fff8ef':'var(--wh)'),border:`1.5px solid ${coche[t.id]?'var(--mn)':(aDater?'#f0b97d':'var(--li)')}`,marginBottom:5}}>
      <span style={{fontSize:16}}>{coche[t.id]?'☑':'☐'}</span>
      <span style={{fontSize:11,color:aDater?'#b45309':'var(--si)',minWidth:74}}>{aDater?'— à dater':labelJourASCII(jour)}</span>
      <span style={{background:TT[t.type]?.bg||'#eee',color:TT[t.type]?.c||'#555',fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:999}}>{lblType}</span>
      <div style={{flex:1,minWidth:120}}>
        <div style={{fontSize:13,fontWeight:600}}>{bien?.name||'(bien supprimé)'}{Number(bien?.rangFacturation)>0&&<span style={{fontSize:10,color:'var(--si)',marginLeft:6}}>#{bien.rangFacturation}</span>}</div>
        {d?.lignes?.map((l,i)=><div key={i} style={{fontSize:11,color:'var(--si)'}}>{l.d}{l.urgent&&<span style={{fontSize:9,background:'#fde8e8',color:'var(--dg)',fontWeight:700,padding:'1px 6px',borderRadius:999,margin:'0 4px'}}>⚡ URGENT</span>} — {feur(l.pu)}{l.q>1?` ×${l.q}`:''}</div>)}
        {d&&Number(d.majoration)>0&&<div style={{fontSize:11,color:'var(--or)'}}>+ majoration {d.majoType==='ferie'?'jour férié':'dimanche'} {feur(d.majoration)}</div>}
        {!d&&<div style={{fontSize:11,color:'var(--dg)'}}>Non facturable (tarif manquant ou pointage absent)</div>}
      </div>
      {aDater&&<span style={{fontSize:9,background:'#fde9c8',color:'#b45309',fontWeight:700,padding:'1px 6px',borderRadius:999}} title="Renseignez le jour de sortie dans le formulaire de tâche pour fiabiliser la semaine de facturation">à dater</span>}
      {enHors&&<span style={{fontSize:9,background:'#fff4d6',color:'#92400e',fontWeight:700,padding:'1px 6px',borderRadius:999}}>hors période</span>}
      <span style={{fontWeight:700,fontSize:13,color:'var(--pk)',minWidth:64,textAlign:'right'}}>{montant>0?feur(montant):'—'}</span>
    </div>);
  };

  return(<div>
    {/* Bandeau filtres */}
    <div style={{display:'flex',gap:10,marginBottom:14,flexWrap:'wrap',alignItems:'center'}}>
      <select value={cid} onChange={e=>setSelClient(e.target.value)} style={{width:'auto',minWidth:200,fontSize:13}}>
        {clientsPresta.map(c=><option key={c.id} value={c.id}>{c.name}{(c.modeRegroupement||'semaine')==='periode'?' (période)':' (semaine)'}</option>)}
      </select>
      <div style={{display:'flex',gap:4,background:'var(--bg)',borderRadius:9,padding:3}}>
        {[['semaine','Semaine'],['mois','Mois']].map(([m,lbl])=>(
          <button key={m} onClick={()=>setModePeriode(m)} className="st" style={{background:modePeriode===m?'var(--or)':'transparent',color:modePeriode===m?'#fff':'var(--si)',border:'none',padding:'6px 12px',fontSize:12,fontWeight:modePeriode===m?700:500}}>{lbl}</button>
        ))}
      </div>
      {modePeriode==='semaine'?(<>
        <button onClick={()=>setLundi(l=>iD(aD(new Date(l+'T12:00:00'),-7)))} className="wn">‹</button>
        <button onClick={()=>setLundi(l=>iD(aD(new Date(l+'T12:00:00'),7)))} className="wn">›</button>
        <div className="D" style={{fontSize:15,minWidth:220}}>{periodeLabelFR}</div>
        <button onClick={()=>setLundi(lundiDeISO(iD(new Date())))} className="btn bgh sm">Cette semaine</button>
      </>):(<>
        <button onClick={()=>{if(mois===0){setMois(11);setAnnee(a=>a-1);}else setMois(m=>m-1);}} className="wn">‹</button>
        <button onClick={()=>{if(mois===11){setMois(0);setAnnee(a=>a+1);}else setMois(m=>m+1);}} className="wn">›</button>
        <div className="D" style={{fontSize:15,minWidth:160}}>{MOIS_FR[mois]} {annee}</div>
      </>)}
    </div>

    {/* Bandeau facture deja existante */}
    {factureEmise&&(
      <div style={{marginBottom:12,borderRadius:9,padding:'10px 14px',display:'flex',alignItems:'center',gap:12,flexWrap:'wrap',background:'#e1f7ee',border:'1.5px solid var(--mn)'}}>
        <span style={{fontSize:18}}>✅</span>
        <div style={{flex:1,minWidth:200}}><span style={{fontWeight:700,fontSize:13,color:'var(--ok)'}}>Facture déjà émise pour cette période</span>
          <span style={{fontSize:12,color:'var(--si)',marginLeft:8}}>{factureEmise.numeroDefinitif||factureEmise.numeroBrouillon}</span></div>
      </div>
    )}
    {!factureEmise&&brouillonExistant&&(
      <div style={{marginBottom:12,borderRadius:9,padding:'10px 14px',display:'flex',alignItems:'center',gap:12,flexWrap:'wrap',background:'#fff4d6',border:'1.5px solid #e5c977'}}>
        <span style={{fontSize:18}}>📄</span>
        <div style={{flex:1,minWidth:200}}><span style={{fontWeight:700,fontSize:13,color:'#7a5a00'}}>Brouillon déjà généré</span>
          <span style={{fontSize:11,color:'var(--si)',marginLeft:8}}>N° provisoire {brouillonExistant.numeroBrouillon} · à émettre depuis l'onglet Factures</span></div>
      </div>
    )}

    {/* En-tete client + apercu */}
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12,flexWrap:'wrap',gap:10}}>
      <div><div className="D" style={{fontSize:17,color:'var(--pk)'}}>{cli?.name}</div>
        <div style={{fontSize:11,color:'var(--si)'}}>{apercu.nb} tâche{apercu.nb>1?'s':''} cochée{apercu.nb>1?'s':''}{libres.length>0&&<> · {libres.length} ligne{libres.length>1?'s':''} libre{libres.length>1?'s':''}</>} · {periodeLabelFR}</div></div>
      <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
        <div style={{background:'#e1f7ee',border:'1px solid var(--mn)',borderRadius:9,padding:'7px 14px',textAlign:'right'}}>
          <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>Total TTC</div>
          <div className="D" style={{fontSize:20,color:'var(--ok)'}}>{feur(r2((apercu.ht+totalLignesLibres(libres))*1.2))}</div>
          <div style={{fontSize:10,color:'var(--si)'}}>HT {feur(r2(apercu.ht+totalLignesLibres(libres)))}</div>
        </div>
        <button onClick={genererFacture} disabled={busy||(apercu.nb===0&&libres.length===0)} className="btn bor sm" style={{fontWeight:700,color:'var(--pk)',opacity:(busy||(apercu.nb===0&&libres.length===0))?0.5:1}} title="Générer la facture Factur-X (PDF + XML)">{busy?'⏳ Génération…':'🧾 Facture Factur-X'}</button>
      </div>
    </div>

    {/* Lignes libres (v240) : ajout manuel d'une ligne de facturation, avec les tâches cochées */}
    <div data-testid="lignes-libres" style={{border:'1.5px dashed var(--li)',borderRadius:9,padding:'10px 12px',marginBottom:12,background:'var(--wh)'}}>
      <div style={{fontSize:12,fontWeight:700,color:'var(--pk)',marginBottom:6}}>➕ Ajouter une ligne à la facture <span style={{fontWeight:400,color:'var(--si)'}}>(hors planning · prix négatif possible pour une remise)</span></div>
      <div style={{display:'flex',gap:6,flexWrap:'wrap',alignItems:'center'}}>
        <input data-testid="libre-libelle" value={formLibre.libelle} onChange={e=>{const v=e.target.value;setFormLibre(f=>({...f,libelle:v}));}} placeholder="Libellé (ex. Fournitures, Remise commerciale)" maxLength={120} style={{flex:'2 1 220px',fontSize:12,padding:'6px 9px'}}/>
        <input data-testid="libre-date" type="date" value={formLibre.date} onChange={e=>{const v=e.target.value;setFormLibre(f=>({...f,date:v}));}} title="Date (facultative)" style={{flex:'0 0 auto',fontSize:12,padding:'6px 9px',width:'auto'}}/>
        <input data-testid="libre-qte" value={formLibre.quantite} onChange={e=>{const v=e.target.value;setFormLibre(f=>({...f,quantite:v}));}} placeholder="Qté" inputMode="decimal" style={{flex:'0 0 64px',fontSize:12,padding:'6px 9px',width:64}}/>
        <input data-testid="libre-prix" value={formLibre.prix} onChange={e=>{const v=e.target.value;setFormLibre(f=>({...f,prix:v}));}} onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault();ajouterLibre();}}} placeholder="Prix unit. HT (€)" inputMode="decimal" style={{flex:'0 0 130px',fontSize:12,padding:'6px 9px',width:130}}/>
        <select data-testid="libre-section" value={formLibre.section} onChange={e=>{const v=e.target.value;setFormLibre(f=>({...f,section:v}));}} style={{flex:'0 0 auto',fontSize:12,padding:'6px 8px',width:'auto'}}>
          {SECTIONS_LIBRES.map(s=><option key={s} value={s}>{s}</option>)}
        </select>
        <button data-testid="libre-ajouter" type="button" onClick={ajouterLibre} className="btn bor sm" style={{fontWeight:700}}>Ajouter</button>
      </div>
      {erreurLibre&&<div data-testid="libre-erreur" style={{fontSize:11,color:'var(--dg)',marginTop:5}}>{erreurLibre}</div>}
      {libres.length>0&&<div style={{marginTop:8,display:'flex',flexDirection:'column',gap:4}}>
        {libres.map(l=>(<div key={l.cle} data-testid="libre-ligne" style={{display:'flex',alignItems:'center',gap:8,fontSize:12,background:l.pu<0?'#fff4e8':'#f0faf0',border:'1px solid '+(l.pu<0?'var(--or)':'var(--mn)'),borderRadius:7,padding:'4px 9px'}}>
          <span style={{flex:1,minWidth:120}}>{l.d}{l.dt&&<span style={{color:'var(--si)'}}> · {l.dt}</span>}<span style={{color:'var(--si)',fontSize:10}}> · {l.section}</span></span>
          <span style={{color:'var(--si)'}}>{l.q!==1?l.q+' × ':''}{feur(l.pu)}</span>
          <span style={{fontWeight:700,minWidth:64,textAlign:'right',color:l.pu<0?'var(--or)':'var(--pk)'}}>{feur(r2(l.pu*l.q))}</span>
          <button type="button" data-testid="libre-retirer" onClick={()=>retirerLibre(l.cle)} className="btn bgh sm" title="Retirer cette ligne" style={{color:'var(--dg)',padding:'1px 7px'}}>✕</button>
        </div>))}
      </div>}
    </div>

    {/* Liste taches periode */}
    {tachesPeriode.length===0
      ? <div className="empty">Aucune tâche facturable taguée sur cette période. Pensez à renseigner le « jour de sortie » sur les ménages (formulaire de tâche).</div>
      : <div style={{marginBottom:8}}>{trier(tachesPeriode).map(t=><div key={t.id}><LigneTache t={t}/>{coche[t.id]&&<div style={{padding:'2px 12px 6px 38px',marginBottom:4}} onClick={e=>e.stopPropagation()}><input value={notesTaches[t.id]||''} onChange={e=>{const v=e.target.value;setNotesTaches(n=>({...n,[t.id]:v}));}} placeholder="Commentaire sur le PDF (optionnel)" style={{width:'100%',fontSize:11,color:'var(--si)',border:'1px solid var(--li)',borderRadius:6,padding:'3px 8px',background:'var(--wh)'}}/></div>}</div>)}</div>
    }

    {/* Filet anti-oubli : taches hors periode non facturees */}
    {tachesHorsPeriode.length>0&&(
      <div style={{marginTop:10}}>
        <label onClick={()=>setShowHors(s=>!s)} style={{cursor:'pointer',fontSize:12,color:'var(--si)',display:'flex',alignItems:'center',gap:6}}>
          <span>{showHors?'☑':'☐'}</span> Voir aussi les tâches non facturées hors période ({tachesHorsPeriode.length})
        </label>
        {showHors&&<div style={{marginTop:8,opacity:.95}}>{trier(tachesHorsPeriode).map(t=><div key={t.id}><LigneTache t={t} enHors/>{coche[t.id]&&<div style={{padding:'2px 12px 6px 38px',marginBottom:4}} onClick={e=>e.stopPropagation()}><input value={notesTaches[t.id]||''} onChange={e=>{const v=e.target.value;setNotesTaches(n=>({...n,[t.id]:v}));}} placeholder="Commentaire sur le PDF (optionnel)" style={{width:'100%',fontSize:11,color:'var(--si)',border:'1px solid var(--li)',borderRadius:6,padding:'3px 8px',background:'var(--wh)'}}/></div>}</div>)}</div>}
      </div>
    )}
  </div>);
}

function SecFacturation(P){
  const{sejours,setSejours,biens,clients,rep,st,setSt,feries,als,factures,setFactures,compteursFacture,setCompteursFacture}=P;
  const[sub,setSub]=useState('aide');
  const[editSej,setEditSej]=useState(null);
  // ── Synchronisation PMS (Eviivo et/ou Beds24, bien par bien selon l'URL renseignée) ──
  const[syncing,setSyncing]=useState(false);
  const[syncMsg,setSyncMsg]=useState(null); // {ok:bool, text:string}
  const lancerSyncEviivo=async()=>{
    const sources=(biens||[]).filter(b=>b.icalUrl&&detectPmsVendor(b.icalUrl)&&(b.icalMode||'complet')==='complet').map(b=>({bid:b.id,url:b.icalUrl}));
    if(!sources.length){setSyncMsg({ok:false,text:"Aucun logement avec un lien iCal PMS valide (Eviivo ou Beds24). Ajoute le lien dans la fiche du bien (onglet Appartements)."});return;}
    setSyncing(true);setSyncMsg(null);
    try{
      // Lecture fraîche avant écriture (cohérence multi-session, comme saveTask)
      let freshSej=sejours, freshSt=st;
      try{
        const[rSej,rSt]=await Promise.all([supaGet('sejours7'),supaGet('st7')]);
        if(Array.isArray(rSej))freshSej=rSej;
        if(Array.isArray(rSt))freshSt=rSt;
      }catch(e){console.warn('[syncEviivo] lecture fraîche échouée, fallback state local',e.message);}
      const{results}=await fetchPmsIcal(sources);
      const{sejours:nSej,st:nSt,notifs,stats}=reconcilePms(results,freshSej,freshSt,biens);
      setSejours(nSej);
      setSt(nSt);
      // Émission des notifications business
      (notifs||[]).forEach(n=>{
        const bien=(biens||[]).find(b=>b.id===n.bid);
        if(n.type==='sejour_importe'){
          notifEventBus.emit('sejour_importe',{toUserType:'admin',date:n.date,
            summary:`Nouveau séjour importé depuis ${pmsLabel(n.vendor)} le ${n.date} · ${bien?.name||'?'} (à compléter)`});
        }else if(n.type==='sejour_a_verifier'){
          const r=n.raison==='annulation'?'annulé chez le PMS':'dates modifiées';
          notifEventBus.emit('sejour_a_verifier',{toUserType:'admin',date:n.date,
            summary:`Séjour à vérifier (${r}) le ${n.date} · ${bien?.name||'?'}`});
        }
      });
      // Lignes d'erreur réseau éventuelles (biens dont l'iCal n'a pu être lu)
      const erreurs=(results||[]).filter(r=>!r.ok);
      const parts=[];
      if(stats.crees)parts.push(`${stats.crees} nouveau(x) séjour(s)`);
      if(stats.rattaches)parts.push(`${stats.rattaches} rattaché(s) à un séjour existant`);
      if(stats.migres)parts.push(`${stats.migres} ré-ancré(s) suite à bascule PMS`);
      if(stats.majDates)parts.push(`${stats.majDates} mis à jour`);
      if(stats.annulesDetectes)parts.push(`${stats.annulesDetectes} annulation(s) détectée(s)`);
      if(stats.inchanges)parts.push(`${stats.inchanges} inchangé(s)`);
      let text=parts.length?('Synchro terminée : '+parts.join(', ')+'.'):'Synchro terminée : rien de nouveau.';
      if(erreurs.length)text+=` ⚠️ ${erreurs.length} logement(s) non lus : ${erreurs.map(e=>{const b=(biens||[]).find(x=>x.id===e.bid);return(b?.name||e.bid)+' ('+(e.error||'?')+')';}).join(' ; ')}`;
      if((stats.crees||stats.majDates||stats.annulesDetectes))setSub('acompleter');
      setSyncMsg({ok:!erreurs.length,text});
    }catch(e){
      setSyncMsg({ok:false,text:'Échec de la synchronisation : '+(e.message||e)+". Vérifie que l'Edge Function sync-eviivo-ical est bien déployée."});
    }finally{setSyncing(false);}
  };
  // Séjours en attente de complétion (importés Eviivo, non finalisés)
  const sejoursACompleter=useMemo(()=>(sejours||[]).filter(s=>s.source==='eviivo'&&(s.statut==='a_completer'||s.statut==='annule_eviivo')),[sejours]);
  const nbACompleter=sejoursACompleter.length;
  const[filterCid,setFilterCid]=useState('all');
  const[filterReprendre,setFilterReprendre]=useState(false);
  const[showIgnores,setShowIgnores]=useState(false); // masque par défaut les séjours 'ignore' (doublons Eviivo écartés)
  const[filterFacCid,setFilterFacCid]=useState('all');
  const[filterFacStatut,setFilterFacStatut]=useState('all');
  const[envoiFac,setEnvoiFac]=useState(null); // facture en cours d'envoi par email (ouvre la modal)
  const[importExtModal,setImportExtModal]=useState(false); // modale import facture externe
  const[relanceFac,setRelanceFac]=useState(null); // facture en cours de relance (ouvre la modal relance)

  // Facture "en retard" = émise, non payée, dateEmission > 7 jours
  const RETARD_JOURS=7;
  const facEnRetard=f=>{
    if(f.statut!=='emise')return false;
    if(!f.dateEmission)return false;
    const diffMs=Date.now()-new Date(f.dateEmission).getTime();
    return diffMs>RETARD_JOURS*24*60*60*1000;
  };
  const nbRelances=(factures||[]).filter(facEnRetard).length;
  const saveSej=s=>{
    // Si on complète un séjour importé Eviivo (sas 'a_completer'), on le bascule
    // en séjour normal facturable. On conserve source/eviivoUid pour la détection d'annulation.
    let out=(s.source==='eviivo'&&s.statut==='a_completer')?{...s,statut:'draft'}:s;
    // Filet de rattrapage : le cid n'est posé que par le onChange du select Appartement,
    // qui ne part jamais quand le bid est déjà prérempli (cas des séjours nés d'Eviivo).
    // On le complète depuis le bien, et UNIQUEMENT s'il est vide : un cid déjà posé reste
    // la vérité historique du séjour, même si le bien change de propriétaire plus tard.
    if(!out.cid&&out.bid){
      const bSej=(biens||[]).find(x=>x.id===out.bid);
      if(bSej&&bSej.cid)out={...out,cid:bSej.cid};
    }
    setSejours(prev=>{const i=prev.findIndex(x=>x.id===out.id);return i>=0?prev.map(x=>x.id===out.id?out:x):[...prev,out];});setEditSej(null);
  };
  const delSej=id=>setSejours(prev=>prev.filter(s=>s.id!==id));
  const MOIS_LONG=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];

  // IDs séjours facturés via l'appli (émis ou payés) — cherche dans snapshotLignes ET lignesIds
  const sejoursFacturesApp=useMemo(()=>{
    const ids=new Set();
    // Exclure les factures externes (pas de lignes séjour) et prestations (lignesIds = tâches)
    (factures||[]).filter(f=>f.type!=='externe'&&f.profil!=='prestations'&&(f.statut==='emise'||f.statut==='payee')).forEach(f=>{
      // Source 1 : snapshotLignes (plus fiable, contient tous les séjours même si lignesIds incomplet)
      if(f.snapshotLignes&&f.snapshotLignes.length){
        f.snapshotLignes.forEach(l=>{if(l.s?.id)ids.add(l.s.id);});
      }
      // Source 2 : lignesIds (fallback)
      (f.lignesIds||[]).forEach(id=>ids.add(id));
    });
    return ids;
  },[factures]);

  const marquerPayee=fac=>{
    if(!window.confirm(`Marquer la facture ${fac.numeroDefinitif} comme payée ?\n\nDate de paiement : aujourd'hui (${new Date().toLocaleDateString('fr-FR')})`))return;
    setFactures(prev=>prev.map(f=>f.id===fac.id?{...f,statut:'payee',datePaiement:new Date().toISOString()}:f));
    if(typeof P.logAction==='function'){const cl=(P.clients||[]).find(c=>c.id===fac.cid);P.logAction({action:'facture_payee',qui:P.sess?.email||'Admin',role:'admin',objet:fac.numeroDefinitif||fac.id,cible:cl?.name||'',detail:'Marquée payée'});}
  };

  const annulerBrouillon=fac=>{
    if(fac.statut!=='brouillon'){alert('Seuls les brouillons peuvent être annulés.');return;}
    if(!window.confirm(`Annuler le brouillon ${fac.numeroBrouillon} ?\n\nLe brouillon ne sera pas supprimé mais marqué « Annulé » et masqué de la liste par défaut (visible via le filtre « Annulées »).`))return;
    setFactures(prev=>prev.map(f=>f.id===fac.id?{...f,statut:'annulee',dateAnnulation:new Date().toISOString()}:f));
    if(typeof P.logAction==='function'){const cl=(P.clients||[]).find(c=>c.id===fac.cid);P.logAction({action:'facture_annulee',qui:P.sess?.email||'Admin',role:'admin',objet:fac.numeroBrouillon||fac.id,cible:cl?.name||'',detail:'Brouillon annulé'});}
  };

  // Émission d'un brouillon directement depuis l'onglet Factures (même logique que AideFacturation).
  const emettreFactureDirect=fac=>{
    if(fac.statut!=='brouillon'){alert('Seuls les brouillons peuvent être émis.');return;}
    const annee=new Date().getFullYear();
    const cpt=prochainCompteur(compteursFacture,SERIE_CONCIERGERIE,annee);
    const numero=formatNumero(SERIE_CONCIERGERIE,annee,cpt);
    if(!window.confirm(
      'Émettre cette facture sous le numéro :\n\n    '+numero+'\n\n'+
      '• Ce numéro est définitif (numérotation séquentielle légale).\n'+
      '• C\'est ce numéro que vous reporterez dans Pennylane à l\'import.\n'+
      '• Le compteur passera ensuite à '+(cpt+1)+'.\n\n'+
      'Confirmer l\'émission ?'
    ))return;
    // Facture prestations : pas de snapshot séjour (le contenu est figé dans sectionsPresta).
    const snapshot=fac.profil==='prestations'?undefined:buildFactureSnapshot(fac.lignesIds,sejours,biens,clients);
    setFactures(prev=>prev.map(f=>f.id===fac.id
      ?{...f,statut:'emise',numeroDefinitif:numero,dateEmission:new Date().toISOString(),...(snapshot!==undefined?{snapshotLignes:snapshot}:{})}
      :f));
    setCompteursFacture(prev=>avancerCompteur(prev,SERIE_CONCIERGERIE,annee));
  };

  // Reconstruit les lignes vivantes d'une facture (pour PDF d'un brouillon sans snapshot).
  const lignesPourPDF=fac=>{
    const ids=new Set(fac.lignesIds||[]);
    const cl=clients.find(c=>c.id===fac.cid);
    return(sejours||[])
      .filter(s=>ids.has(s.id))
      .map(s=>({s,bien:biens.find(b=>b.id===s.bid)||{name:''},calc:calcSejour(s,biens.find(b=>b.id===s.bid)||{},cl)}))
      .filter(l=>l.bien?.name);
  };

  const setJustifsFacture=(facId,newJustifs)=>{
    setFactures(prev=>prev.map(f=>f.id===facId?{...f,justifs:newJustifs}:f));
  };

  const setAvoirFacture=(facId,avoir)=>{
    setFactures(prev=>prev.map(f=>f.id===facId?{...f,avoir}:f));
  };

  // Capture rétroactive du snapshot pour une facture émise AVANT le mécanisme de snapshot.
  // À utiliser AVANT toute modification des séjours, pour figer les montants actuels.
  const figerSnapshot=fac=>{
    const snap=buildFactureSnapshot(fac.lignesIds,sejours,biens,clients);
    if(!snap.length){alert('Impossible de figer : séjours associés introuvables.');return;}
    if(!window.confirm('Figer les montants ACTUELS de la facture '+(fac.numeroDefinitif||fac.numeroBrouillon)+' ?\n\nLe PDF de cette facture ne bougera plus, même si vous modifiez les séjours ensuite. À faire AVANT toute correction du séjour.'))return;
    setFactures(prev=>prev.map(f=>f.id===fac.id?{...f,snapshotLignes:snap}:f));
  };

  const facFiltered=(factures||[])
    .filter(f=>(filterFacCid==='all'||f.cid===filterFacCid)&&(filterFacStatut==='all'?f.statut!=='annulee':f.statut===filterFacStatut))
    .sort((a,b)=>new Date(b.dateCreation||0)-new Date(a.dateCreation||0));

  const badgeFac=f=>{
    if(f.type==='externe'&&f.statut==='payee')return{bg:'#e1f7ee',col:'var(--ok)',lbl:'📎 Externe · Réglée'};
    if(f.type==='externe')return{bg:'#f0e6ff',col:'#5a2d82',lbl:'📎 Externe'};
    if(f.statut==='payee')return{bg:'#e1f7ee',col:'var(--ok)',lbl:'✅ Payée'};
    if(f.statut==='emise')return{bg:'#e8f4ff',col:'#0369a1',lbl:'📤 Émise'};
    if(f.statut==='annulee')return{bg:'#f3f4f6',col:'#9ca3af',lbl:'🚫 Annulée'};
    return{bg:'#fff4d6',col:'#7a5a00',lbl:'📄 Brouillon'};
  };

  const nbBrouillons=(factures||[]).filter(f=>f.statut==='brouillon').length;
  const nbEmises=(factures||[]).filter(f=>f.statut==='emise').length;

  return(<div>
    <div className="stabs">
      <button className={`st ${sub==='aide'?'on':''}`} onClick={()=>setSub('aide')}>📋 Aide à la facturation</button>
      {(clients||[]).some(c=>c.profilFacturation==='prestations')&&
        <button className={`st ${sub==='prestations'?'on':''}`} onClick={()=>setSub('prestations')}>🧹 Prestations</button>}
      <button className={`st ${sub==='factures'?'on':''}`} onClick={()=>setSub('factures')}>🧾 Factures{(nbBrouillons+nbEmises)>0&&<span className="bc" style={{background:nbEmises>0?'#0369a1':'var(--ye)'}}>{nbBrouillons+nbEmises}</span>}</button>
      <button className={`st ${sub==='sejours'?'on':''}`} onClick={()=>setSub('sejours')}>🏨 Séjours saisis</button>
      <button className={`st ${sub==='acompleter'?'on':''}`} onClick={()=>setSub('acompleter')}>🔄 À compléter{nbACompleter>0&&<span className="bc" style={{background:'var(--pk)'}}>{nbACompleter}</span>}</button>
      <button className={`st ${sub==='annuel'?'on':''}`} onClick={()=>setSub('annuel')}>📊 Récap annuel</button>
      <button className={`st ${sub==='relances'?'on':''}`} onClick={()=>setSub('relances')} style={nbRelances>0?{color:'#b45309'}:{}} title="Factures émises non réglées depuis plus de 7 jours">⚠️ Relances{nbRelances>0&&<span className="bc" style={{background:'#f59e0b'}}>{nbRelances}</span>}</button>
    </div>

    {sub==='aide'&&<AideFacturation sejours={sejours} biens={biens} clients={clients} factures={factures} setFactures={setFactures} compteursFacture={compteursFacture} setCompteursFacture={setCompteursFacture}/>}

    {sub==='prestations'&&<FacturationPrestations clients={clients} biens={biens} st={st} rep={rep} als={als} feries={feries} factures={factures} setFactures={setFactures} compteursFacture={compteursFacture} setCompteursFacture={setCompteursFacture}/>}

    {sub==='factures'&&(<div>
      {/* Compteur de série conciergerie (lecture seule) */}
      {(()=>{const an=new Date().getFullYear();const cpt=prochainCompteur(compteursFacture,SERIE_CONCIERGERIE,an);return(
        <div style={{marginBottom:14,fontSize:12,color:'var(--si)',background:'var(--bg)',borderRadius:8,padding:'8px 12px',display:'inline-block'}}>
          Série conciergerie · prochain numéro à l'émission : <b style={{color:'var(--pk)'}}>{formatNumero(SERIE_CONCIERGERIE,an,cpt)}</b>
        </div>
      );})()}
      {/* Filtres */}
      <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap',alignItems:'center'}}>
        <select value={filterFacCid} onChange={e=>setFilterFacCid(e.target.value)} style={{width:'auto',minWidth:180,fontSize:13}}>
          <option value="all">Tous les propriétaires</option>
          {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <div style={{display:'flex',gap:3,background:'var(--bg)',borderRadius:9,padding:3}}>
          {[['all','Tous'],['brouillon','Brouillons'],['emise','Émises'],['payee','Payées'],['annulee','Annulées']].map(([v,l])=>(
            <button key={v} onClick={()=>setFilterFacStatut(v)} className="st"
              style={{background:filterFacStatut===v?'var(--or)':'transparent',color:filterFacStatut===v?'#fff':'var(--si)',border:'none',padding:'5px 10px',fontSize:12,fontWeight:filterFacStatut===v?700:400}}>
              {l}
            </button>
          ))}
        </div>
        <div style={{marginLeft:'auto',fontSize:12,color:'var(--si)'}}>{facFiltered.length} facture{facFiltered.length>1?'s':''}</div>
        <button onClick={()=>setImportExtModal(true)} className="btn bgh sm" title="Importer une facture faite hors application (Legalstart, Pennylane…)">📎 Facture externe</button>
      </div>

      {facFiltered.length===0?(
        <div className="empty">Aucune facture{filterFacStatut!=='all'?` en statut "${filterFacStatut}"`:''}{filterFacCid!=='all'?' pour ce propriétaire':''}.</div>
      ):(
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {facFiltered.map(f=>{
            const client=clients.find(c=>c.id===f.cid);
            const badge=badgeFac(f);
            const dateEm=f.dateEmission?new Date(f.dateEmission).toLocaleDateString('fr-FR'):'—';
            const datePay=f.datePaiement?new Date(f.datePaiement).toLocaleDateString('fr-FR'):null;
            const montantTTCval=montantFactureActuel(f,sejours,biens);
            const montantTTC=(Math.round(montantTTCval*100)/100).toFixed(2).replace('.',',')+'  €';
            return(<div key={f.id} className="card" style={{padding:'12px 16px',display:'flex',alignItems:'center',gap:14,flexWrap:'wrap',borderLeft:`4px solid ${badge.col}`}}>
              <div style={{flex:1,minWidth:200}}>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:3,flexWrap:'wrap'}}>
                  <span style={{fontWeight:700,fontSize:14}}>{f.statut==='brouillon'?f.numeroBrouillon:f.numeroDefinitif}</span>
                  <span style={{background:badge.bg,color:badge.col,fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999}}>{badge.lbl}</span>
                </div>
                <div style={{fontSize:12,color:'var(--si)'}}>{client?.name||'—'} · {f.periodeLabel||'—'}</div>
                <div style={{fontSize:11,color:'var(--si)',marginTop:2}}>
                  {f.statut!=='brouillon'&&`Émise le ${dateEm}`}
                  {datePay&&` · Payée le ${datePay}`}
                </div>
              </div>
              <div style={{textAlign:'right',minWidth:90}}>
                <div style={{fontSize:10,color:'var(--si)',textTransform:'uppercase'}}>TTC</div>
                <div style={{fontWeight:800,fontSize:18,color:f.statut==='payee'?'var(--ok)':f.statut==='emise'?'#0369a1':'var(--si)'}}>{montantTTC}</div>
              </div>
              <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                {/* ── Facture EXTERNE ── */}
                {f.type==='externe'&&f.pdfPath&&(
                  <button onClick={async()=>{
                    try{const url=await getSignedFactureUrl(f.pdfPath,3600);window.open(url,'_blank');}
                    catch(e){alert('Impossible d\'ouvrir le PDF : '+e.message);}
                  }} className="btn bgh sm">⬇ PDF</button>
                )}
                {f.type==='externe'&&f.statut==='emise'&&(
                  <button onClick={()=>marquerPayee(f)} className="btn bmn sm" style={{fontWeight:700}}>💶 Payée</button>
                )}
                {f.type==='externe'&&f.statut==='payee'&&(
                  <span style={{fontSize:11,color:'var(--ok)',fontWeight:600}}>✓ Réglée</span>
                )}
                {f.type==='externe'&&(
                  <button onClick={()=>{
                    if(!window.confirm(`Supprimer la facture externe ${f.numeroDefinitif} ?\n\nLe fichier PDF sera conservé dans le stockage mais ne sera plus accessible depuis l'application.`))return;
                    setFactures(prev=>prev.filter(x=>x.id!==f.id));
                  }} className="btn bgh sm" style={{color:'#b91c1c'}} title="Supprimer cette facture externe">🗑</button>
                )}
                {/* ── Factures normales (non externes) ── */}
                {f.type!=='externe'&&f.statut!=='brouillon'&&(()=>{
                  const cl=clients.find(c=>c.id===f.cid);
                  const lignesIds=new Set(f.lignesIds||[]);
                  const lignesF=(sejours||[])
                    .filter(s=>lignesIds.has(s.id))
                    .map(s=>({s,bien:biens.find(b=>b.id===s.bid)||{name:''},calc:calcSejour(s,biens.find(b=>b.id===s.bid)||{},cl)}))
                    .filter(l=>l.bien?.name);
                  return(<button onClick={()=>regenererPDFDepuisFacture(f,cl,lignesF)
                    .catch(e=>alert('Erreur PDF : '+e.message))} className="btn bgh sm">⬇ PDF</button>);
                })()}
                {f.type!=='externe'&&f.statut==='brouillon'&&(
                  <button onClick={()=>{const cl=clients.find(c=>c.id===f.cid);regenererPDFDepuisFacture(f,cl,lignesPourPDF(f)).catch(e=>alert('Erreur PDF : '+e.message));}} className="btn bgh sm" title="Télécharger le PDF du brouillon">⬇ PDF brouillon</button>
                )}
                {f.type!=='externe'&&f.statut==='brouillon'&&(
                  <button onClick={()=>emettreFactureDirect(f)} className="btn bmn sm" style={{fontWeight:700}} title="Attribuer le n° FC définitif et émettre">📤 Émettre</button>
                )}
                {f.type!=='externe'&&f.statut==='brouillon'&&(
                  <button onClick={()=>annulerBrouillon(f)} className="btn bgh sm" style={{color:'#b91c1c'}} title="Annuler ce brouillon (non supprimé, masqué de la liste)">🚫 Annuler</button>
                )}
                {f.type!=='externe'&&f.statut==='emise'&&(
                  <button onClick={()=>marquerPayee(f)} className="btn bmn sm" style={{fontWeight:700}}>💶 Payée</button>
                )}
                {f.type!=='externe'&&f.statut==='payee'&&(
                  <span style={{fontSize:11,color:'var(--ok)',fontWeight:600}}>✓ Réglée</span>
                )}
                {f.type!=='externe'&&(f.statut==='emise'||f.statut==='payee')&&(
                  <button onClick={()=>setEnvoiFac(f)} className="btn bpk sm" style={{fontWeight:700}} title="Envoyer la facture par email au propriétaire">
                    📧 Envoyer{f.dateEnvoiEmail?' ↺':''}
                  </button>
                )}
                {f.type!=='externe'&&f.statut==='emise'&&facEnRetard(f)&&(
                  <button onClick={()=>setRelanceFac(f)} className="btn sm" style={{background:'#f59e0b',color:'#fff',fontWeight:700}} title="Envoyer une relance (facture en retard de paiement)">
                    🔔 Relancer
                  </button>
                )}
                {f.type!=='externe'&&f.dateEnvoiEmail&&(
                  <span style={{fontSize:10,color:'var(--si)'}} title={`Dernier envoi : ${new Date(f.dateEnvoiEmail).toLocaleString('fr-FR')}`}>✉️ {new Date(f.dateEnvoiEmail).toLocaleDateString('fr-FR')}</span>
                )}
                {f.type!=='externe'&&f.statut!=='brouillon'&&!(f.snapshotLignes&&f.snapshotLignes.length)&&(
                  <button onClick={()=>figerSnapshot(f)} className="btn bor sm" style={{fontSize:11}} title="Figer les montants actuels (facture émise avant le mécanisme de snapshot)">🔒 Figer montants</button>
                )}
              </div>
              {f.type!=='externe'&&f.statut!=='brouillon'&&(
                <JustifsFacture facture={f} mode="admin" onChange={nj=>setJustifsFacture(f.id,nj)}/>
              )}
              {f.type!=='externe'&&f.statut!=='brouillon'&&(
                <AvoirFacture facture={f} mode="admin" onChange={av=>setAvoirFacture(f.id,av)}/>
              )}
            </div>);
          })}
        </div>
      )}
    </div>)}

    {sub==='sejours'&&(<div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:16,flexWrap:'wrap',gap:10,alignItems:'center'}}>
        <div className="D" style={{fontSize:18}}>Séjours saisis</div>
        <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          <select value={filterCid} onChange={e=>setFilterCid(e.target.value)} style={{width:'auto',minWidth:170,fontSize:13}}>
            <option value="all">Tous les propriétaires</option>
            {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <button onClick={()=>setFilterReprendre(p=>!p)} className={`btn sm ${filterReprendre?'bor':'bgh'}`} style={{gap:5}}>
            ⚠️ {filterReprendre?'Tous':'À revalider'}
            {!filterReprendre&&sejours.filter(s=>(filterCid==='all'||s.cid===filterCid)&&s.aReprendre).length>0&&<span style={{background:'#f59e0b',color:'#fff',borderRadius:999,padding:'0 6px',fontSize:10,fontWeight:700}}>{sejours.filter(s=>(filterCid==='all'||s.cid===filterCid)&&s.aReprendre).length}</span>}
          </button>
          {sejours.filter(s=>(filterCid==='all'||s.cid===filterCid)&&s.statut==='ignore').length>0&&<button onClick={()=>setShowIgnores(p=>!p)} className={`btn sm ${showIgnores?'bor':'bgh'}`} style={{gap:5,color:'var(--si)'}}>
            🚫 {showIgnores?'Masquer ignorés':'Afficher ignorés'}
            <span style={{background:'var(--si)',color:'#fff',borderRadius:999,padding:'0 6px',fontSize:10,fontWeight:700}}>{sejours.filter(s=>(filterCid==='all'||s.cid===filterCid)&&s.statut==='ignore').length}</span>
          </button>}
          <button onClick={()=>setEditSej({...SEJOUR_EMPTY})} className="btn bor sm"><Ic n="plus"/>Nouveau séjour</button>
        </div>
      </div>
      {sejours.filter(s=>(filterCid==='all'||s.cid===filterCid)&&(!filterReprendre||s.aReprendre)&&s.statut!=='a_completer'&&s.statut!=='annule_eviivo'&&(showIgnores||s.statut!=='ignore')).length===0&&<div className="empty">{filterReprendre?'Aucun séjour à revalider.':'Aucun séjour saisi. Cliquez sur « Nouveau séjour » pour commencer.'}</div>}
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        {sejours.filter(s=>(filterCid==='all'||s.cid===filterCid)&&(!filterReprendre||s.aReprendre)&&s.statut!=='a_completer'&&s.statut!=='annule_eviivo'&&(showIgnores||s.statut!=='ignore')).sort((a,b)=>(b.dateDepart||b.dateArrivee||'').localeCompare(a.dateDepart||a.dateArrivee||'')).map(s=>{
          const bien=biens.find(b=>b.id===s.bid);
          const client=clients.find(c=>c.id===s.cid);
          const calc=bien?calcSejour(s,bien,client):{totalTTC:0,fraisServices:0,fraisServicesNet:0,remiseProprio:0};
          const isFactApp=sejoursFacturesApp.has(s.id);
          const isFactHors=!isFactApp&&s.factureHorsAppli;
          const isIgnore=s.statut==='ignore';
          // Séjour non rattaché à un propriétaire : invisible dans l'Aide à la facturation
          // dès qu'un propriétaire est sélectionné. On le signale au lieu de le taire.
          const sansProprio=!isIgnore&&!client;
          return(<div key={s.id} className="card" style={{padding:'12px 16px',borderLeft:s.aReprendre?'3px solid #f59e0b':isIgnore?'3px solid var(--si)':'3px solid var(--pk)',background:s.aReprendre?'#fffbf0':isIgnore?'#f3f4f6':isFactApp?'#f0faf0':isFactHors?'#f7fdf7':'',opacity:isIgnore?0.55:isFactApp||isFactHors?0.6:1}}>            <div style={{display:'flex',justifyContent:'space-between',flexWrap:'wrap',gap:10,alignItems:'center'}}>
              <div>
                <div style={{display:'flex',gap:7,marginBottom:4,flexWrap:'wrap',alignItems:'center'}}>
                  {isIgnore&&<span style={{background:'var(--si)',color:'#fff',fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:999}}>🚫 Ignoré (doublon)</span>}
                  {s.aReprendre&&<span style={{background:'#f59e0b',color:'#fff',fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:999}}>⚠️ À revalider</span>}
                  {sansProprio&&<span title="Ce séjour n'est rattaché à aucun propriétaire : il n'apparaîtra pas dans l'Aide à la facturation. Ouvrez-le et enregistrez-le pour le rattacher." style={{background:'#dc2626',color:'#fff',fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:999}}>⚠️ Sans propriétaire</span>}
                  {isFactApp&&<span style={{background:'#16a34a',color:'#fff',fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:999}}>✓ Facturé (appli)</span>}
                  {isFactHors&&<span style={{background:'#86efac',color:'#166534',fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:999}}>✓ Facturé (hors appli)</span>}
                  <span style={{background:s.ota==='AIRBNB'?'#ffe0f0':'#e0f0ff',fontSize:10,fontWeight:700,padding:'2px 6px',borderRadius:999}}>{s.ota}</span>
                  <span style={{fontWeight:700,fontSize:13}}>{bien?.name||'—'}</span>
                  <span style={{fontSize:11,color:'var(--si)'}}>· {client?.name||'—'}</span>
                </div>
                <div style={{fontSize:12,color:'var(--si)'}}>{s.dateArrivee} → {s.dateDepart} · {s.nuitees} nuit{s.nuitees>1?'s':''} · {s.adultes} adultes</div>
                <div style={{display:'flex',gap:12,fontSize:12,marginTop:4}}>
                  <span>Versement propriétaire : <strong style={{color:'var(--ok)'}}>{feur(s.versementProprio)}</strong></span>
                  {calc.fraisServices>0&&<span>Commission : <strong style={{color:'var(--or)'}}>{feur(calc.fraisServices)}</strong></span>}
                  {calc.remiseProprio>0&&<span>🎁 {calc.remiseLabel||'Remise'} : <strong style={{color:'var(--ok)'}}>−{feur(calc.remiseProprio)}</strong></span>}
                  <span>TTC : <strong style={{color:'var(--ok)'}}>{feur(calc.totalTTC)}</strong></span>
                </div>
              </div>
              <div style={{display:'flex',gap:6}}>
                <button onClick={()=>genererRecuLocataire(s,bien,clients)} className="btn bgh sm" title="Reçu locataire" disabled={!bien}>🧾</button>
                <button onClick={()=>setEditSej(s)} className="btn bgh sm"><Ic n="edit" c="w-3.5 h-3.5"/></button>
                <button onClick={()=>delSej(s.id)} className="btn bdg sm"><Ic n="trash" c="w-3.5 h-3.5"/></button>
              </div>
            </div>
          </div>);
        })}
      </div>
      {editSej!==null&&<M onC={()=>setEditSej(null)} title={editSej.id?'Modifier le séjour':'Nouveau séjour'} col="var(--or)" wide ch={<SejourForm s={editSej.id?editSej:null} biens={biens} clients={clients} rep={rep||[]} st={st||[]} feries={feries||[]} sejours={sejours||[]} onSave={saveSej} onC={()=>setEditSej(null)}/>}/>}
    </div>)}

    {sub==='annuel'&&<RecapAnnuel sejours={sejours} biens={biens} clients={clients}/>}

    {sub==='relances'&&(()=>{
      const facRetard=(factures||[]).filter(facEnRetard).sort((a,b)=>new Date(a.dateEmission)-new Date(b.dateEmission));
      return(<div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16,flexWrap:'wrap',gap:10}}>
          <div>
            <div className="D" style={{fontSize:18}}>⚠️ Factures à relancer</div>
            <div style={{fontSize:12,color:'var(--si)',marginTop:3}}>Factures émises non réglées depuis plus de {RETARD_JOURS} jours.</div>
          </div>
          {facRetard.length>0&&<div style={{background:'#fff4d6',color:'#92400e',borderRadius:9,padding:'8px 16px',fontWeight:700,fontSize:13}}>{facRetard.length} facture{facRetard.length>1?'s':''} en retard</div>}
        </div>
        {facRetard.length===0?(
          <div style={{textAlign:'center',padding:'40px 20px',color:'var(--si)'}}>
            <div style={{fontSize:32,marginBottom:8}}>✅</div>
            <div style={{fontSize:14}}>Aucune facture en retard de paiement.</div>
            <div style={{fontSize:12,marginTop:4}}>Toutes les factures émises ont été réglées ou datent de moins de {RETARD_JOURS} jours.</div>
          </div>
        ):(
          <div style={{display:'flex',flexDirection:'column',gap:10}}>
            {facRetard.map(f=>{
              const client=clients.find(c=>c.id===f.cid);
              const montantTTCval=montantFactureActuel(f,sejours,biens);
              const montantTTC=(Math.round(montantTTCval*100)/100).toFixed(2).replace('.',',')+'  €';
              const dateEm=f.dateEmission?new Date(f.dateEmission).toLocaleDateString('fr-FR'):'—';
              const joursRetard=f.dateEmission?Math.floor((Date.now()-new Date(f.dateEmission).getTime())/(24*60*60*1000)):0;
              const relances=Array.isArray(f.relances)?f.relances:[];
              const derniereRelance=relances.length>0?relances[relances.length-1]:null;
              return(<div key={f.id} className="card" style={{padding:'14px 16px',borderLeft:'4px solid #f59e0b',background:'#fffbf0'}}>
                <div style={{display:'flex',alignItems:'center',gap:14,flexWrap:'wrap'}}>
                  <div style={{flex:1,minWidth:200}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:3,flexWrap:'wrap'}}>
                      <span style={{fontWeight:700,fontSize:14}}>{f.numeroDefinitif}</span>
                      <span style={{background:'#fef3c7',color:'#92400e',fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999}}>📤 Émise · {joursRetard}j sans règlement</span>
                      {relances.length>0&&<span style={{background:'#e0e7ff',color:'#3730a3',fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999}}>🔔 {relances.length} relance{relances.length>1?'s':''}</span>}
                    </div>
                    <div style={{fontSize:12,color:'var(--si)'}}>{client?.name||'—'} · {f.periodeLabel||'—'}</div>
                    <div style={{fontSize:11,color:'var(--si)',marginTop:2}}>Émise le {dateEm}{derniereRelance&&` · Dernière relance le ${new Date(derniereRelance.ts).toLocaleDateString('fr-FR')}`}</div>
                  </div>
                  <div style={{textAlign:'right',minWidth:90}}>
                    <div style={{fontSize:10,color:'var(--si)',textTransform:'uppercase'}}>TTC</div>
                    <div style={{fontWeight:800,fontSize:18,color:'#92400e'}}>{montantTTC}</div>
                  </div>
                  <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                    {(()=>{
                      const cl=clients.find(c=>c.id===f.cid);
                      const lignesIds=new Set(f.lignesIds||[]);
                      const lignesF=(sejours||[])
                        .filter(s=>lignesIds.has(s.id))
                        .map(s=>({s,bien:biens.find(b=>b.id===s.bid)||{name:''},calc:calcSejour(s,biens.find(b=>b.id===s.bid)||{},cl)}))
                        .filter(l=>l.bien?.name);
                      return(<>
                        <button onClick={()=>regenererPDFDepuisFacture(f,cl,lignesF).catch(e=>alert('Erreur PDF : '+e.message))} className="btn bgh sm">⬇ PDF</button>
                        <button onClick={()=>marquerPayee(f)} className="btn bmn sm" style={{fontWeight:700}}>💶 Payée</button>
                        <button onClick={()=>setRelanceFac(f)} className="btn sm" style={{background:'#f59e0b',color:'#fff',fontWeight:700}}>🔔 Relancer</button>
                      </>);
                    })()}
                  </div>
                </div>
                {relances.length>0&&(
                  <div style={{marginTop:10,paddingTop:8,borderTop:'1px dashed #fde68a'}}>
                    <div style={{fontSize:11,fontWeight:700,color:'#92400e',marginBottom:5,textTransform:'uppercase',letterSpacing:'.05em'}}>Historique</div>
                    <div style={{display:'flex',flexDirection:'column',gap:4}}>
                      {relances.map((r,i)=>(
                        <div key={i} style={{fontSize:12,color:'var(--si)',display:'flex',alignItems:'flex-start',gap:6}}>
                          <div style={{flex:1}}>
                            <span style={{fontWeight:600,color:'#92400e'}}>Relance {i+1}</span>
                            {' · '}{new Date(r.ts).toLocaleString('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}
                            {r.dest&&r.dest.length>0&&<span> → {r.dest.join(', ')}</span>}
                            {r.note&&<span style={{fontStyle:'italic',color:'#6b5d52'}}> · "{r.note}"</span>}
                          </div>
                          <button onClick={()=>{if(window.confirm(`Supprimer la relance ${i+1} du ${new Date(r.ts).toLocaleDateString('fr-FR')} ?`))setFactures(prev=>prev.map(x=>x.id===f.id?{...x,relances:relances.filter((_,j)=>j!==i)}:x));}} className="btn bgh sm" style={{fontSize:10,padding:'2px 6px',color:'#b91c1c',flexShrink:0}} title="Supprimer cette relance">🗑</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>);
            })}
          </div>
        )}
      </div>);
    })()}

    {sub==='acompleter'&&(<div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:14,flexWrap:'wrap',gap:10}}>
        <div>
          <div className="D" style={{fontSize:18}}>Séjours importés automatiquement</div>
          <div style={{fontSize:12,color:'var(--si)',marginTop:3,maxWidth:560}}>Ces séjours proviennent de l'iCal du PMS (Eviivo et/ou Beds24 selon le bien). Ils ne contiennent que les dates : complète le nom du locataire, la plateforme et les montants, puis valide pour les basculer dans tes séjours saisis. Tant qu'ils sont ici, ils ne sont pas facturables.</div>
        </div>
        <button onClick={lancerSyncEviivo} disabled={syncing} className="btn bor" style={{whiteSpace:'nowrap'}}>{syncing?'⏳ Synchronisation…':'🔄 Synchroniser'}</button>
      </div>
      {syncMsg&&<div style={{padding:'10px 14px',borderRadius:9,marginBottom:14,fontSize:13,background:syncMsg.ok?'#e1f7ee':'#fff4d6',color:syncMsg.ok?'#2d6b3e':'#8a5a00',border:`1px solid ${syncMsg.ok?'#a8e0c0':'#f0d68a'}`}}>{syncMsg.text}</div>}
      {nbACompleter===0?(
        <div style={{textAlign:'center',padding:'40px 20px',color:'var(--si)'}}>
          <div style={{fontSize:32,marginBottom:8}}>📭</div>
          <div style={{fontSize:14}}>Aucun séjour en attente de complétion.</div>
          <div style={{fontSize:12,marginTop:4}}>Clique sur « Synchroniser » pour importer les dernières réservations.</div>
        </div>
      ):(
        <div style={{display:'grid',gap:10}}>
          {sejoursACompleter.slice().sort((a,b)=>(a.dateArrivee||'').localeCompare(b.dateArrivee||'')).map(s=>{
            const bien=(biens||[]).find(b=>b.id===s.bid);
            const annule=s.statut==='annule_eviivo';
            return(<div key={s.id} className="card" style={{padding:'12px 16px',borderLeft:`4px solid ${annule?'var(--dg)':'var(--pk)'}`}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:10,flexWrap:'wrap'}}>
                <div>
                  <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                    <span className="D" style={{fontSize:14}}>{bien?.name||'Bien inconnu'}</span>
                    {annule
                      ?<span style={{background:'var(--dg)',color:'white',fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999}}>ANNULÉ CHEZ {pmsLabel(s.pmsVendor).toUpperCase()}</span>
                      :<span style={{background:'var(--pk)',color:'white',fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999}}>À COMPLÉTER</span>}
                    {s._eviivoDatesMaj&&!annule&&<span style={{background:'var(--ye)',fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999}}>DATES MODIFIÉES</span>}
                  </div>
                  <div style={{fontSize:12,color:'var(--si)',marginTop:4}}>
                    Du <strong>{s.dateArrivee}</strong> au <strong>{s.dateDepart}</strong> · {s.nuitees} nuit(s){s.refEviivo?<span> · réf. {s.refEviivo}</span>:null}
                  </div>
                </div>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {!annule&&<button onClick={()=>setEditSej(s)} className="btn bor sm">✏️ Compléter</button>}
                  {!annule&&<button onClick={()=>{
                    // Ignorer un séjour importé en doublon : statut 'ignore' (sort du sas, jamais facturé, jamais supprimé)
                    // + ses 3 tâches liées passent en 'cancelled' (barrées, conservées).
                    if(!window.confirm("Ignorer ce séjour importé ? À utiliser s'il fait doublon avec un séjour que tu as déjà saisi. Le séjour et ses tâches seront conservés mais marqués annulés (non facturé, non planifié)."))return;
                    setSejours(prev=>prev.map(x=>x.id===s.id?{...x,statut:'ignore'}:x));
                    setSt(prev=>prev.map(t=>(t.source==='eviivo'&&t.eviivoUid===s.eviivoUid&&t.st!=='done')?{...t,st:'cancelled'}:t));
                  }} className="btn bgh sm" style={{color:'var(--si)'}}>🚫 Ignorer (déjà saisi)</button>}
                  {annule&&<button onClick={()=>{
                    // Confirmer l'annulation : séjour -> 'annulee', tâches liées -> 'cancelled'
                    if(!window.confirm("Confirmer l'annulation de ce séjour ? Les tâches liées seront marquées annulées (non supprimées)."))return;
                    setSejours(prev=>prev.map(x=>x.id===s.id?{...x,statut:'annulee'}:x));
                    setSt(prev=>prev.map(t=>(t.source==='eviivo'&&t.eviivoUid===s.eviivoUid&&t.st!=='done')?{...t,st:'cancelled'}:t));
                  }} className="btn sm" style={{background:'var(--dg)',color:'white'}}>✓ Confirmer l'annulation</button>}
                </div>
              </div>
              {annule&&<div style={{fontSize:11,color:'var(--dg)',marginTop:8,padding:'6px 10px',background:'#fdeaea',borderRadius:7}}>⚠️ Cette réservation a disparu de l'iCal {pmsLabel(s.pmsVendor)}. Les tâches check-in/check-out/ménage liées sont passées en « à vérifier » dans le planning. Confirme l'annulation ou ignore si c'est une erreur.</div>}
            </div>);
          })}
        </div>
      )}
      {editSej!==null&&<M onC={()=>setEditSej(null)} title="Compléter le séjour importé" col="var(--or)" wide ch={<SejourForm s={editSej} biens={biens} clients={clients} rep={rep||[]} st={st||[]} feries={feries||[]} sejours={sejours||[]} onSave={saveSej} onC={()=>setEditSej(null)}/>}/>}
    </div>)}

    {importExtModal&&<ImportFactureExterneModal clients={clients} setFactures={setFactures} onC={()=>setImportExtModal(false)}/>}

    {relanceFac&&(()=>{
      const cl=clients.find(c=>c.id===relanceFac.cid);
      const lignesIds=new Set(relanceFac.lignesIds||[]);
      const lignesF=(sejours||[])
        .filter(s=>lignesIds.has(s.id))
        .map(s=>({s,bien:biens.find(b=>b.id===s.bid)||{name:''},calc:calcSejour(s,biens.find(b=>b.id===s.bid)||{},cl)}))
        .filter(l=>l.bien?.name);
      return(<RelanceFactureModal
        fac={relanceFac}
        client={cl}
        fallbackLignes={lignesF}
        onC={()=>setRelanceFac(null)}
        onSent={(dest,note)=>{
          const nouvelleRelance={ts:new Date().toISOString(),dest,note:note||''};
          setFactures(prev=>prev.map(f=>f.id===relanceFac.id
            ?{...f,relances:[...(Array.isArray(f.relances)?f.relances:[]),nouvelleRelance]}
            :f));
          if(typeof P.logAction==='function'){const cl=(P.clients||[]).find(c=>c.id===relanceFac.cid);P.logAction({action:'relance_envoyee',qui:P.sess?.email||'Admin',role:'admin',objet:relanceFac.numeroDefinitif||relanceFac.id,cible:dest.join(', '),detail:note||''});}
          setRelanceFac(null);
        }}
        onDeleteRelance={(idx)=>{
          const rel=(Array.isArray(relanceFac.relances)?relanceFac.relances:[])[idx];
          setFactures(prev=>prev.map(f=>f.id===relanceFac.id
            ?{...f,relances:(Array.isArray(f.relances)?f.relances:[]).filter((_,j)=>j!==idx)}
            :f));
          setRelanceFac(r=>r?{...r,relances:(Array.isArray(r.relances)?r.relances:[]).filter((_,j)=>j!==idx)}:r);
          if(typeof P.logAction==='function'){const cl=(P.clients||[]).find(c=>c.id===relanceFac.cid);P.logAction({action:'relance_supprimee',qui:P.sess?.email||'Admin',role:'admin',objet:relanceFac.numeroDefinitif||relanceFac.id,cible:cl?.name||'',detail:rel?`Relance du ${new Date(rel.ts).toLocaleDateString('fr-FR')}`:'relance supprimée'});}
        }}
      />);
    })()}

    {envoiFac&&(()=>{
      const cl=clients.find(c=>c.id===envoiFac.cid);
      const lignesIds=new Set(envoiFac.lignesIds||[]);
      const lignesF=(sejours||[])
        .filter(s=>lignesIds.has(s.id))
        .map(s=>({s,bien:biens.find(b=>b.id===s.bid)||{name:''},calc:calcSejour(s,biens.find(b=>b.id===s.bid)||{},cl)}))
        .filter(l=>l.bien?.name);
      return(<EnvoiFactureModal
        fac={envoiFac}
        client={cl}
        fallbackLignes={lignesF}
        onC={()=>setEnvoiFac(null)}
        onSent={()=>{
          setFactures(prev=>prev.map(f=>f.id===envoiFac.id?{...f,dateEnvoiEmail:new Date().toISOString()}:f));
        }}
      />);
    })()}
  </div>);
}

// ── Vue récapitulatif propriétaire (interface client) ──
function ClientRecapView({sess,sejours,biens,clients,factures}){
  const myBiens=biens.filter(b=>b.cid===sess.id);
  const today_str=new Date().toISOString().split('T')[0];
  const STATUTS_EXCLUS_RECAP=['ignore','a_completer','annule_eviivo','annulee'];
  const mySejours=sejours.filter(s=>myBiens.some(b=>b.id===s.bid)&&!STATUTS_EXCLUS_RECAP.includes(s.statut)&&(s.dateDepart||s.dateArrivee||'')<=today_str);
  const MOIS_LONG=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  const client=clients.find(c=>c.id===sess.id);
  const now2=new Date();

  const[mode,setMode]=useState('annee');
  const[mois,setMois]=useState(now2.getMonth());
  const[annee,setAnnee]=useState(now2.getFullYear());
  const[dDebut,setDDebut]=useState('');
  const[dFin,setDFin]=useState('');
  const[detail,setDetail]=useState({}); // {sejourId:true} lignes dépliées
  const[bienFiltre,setBienFiltre]=useState('all'); // 'all' ou id de bien

  const dateRef=s=>s.dateDepart||s.dateArrivee||'';
  const dansPeriode=s=>{
    const ref=dateRef(s); if(!ref) return false;
    const d=new Date(ref);
    if(mode==='mois') return d.getMonth()===mois&&d.getFullYear()===annee;
    if(mode==='annee') return d.getFullYear()===annee;
    if(dDebut&&ref<dDebut) return false;
    if(dFin&&ref>dFin) return false;
    return true;
  };
  const periodeLabel=mode==='mois'?(MOIS_LONG[mois]+' '+annee)
    :mode==='annee'?String(annee)
    :((dDebut?dDebut.split('-').reverse().join('/'):'…')+' au '+(dFin?dFin.split('-').reverse().join('/'):'…'));
  const periodeFichier=mode==='mois'?(MOIS_LONG[mois]+'-'+annee)
    :mode==='annee'?String(annee)
    :((dDebut||'debut')+'_'+(dFin||'fin'));

  const sejoursPeriode=mySejours.filter(dansPeriode).filter(s=>bienFiltre==='all'||s.bid===bienFiltre).sort((a,b)=>dateRef(a).localeCompare(dateRef(b)));

  const calcLigne=s=>{
    const b=biens.find(x=>x.id===s.bid);
    const cl=(clients||[]).find(x=>x.id===sess.id);
    const c=b?calcSejour(s,b,cl):{totalTTC:0,prixNuitee:0,totalPrestations:0,fraisServices:0,fraisServicesNet:0,remiseProprio:0,remiseLabel:''};
    const verse=Number(s.versementProprio||0);
    const prestaTTC=Math.round(Number(c.totalPrestations||0)*1.2*100)/100;
    const fdsTTC=Math.round(Number(c.fraisServicesNet||c.fraisServices||0)*1.2*100)/100;
    const fraisTTC=Number(c.totalTTC||0);
    const remiseTTC=Math.round(Number(c.remiseProprio||0)*1.2*100)/100;
    const net=verse-fraisTTC;
    const payeLoc=Number(s.versementOTA||0);
    const commOTA=Number(s.fraisOTA||0);
    const taxe=Number(s.taxeSejour||0);
    return{b,c,verse,prestaTTC,fdsTTC,fraisTTC,remiseTTC,net,payeLoc,commOTA,taxe,ajustementOTA:Number(s.ajustementOTA||0),ajustementOTALibelle:s.ajustementOTALibelle||'',adultes:Number(s.adultes||0),enfants:Number(s.enfants||0)};
  };

  const tot=sejoursPeriode.reduce((a,s)=>{
    const L=calcLigne(s);
    return{
      nuitees:a.nuitees+Number(s.nuitees||0),
      verse:a.verse+L.verse, prestaTTC:a.prestaTTC+L.prestaTTC, fdsTTC:a.fdsTTC+L.fdsTTC,
      fraisTTC:a.fraisTTC+L.fraisTTC, net:a.net+L.net,
      payeLoc:a.payeLoc+L.payeLoc, commOTA:a.commOTA+L.commOTA, taxe:a.taxe+L.taxe,
      adultes:a.adultes+L.adultes, enfants:a.enfants+L.enfants, remiseTTC:a.remiseTTC+L.remiseTTC,
    };
  },{nuitees:0,verse:0,prestaTTC:0,fdsTTC:0,fraisTTC:0,net:0,payeLoc:0,commOTA:0,taxe:0,adultes:0,enfants:0,remiseTTC:0});

  // ── PDF complet (toutes colonnes, paysage) ──
  const genererPDF=async()=>{
    if(sejoursPeriode.length===0){alert('Aucun séjour pour cette période.');return;}
    const {PDFDocument,StandardFonts,rgb}=window.PDFLib;
    const san=t=>(t||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^\x20-\x7E]/g,' ');
    const eur=n=>Number(n||0).toFixed(2).replace('.',',');
    const fmt=d=>{if(!d)return'—';const p=d.split('-');return p[2]+'/'+p[1]+'/'+p[0];};

    const pdf=await PDFDocument.create();
    const font=await pdf.embedFont(StandardFonts.Helvetica);
    const bold=await pdf.embedFont(StandardFonts.HelveticaBold);
    const VERT=rgb(0.20,0.55,0.33),ROUGE=rgb(0.82,0.18,0.18),NOIR=rgb(0.16,0.145,0.125),GRIS=rgb(0.45,0.40,0.36),ACCENT=rgb(0.20,0.35,0.55);
    const PW=842,PH=595,M=22;
    let page=pdf.addPage([PW,PH]); let y=PH-36;
    const txt=(s,x,yy,f=font,sz=7,c=NOIR)=>page.drawText(san(s),{x,y:yy,size:sz,font:f,color:c});
    const txtR=(s,xR,yy,f=font,sz=7,c=NOIR)=>{const s2=san(s);page.drawText(s2,{x:xR-f.widthOfTextAtSize(s2,sz),y:yy,size:sz,font:f,color:c});};

    const cn=client?client.name:'';
    // Bien sélectionné ?
    const bienSel=bienFiltre!=='all'?biens.find(b=>b.id===bienFiltre):null;

    // En-tête
    txt('Recapitulatif de locations',M,y,bold,14,ACCENT);
    txt('BAILLEUR : '+cn,PW-M-260,y,bold,9,NOIR);
    y-=14;
    txt('Periode : '+periodeLabel,M,y,font,8,GRIS);
    if(client?.addr)txt(san(client.addr+'  '+(client.cp||'')+' '+(client.ville||'')),PW-M-260,y,font,7,GRIS);
    y-=12;
    if(bienSel)txt('Bien : '+san(bienSel.name),M,y,bold,10,ROUGE);
    y-=16;

    // Colonnes SANS la colonne Bien (libère ~80px)
    const C=[
      {x:M,     w:96, l:'Locataire',a:'l'},
      {x:M+96,  w:96, l:'Dates',a:'l'},
      {x:M+192, w:32, l:'Nuits',a:'r'},
      {x:M+224, w:40, l:'Ad./Enf.',a:'c'},
      {x:M+264, w:55, l:'OTA',a:'l'},
      {x:M+319, w:72, l:'Paye loc.',a:'r'},
      {x:M+391, w:64, l:'Comm.OTA',a:'r'},
      {x:M+455, w:60, l:'Taxe sej.',a:'r'},
      {x:M+515, w:68, l:'Verse(+)',a:'r'},
      {x:M+583, w:58, l:'Presta(-)',a:'r'},
      {x:M+641, w:58, l:'Frais sv(-)',a:'r'},
      {x:M+699, w:58, l:'Tot.fact(-)',a:'r'},
      {x:M+757, w:35, l:'Net(=)',a:'r'},
    ];
    const cell=(col,s,f=font,sz=6.5,c=NOIR)=>{
      if(col.a==='r')txtR(s,col.x+col.w-2,y,f,sz,c);
      else if(col.a==='c'){const s2=san(s);page.drawText(s2,{x:col.x+col.w/2-f.widthOfTextAtSize(s2,sz)/2,y,size:sz,font:f,color:c});}
      else txt(s,col.x+2,y,f,sz,c);
    };
    const drawHead=()=>{
      page.drawRectangle({x:M,y:y-3,width:PW-M*2,height:13,color:ACCENT});
      C.forEach(col=>cell(col,col.l,bold,6,rgb(1,1,1)));
      y-=16;
    };
    const drawRow=(L,s,z)=>{
      if(y<60){page=pdf.addPage([PW,PH]);y=PH-36;drawHead();}
      if(z%2)page.drawRectangle({x:M,y:y-3.5,width:PW-M*2,height:12,color:rgb(0.975,0.978,0.985)});
      cell(C[0],s.nomLocataire||'—');
      cell(C[1],fmt(s.dateArrivee)+'-'+fmt(s.dateDepart),font,6);
      cell(C[2],String(s.nuitees||0));
      cell(C[3],L.adultes+'/'+L.enfants);
      cell(C[4],san(s.ota||'—'),font,6,GRIS);
      cell(C[5],eur(L.payeLoc),font,6.5,GRIS);
      cell(C[6],eur(L.commOTA),font,6.5,GRIS);
      cell(C[7],eur(L.taxe),font,6.5,GRIS);
      cell(C[8],eur(L.verse),font,6.5,VERT);
      cell(C[9],eur(L.prestaTTC),font,6.5,ROUGE);
      cell(C[10],eur(L.fdsTTC),font,6.5,ROUGE);
      cell(C[11],eur(L.fraisTTC),font,6.5,ROUGE);
      cell(C[12],eur(L.net),bold,6.5,L.net>=0?VERT:ROUGE);
      y-=13;
    };
    const sommeGroupe=(arr)=>arr.reduce((a,s)=>{const L=calcLigne(s);return{nuitees:a.nuitees+Number(s.nuitees||0),verse:a.verse+L.verse,prestaTTC:a.prestaTTC+L.prestaTTC,fdsTTC:a.fdsTTC+L.fdsTTC,fraisTTC:a.fraisTTC+L.fraisTTC,net:a.net+L.net,payeLoc:a.payeLoc+L.payeLoc,commOTA:a.commOTA+L.commOTA,taxe:a.taxe+L.taxe,adultes:a.adultes+L.adultes,enfants:a.enfants+L.enfants};},{nuitees:0,verse:0,prestaTTC:0,fdsTTC:0,fraisTTC:0,net:0,payeLoc:0,commOTA:0,taxe:0,adultes:0,enfants:0});
    const drawTotaux=(T,label,couleurFond)=>{
      if(y<60){page=pdf.addPage([PW,PH]);y=PH-36;drawHead();}
      y-=2;
      page.drawRectangle({x:M,y:y-3.5,width:PW-M*2,height:14,color:couleurFond});
      cell(C[0],label,bold,7,ACCENT);
      cell(C[2],String(T.nuitees),bold,6.5,NOIR);
      cell(C[3],T.adultes+'/'+T.enfants,bold,6.5,NOIR);
      cell(C[5],eur(T.payeLoc),bold,6.5,GRIS);
      cell(C[6],eur(T.commOTA),bold,6.5,GRIS);
      cell(C[7],eur(T.taxe),bold,6.5,GRIS);
      cell(C[8],eur(T.verse),bold,6.5,VERT);
      cell(C[9],eur(T.prestaTTC),bold,6.5,ROUGE);
      cell(C[10],eur(T.fdsTTC),bold,6.5,ROUGE);
      cell(C[11],eur(T.fraisTTC),bold,6.5,ROUGE);
      cell(C[12],eur(T.net),bold,6.5,T.net>=0?VERT:ROUGE);
      y-=16;
    };

    drawHead();

    if(bienFiltre==='all'){
      // Groupé par bien avec sous-totaux
      const parBien={};
      sejoursPeriode.forEach(s=>{(parBien[s.bid]=parBien[s.bid]||[]).push(s);});
      const bidList=Object.keys(parBien).sort((a,b)=>{const na=(biens.find(x=>x.id===a)||{}).name||'';const nb=(biens.find(x=>x.id===b)||{}).name||'';return na.localeCompare(nb);});
      const plusieurs=bidList.length>1;
      bidList.forEach(bid=>{
        const b=biens.find(x=>x.id===bid);
        if(plusieurs){
          if(y<70){page=pdf.addPage([PW,PH]);y=PH-36;drawHead();}
          txt('▸ '+san(b?b.name:'—'),M,y,bold,8.5,NOIR);y-=13;
        }
        let z=0; parBien[bid].forEach(s=>drawRow(calcLigne(s),s,z++));
        if(plusieurs)drawTotaux(sommeGroupe(parBien[bid]),'Sous-total '+san(b?b.name:''),rgb(0.96,0.97,0.99));
      });
      // Total général
      drawTotaux(tot,'TOTAL GENERAL — '+periodeLabel,rgb(0.93,0.95,0.99));
    }else{
      // Un seul bien
      let z=0; sejoursPeriode.forEach(s=>drawRow(calcLigne(s),s,z++));
      drawTotaux(tot,'TOTAUX — '+periodeLabel,rgb(0.93,0.95,0.99));
    }

    y-=10;
    txt('Montants en euros. (+) encaisse par le bailleur via la plateforme  (-) facture par la conciergerie  (=) net revenant au bailleur.',M,y,font,6.5,GRIS); y-=10;
    txt('Paye loc. = montant total regle par le locataire a la plateforme.  Comm. OTA = commission prelevee par la plateforme (a la charge du bailleur).',M,y,font,6.5,GRIS); y-=10;
    txt('Taxe de sejour collectee pour la commune (enfants exoneres, comptabilises pour declaration). Ad./Enf. = adultes / enfants.',M,y,font,6.5,GRIS);

    pdf.setTitle(san('Recapitulatif '+periodeLabel+' - '+cn+(bienSel?' - '+bienSel.name:'')));
    const bytes=await pdf.save();
    const blob=new Blob([bytes],{type:'application/pdf'});
    const url=URL.createObjectURL(blob);
    const a=document.createElement('a');
    a.href=url;a.download='recap-'+periodeFichier+(bienSel?'-'+san(bienSel.name).replace(/\s+/g,'_'):'')+'-'+(cn.replace(/\s+/g,'_')||'proprietaire')+'.pdf';
    document.body.appendChild(a);a.click();document.body.removeChild(a);
    setTimeout(()=>URL.revokeObjectURL(url),2000);
  };
  const VERT='#2a8c54', ROUGE='#d12f2f';

  return(<div>
    <div className="D" style={{fontSize:22,marginBottom:6}}>Vos locations</div>

    {/* Sélecteur de période unifié */}
    <div style={{display:'flex',gap:10,marginBottom:14,flexWrap:'wrap',alignItems:'center'}}>
      <div style={{display:'flex',gap:4,background:'var(--bg)',borderRadius:9,padding:3}}>
        {[['mois','Mois'],['annee','Année'],['perso','Plage perso']].map(([m,lbl])=>(
          <button key={m} onClick={()=>setMode(m)} className="st" style={{background:mode===m?'var(--or)':'transparent',color:mode===m?'#fff':'var(--si)',border:'none',padding:'6px 12px',fontSize:12,fontWeight:mode===m?700:500}}>{lbl}</button>
        ))}
      </div>
      {mode==='mois'&&<>
        <select value={mois} onChange={e=>setMois(Number(e.target.value))} style={{width:'auto',minWidth:120,fontSize:13}}>
          {MOIS_LONG.map((m,i)=><option key={i} value={i}>{m}</option>)}
        </select>
        <select value={annee} onChange={e=>setAnnee(Number(e.target.value))} style={{width:'auto',fontSize:13}}>
          {Array.from({length:5},(_,i)=>new Date().getFullYear()-2+i).map(a=><option key={a} value={a}>{a}</option>)}
        </select>
      </>}
      {mode==='annee'&&<select value={annee} onChange={e=>setAnnee(Number(e.target.value))} style={{width:'auto',fontWeight:700,fontSize:15}}>
        {Array.from({length:5},(_,i)=>new Date().getFullYear()-2+i).map(a=><option key={a} value={a}>{a}</option>)}
      </select>}
      {mode==='perso'&&<div style={{display:'flex',gap:6,alignItems:'center'}}>
        <label style={{fontSize:12,color:'var(--si)'}}>Du</label>
        <input type="date" value={dDebut} onChange={e=>setDDebut(e.target.value)} style={{width:'auto',fontSize:13}}/>
        <label style={{fontSize:12,color:'var(--si)'}}>au</label>
        <input type="date" value={dFin} onChange={e=>setDFin(e.target.value)} style={{width:'auto',fontSize:13}}/>
      </div>}
      {myBiens.length>1&&<select value={bienFiltre} onChange={e=>setBienFiltre(e.target.value)} style={{width:'auto',fontSize:13}}>
        <option value="all">🏠 Tous les biens</option>
        {myBiens.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
      </select>}
      <button onClick={genererPDF} className="btn bor" style={{marginLeft:'auto'}} disabled={sejoursPeriode.length===0}>📄 Télécharger le récapitulatif comptable (PDF)</button>
    </div>

    {/* KPIs + indicateur visuel (piloté par l'admin via la fiche client) */}
    <div style={{display:'flex',gap:14,alignItems:'center',flexWrap:'wrap',marginBottom:20}}>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:10,flex:1}}>
        {[
          {l:'Nuitées louées',v:tot.nuitees,e:'🌙',c:'var(--si)'},
          {l:'Versé par les plateformes',v:feur(tot.verse),e:'💶',c:VERT},
          {l:'Frais conciergerie TTC',v:feur(tot.fraisTTC),e:'🧾',c:ROUGE},
          {l:'Revenu net',v:feur(tot.net),e:'📈',c:tot.net>=0?VERT:ROUGE},
        ].map((k,i)=>(
          <div key={i} className="scard" style={{borderTop:`3px solid ${k.c}`,padding:'12px 14px'}}>
            <div style={{fontSize:18,marginBottom:4}}>{k.e}</div>
            <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)',marginBottom:2}}>{k.l}</div>
            <div className="D" style={{fontSize:18,color:k.c}}>{k.v}</div>
          </div>
        ))}
      </div>
      {(()=>{
        const donutMetric=client?.donutMetric||'occ';
        if(donutMetric==='off')return null;
        let joursPeriode;
        if(mode==='mois')joursPeriode=new Date(annee,mois+1,0).getDate();
        else if(mode==='annee')joursPeriode=((annee%4===0&&annee%100!==0)||annee%400===0)?366:365;
        else if(dDebut&&dFin)joursPeriode=Math.max(1,Math.round((new Date(dFin)-new Date(dDebut))/86400000)+1);
        else joursPeriode=0;
        const denomOcc=joursPeriode*(myBiens.length||1);
        const tauxOcc=denomOcc>0?Math.round(tot.nuitees/denomOcc*100):0;
        const tauxConserv=tot.verse>0?Math.round(tot.net/tot.verse*100):0;
        const donutVal=donutMetric==='conserv'?tauxConserv:tauxOcc;
        const donutLabel=donutMetric==='conserv'?<>Part<br/>conservée</>:<>Taux<br/>occupation</>;
        return(<div style={{width:150,height:150,borderRadius:'50%',background:'var(--nbg)',boxShadow:'10px 10px 24px var(--nsh1),-10px -10px 24px var(--nsh2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
          <div style={{width:104,height:104,borderRadius:'50%',background:'var(--nbg)',boxShadow:'inset 6px 6px 14px var(--nsh1),inset -6px -6px 14px var(--nsh2)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',textAlign:'center'}}>
            <div style={{width:32,height:2,background:'#39c98a',marginBottom:6,borderRadius:2}}/>
            <div className="D" style={{fontSize:20,color:'#2f3e45'}}>{donutVal}%</div>
            <div style={{fontSize:11,color:'#5f6e75',lineHeight:1.2}}>{donutLabel}</div>
            <div style={{width:32,height:2,background:'#39c98a',marginTop:6,borderRadius:2}}/>
          </div>
        </div>);
      })()}
    </div>

    {/* Tableau détaillé (écran allégé + ligne repliable) */}
    {sejoursPeriode.length===0
      ?<div className="empty">Aucun séjour enregistré pour cette période.</div>
      :<div style={{overflowX:'auto',marginBottom:14}}>
        <table className="tbl">
          <thead><tr>
            <th></th><th>Bien</th><th>Locataire</th><th>Dates</th><th style={{textAlign:'center'}}>Nuits</th><th>Plateforme</th>
            <th style={{textAlign:'right'}}>Versé (+)</th>
            <th style={{textAlign:'right'}}>Prestations (−)</th>
            <th style={{textAlign:'right'}}>Frais de service (−)</th>
            <th style={{textAlign:'right'}}>Total facturé (−)</th>
            <th style={{textAlign:'right'}}>Net (=)</th>
            <th></th>
          </tr></thead>
          <tbody>
            {sejoursPeriode.map(s=>{
              const L=calcLigne(s);
              const open=!!detail[s.id];
              return(<React.Fragment key={s.id}>
              <tr style={s.aReprendre?{background:'#fffbf0'}:{}}>
                <td style={{width:24,textAlign:'center'}}><button onClick={()=>setDetail(d=>({...d,[s.id]:!d[s.id]}))} className="btn bgh sm" style={{padding:'1px 6px',fontSize:11}} title="Détails comptables">{open?'▾':'▸'}</button></td>
                <td><strong style={{fontSize:12}}>{L.b?.name||'—'}</strong>{s.aReprendre&&<div style={{marginTop:2}}><span style={{background:'#fff4d6',color:'#92400e',fontSize:9,fontWeight:700,padding:'1px 6px',borderRadius:999}}>⏳ Montants provisoires</span></div>}</td>
                <td style={{fontSize:11}}>{s.nomLocataire||'—'}{s.nationalite&&<span style={{color:'var(--si)',marginLeft:4}}>({s.nationalite})</span>}</td>
                <td style={{fontSize:11,color:'var(--si)'}}>{s.dateArrivee} → {s.dateDepart}</td>
                <td style={{textAlign:'center'}}>{s.nuitees}</td>
                <td><span style={{background:s.ota==='AIRBNB'?'#ffe0f0':s.ota==='BOOKING'?'#e0f0ff':'#e8e8e8',fontSize:10,fontWeight:700,padding:'2px 6px',borderRadius:999}}>{s.ota}</span></td>
                <td style={{textAlign:'right',color:VERT,fontWeight:600}}>{feur(L.verse)}</td>
                <td style={{textAlign:'right',color:ROUGE}}>{L.prestaTTC>0?feur(L.prestaTTC):'—'}</td>
                <td style={{textAlign:'right',color:ROUGE}}>{L.fdsTTC>0?feur(L.fdsTTC):'—'}</td>
                <td style={{textAlign:'right',color:ROUGE,fontWeight:600}}>{feur(L.fraisTTC)}</td>
                <td style={{textAlign:'right',fontWeight:700,color:L.net>=0?VERT:ROUGE}}>{feur(L.net)}{Number(s.nuitees||0)>0&&<div style={{fontSize:10,fontWeight:600,color:'var(--si)',marginTop:1}}>{feur(Math.round(L.net/Number(s.nuitees)*100)/100)} / nuit</div>}</td>
                <td><button onClick={()=>genererRecuLocataire(s,L.b,clients)} className="btn bgh sm" title="Reçu de séjour locataire" disabled={!L.b}>🧾</button></td>
              </tr>
              {open&&<tr style={{background:'#fafbfc'}}>
                <td></td>
                <td colSpan="11" style={{fontSize:11,color:'var(--si)',padding:'8px 10px'}}>
                  <div style={{display:'flex',gap:24,flexWrap:'wrap'}}>
                    <span>👥 <strong>{L.adultes}</strong> adulte{L.adultes>1?'s':''}{L.enfants>0&&<> · <strong>{L.enfants}</strong> enfant{L.enfants>1?'s':''} <span style={{fontSize:10}}>(exonérés taxe)</span></>}</span>
                    <span>💳 Payé par le locataire : <strong>{feur(L.payeLoc)}</strong></span>
                    <span>🏦 Commission {s.ota} : <strong style={{color:ROUGE}}>{feur(L.commOTA)}</strong></span>
                    <span>🏛️ Taxe de séjour : <strong>{feur(L.taxe)}</strong> {s.taxeCollecteeParOTA?<span style={{fontSize:10}}>(collectée par {s.ota})</span>:<span style={{fontSize:10}}>(réglée à l'arrivée)</span>}</span>
                    {L.ajustementOTA!==0&&<span style={{color:ROUGE}}>⚠️ Ajustement {s.ota}{L.ajustementOTALibelle?` — ${L.ajustementOTALibelle}`:''} : <strong>{feur(L.ajustementOTA)}</strong></span>}
                    {L.remiseTTC>0&&<span style={{color:'var(--ok)',fontWeight:600}}>🎁 {L.c?.remiseLabel||'Remise fidélité'} : <strong>−{feur(L.remiseTTC)}</strong></span>}
                  </div>
                </td>
              </tr>}
              </React.Fragment>);
            })}
          </tbody>
          <tfoot><tr>
            <td></td>
            <td colSpan="3" style={{fontWeight:700}}>Totaux — {periodeLabel}</td>
            <td style={{textAlign:'center',fontWeight:700}}>{tot.nuitees}</td>
            <td></td>
            <td style={{textAlign:'right',fontWeight:800,color:VERT}}>{feur(tot.verse)}</td>
            <td style={{textAlign:'right',fontWeight:700,color:ROUGE}}>{feur(tot.prestaTTC)}</td>
            <td style={{textAlign:'right',fontWeight:700,color:ROUGE}}>{feur(tot.fdsTTC)}</td>
            <td style={{textAlign:'right',fontWeight:800,color:ROUGE}}>{feur(tot.fraisTTC)}</td>
            <td style={{textAlign:'right',fontWeight:800,color:tot.net>=0?VERT:ROUGE}}>{feur(tot.net)}</td>
            <td></td>
          </tr></tfoot>
        </table>
      </div>}

    {/* Avoirs de la période (crédits en faveur du propriétaire) */}
    {(()=>{
      const avoirs=(factures||[]).filter(f=>f.cid===sess.id&&f.avoir&&f.periodeLabel===periodeLabel);
      if(!avoirs.length)return null;
      const ttc=v=>Math.round(Number(v||0)*1.2*100)/100;
      return(<div style={{background:'#f0f7ff',borderRadius:10,padding:'10px 14px',marginBottom:14,border:'1px solid #bae0ff'}}>
        <div style={{fontSize:12,fontWeight:700,color:'#0369a1',marginBottom:6}}>↩️ Avoirs sur cette période (en votre faveur)</div>
        {avoirs.map((f,i)=>(
          <div key={i} style={{display:'flex',alignItems:'center',gap:10,fontSize:12,flexWrap:'wrap',padding:'3px 0'}}>
            <span style={{fontWeight:700,color:'#0369a1'}}>{f.avoir.numero}</span>
            <span style={{color:VERT,fontWeight:700}}>+ {feur(ttc(f.avoir.montantHT))} TTC</span>
            <span style={{color:'var(--si)'}}>(avoir sur facture {f.numeroDefinitif}{f.avoir.motif?` — ${f.avoir.motif}`:''})</span>
          </div>
        ))}
      </div>);
    })()}

    {/* Légende */}
    <div style={{background:'var(--cr)',borderRadius:10,padding:'12px 14px',fontSize:11.5,color:'var(--si)',lineHeight:1.6}}>
      <div style={{marginBottom:4}}>Cliquez sur <strong>▸</strong> pour afficher le détail comptable de chaque séjour (payé locataire, commission plateforme, taxe de séjour, nombre de personnes).</div>
      <div style={{marginBottom:4}}><span style={{color:VERT,fontWeight:700}}>Versé (+)</span> : montant net que la plateforme vous a directement reversé (sa commission est déjà déduite par elle).</div>
      <div style={{marginBottom:4}}><span style={{color:ROUGE,fontWeight:700}}>Prestations (−)</span> : services réalisés (ménage, linge, accueil…). <span style={{color:ROUGE,fontWeight:700}}>Frais de service (−)</span> : prestations de mise à disposition et services associés au séjour.</div>
      <div><span style={{color:ROUGE,fontWeight:700}}>Total facturé (−)</span> : montant facturé par la conciergerie (TTC). <span style={{fontWeight:700}}>Net (=)</span> : ce qu'il vous reste après déduction. Le PDF reprend la période affichée avec toutes les colonnes comptables.</div>
    </div>
  </div>);
}

// ══════════════ POINTAGE SALARIÉ ══════════════
// ══════════════ OBJETS TROUVÉS ══════════════
export const OT_CATS=['Vêtement','Électronique','Bijou / montre','Document','Clé','Jouet','Livre','Chargeur','Cosmétique','Autre'];
export const OT_STATUS={
  // Hérités (Types anciens / Type 4 expédié)
  stored:{l:'En stock',c:'var(--ye)',bg:'#fff9e0'},
  claimed:{l:'Réclamé',c:'var(--or)',bg:'#fff4d6'},
  shipped:{l:'Expédié',c:'var(--ok)',bg:'#e1f7ee'},
  abandoned:{l:'Abandonné',c:'var(--si)',bg:'var(--li)'},
  // Type 1 — coffre-fort
  coffre:{l:'Au coffre',c:'#7c4dff',bg:'#ede7ff'},
  restitue:{l:'Restitué',c:'var(--ok)',bg:'#e1f7ee'},
  ecoule:{l:'Écoulé (3 ans)',c:'var(--si)',bg:'var(--li)'},
  // Type 2 — identité / paiement
  attente_retour:{l:'Attente retour',c:'var(--or)',bg:'#fff4d6'},
  depot_commissariat:{l:'Déposé commissariat',c:'#1565c0',bg:'#e3f2fd'},
  detruit:{l:'Détruit',c:'var(--si)',bg:'var(--li)'},
  // Type 3 & 5 — terminal immédiat
  jete:{l:'Jeté',c:'var(--si)',bg:'var(--li)'},
  conserve_salarie:{l:'Conservé (salarié)',c:'var(--ok)',bg:'#e1f7ee'},
  kit_accueil:{l:'Kit accueil',c:'#0097a7',bg:'#e0f7fa'},
  // Type 4 — bac
  bac:{l:'Dans le bac',c:'#e65100',bg:'#fff3e0'},
  donne:{l:'Donné',c:'var(--ok)',bg:'#e1f7ee'},
};

function nextCasier(objets){
  const used=new Set(objets.filter(o=>o.statut==='stored'||o.statut==='claimed').map(o=>o.casier));
  for(let i=1;i<=50;i++){if(!used.has(i))return i;}
  return null;
}


function OTBadge({statut}){
  const s=OT_STATUS[statut]||OT_STATUS.stored;
  return<span style={{background:s.bg,color:s.c,fontSize:11,fontWeight:700,padding:'3px 9px',borderRadius:999}}>{s.l}</span>;
}

// ═══════════════════════════════════════════════════════════════════
// TAXE DE SÉJOUR — Aide à la déclaration mairie (proprio) + décompte TS arrivée (admin)
// mode='client' : un seul propriétaire, ses biens. mode='admin' : tous.
// Rattachement d'un séjour à un mois = date d'ARRIVÉE (cohérent avec le reste de l'app).
// La taxe effective vient de calcSejour (= 0 si nonAssujettiTS) — source unique de vérité.
// ═══════════════════════════════════════════════════════════════════
function TaxeSejourView({mode,sess,sejours,biens,clients}){
  const now=new Date();
  const[ym,setYm]=useState(()=>`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}`);
  const[bienFiltre,setBienFiltre]=useState('all');

  // Biens visibles selon le mode
  const myBiens=useMemo(()=>{
    if(mode==='client'){
      const cid=sess?.id;
      return (biens||[]).filter(b=>b.cid===cid);
    }
    return biens||[];
  },[mode,sess,biens]);
  const myBienIds=useMemo(()=>new Set(myBiens.map(b=>b.id)),[myBiens]);

  // Séjours du mois (par date d'arrivée), limités aux biens visibles + filtre bien
  const lignes=useMemo(()=>{
    const [yy,mm]=ym.split('-');
    const STATUTS_EXCLUS_TS=['ignore','a_completer','annule_eviivo','annulee'];
    return (sejours||[])
      .filter(s=>myBienIds.has(s.bid))
      .filter(s=>!STATUTS_EXCLUS_TS.includes(s.statut))
      .filter(s=>bienFiltre==='all'||s.bid===bienFiltre)
      .filter(s=>{
        if(!s.dateArrivee)return false;
        const d=new Date(s.dateArrivee);
        return d.getFullYear()===Number(yy)&&(d.getMonth()+1)===Number(mm);
      })
      .map(s=>{
        const bien=(biens||[]).find(b=>b.id===s.bid)||{name:'—'};
        const calc=calcSejour(s,bien);
        const taxe=s.nonAssujettiTS?0:Number(s.taxeSejour||0);
        const prov=!s.nationalite?'Inconnue':(s.nationalite==='FR'?'France':'Étranger');
        return{s,bien,calc,taxe,prov};
      })
      .sort((a,b)=>(a.s.dateArrivee||'').localeCompare(b.s.dateArrivee||'')||(a.bien.name||'').localeCompare(b.bien.name||''));
  },[sejours,biens,myBienIds,bienFiltre,ym]);

  // Totaux
  const T=useMemo(()=>{
    const r={nuitees:0,adultes:0,enfants:0,taxeTotale:0,taxeOTA:0,taxeArrivee:0,nbNonAssuj:0};
    lignes.forEach(({s,calc,taxe})=>{
      r.nuitees+=Number(s.nuitees||0);
      r.adultes+=Number(s.adultes||0);
      r.enfants+=Number(s.enfants||0);
      r.taxeTotale+=taxe;
      if(s.nonAssujettiTS){r.nbNonAssuj++;return;}
      if(s.taxeCollecteeParOTA)r.taxeOTA+=taxe; else r.taxeArrivee+=taxe;
    });
    return r;
  },[lignes]);

  const moisLabel=(()=>{const[yy,mm]=ym.split('-');return new Date(Number(yy),Number(mm)-1,1).toLocaleDateString('fr-FR',{month:'long',year:'numeric'});})();

  const exportCSV=()=>{
    const sep=';';
    const head=['Arrivee','Depart','Bien','Locataire','Nuitees','Adultes (assujettis)','Mineurs (non assujettis)','Provenance','Prix nuit HT','Prix vente total HT','Taxe de sejour','Statut taxe'];
    const rows=lignes.map(({s,bien,calc,taxe,prov})=>{
      const statut=s.nonAssujettiTS?'Non assujetti':(s.taxeCollecteeParOTA?('Prelevee par '+(s.ota||'OTA')):'A regler (arrivee)');
      const prixVente=calc.prixNuitee*Number(s.nuitees||0);
      return[s.dateArrivee||'',s.dateDepart||'',bien.name||'',(s.nomLocataire||'').replace(/[;\n]/g,' '),s.nuitees||0,s.adultes||0,s.enfants||0,prov,String(calc.prixNuitee).replace('.',','),String(Math.round(prixVente*100)/100).replace('.',','),String(taxe).replace('.',','),statut];
    });
    const csv=[head,...rows].map(r=>r.join(sep)).join('\r\n');
    const blob=new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8;'});
    const url=URL.createObjectURL(blob);
    const a=document.createElement('a');
    a.href=url;a.download='taxe-sejour-'+ym+(bienFiltre!=='all'?'-'+(myBiens.find(b=>b.id===bienFiltre)?.name||'').replace(/\s+/g,'_'):'')+'.csv';
    document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
  };

  const moisInput=(<input type="month" value={ym} onChange={e=>setYm(e.target.value)} style={{padding:'6px 10px',borderRadius:7,border:'1px solid var(--li)',fontFamily:'inherit',fontSize:13}}/>);

  return(<div>
    <div style={{display:'flex',alignItems:'center',gap:12,flexWrap:'wrap',marginBottom:16}}>
      <h2 className="D" style={{margin:0,fontSize:22}}>🏛️ Taxe de séjour</h2>
      <span style={{fontSize:13,color:'var(--si)'}}>{moisLabel}</span>
    </div>

    {mode==='client'&&<div style={{background:'#eef6ff',border:'1px solid #cfe3ff',borderRadius:10,padding:'12px 14px',marginBottom:16,fontSize:13,lineHeight:1.5}}>
      Ce tableau vous aide à remplir votre déclaration de taxe de séjour en mairie. Pour chaque séjour, la colonne <strong>Statut taxe</strong> indique si la taxe a déjà été <strong>prélevée par la plateforme</strong> (Booking, Airbnb…) — auquel cas elle est reversée directement à la commune par celle-ci — ou si elle a été <strong>réglée à l'arrivée</strong> et reste à reverser de votre côté.
    </div>}

    <div style={{display:'flex',alignItems:'flex-end',gap:12,flexWrap:'wrap',marginBottom:16}}>
      <div><label className="fl">Mois</label><br/>{moisInput}</div>
      <div><label className="fl">Bien</label><br/>
        <select value={bienFiltre} onChange={e=>setBienFiltre(e.target.value)} style={{padding:'6px 10px',borderRadius:7,border:'1px solid var(--li)',fontFamily:'inherit',fontSize:13}}>
          <option value="all">Tous mes biens</option>
          {myBiens.slice().sort((a,b)=>(a.name||'').localeCompare(b.name||'')).map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      </div>
      <button onClick={exportCSV} className="btn bgh sm" disabled={!lignes.length}>⬇️ Export CSV</button>
    </div>

    {mode==='admin'&&<div style={{display:'flex',gap:12,flexWrap:'wrap',marginBottom:16}}>
      <div style={{flex:'1 1 200px',background:'#fff4e0',border:'1px solid #f5d9a0',borderRadius:10,padding:'12px 14px'}}>
        <div style={{fontSize:11,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>TS prélevées à l'arrivée</div>
        <div style={{fontSize:22,fontWeight:800,color:'var(--or)'}}>{feur(T.taxeArrivee)}</div>
        <div style={{fontSize:11,color:'var(--si)'}}>ce mois — à reverser aux communes</div>
      </div>
      <div style={{flex:'1 1 200px',background:'#eef6ff',border:'1px solid #cfe3ff',borderRadius:10,padding:'12px 14px'}}>
        <div style={{fontSize:11,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>TS prélevées par les OTA</div>
        <div style={{fontSize:22,fontWeight:800,color:'var(--bl)'}}>{feur(T.taxeOTA)}</div>
        <div style={{fontSize:11,color:'var(--si)'}}>reversées par les plateformes</div>
      </div>
      <div style={{flex:'1 1 200px',background:'#f3f4f6',border:'1px solid var(--li)',borderRadius:10,padding:'12px 14px'}}>
        <div style={{fontSize:11,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>Total taxe collectée</div>
        <div style={{fontSize:22,fontWeight:800}}>{feur(T.taxeTotale)}</div>
        <div style={{fontSize:11,color:'var(--si)'}}>{lignes.length} séjour{lignes.length>1?'s':''}{T.nbNonAssuj>0?` · ${T.nbNonAssuj} non assujetti${T.nbNonAssuj>1?'s':''}`:''}</div>
      </div>
    </div>}

    {!lignes.length?<div style={{textAlign:'center',padding:'40px 20px',color:'var(--si)'}}>Aucun séjour sur cette période.</div>:
    <div style={{overflowX:'auto',border:'1px solid var(--li)',borderRadius:10}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:12,whiteSpace:'nowrap'}}>
        <thead>
          <tr style={{background:'var(--cr)',textAlign:'left'}}>
            <th style={{padding:'8px 10px'}}>Séjour</th>
            {mode==='admin'&&<th style={{padding:'8px 10px'}}>Propriétaire</th>}
            <th style={{padding:'8px 10px'}}>Bien</th>
            <th style={{padding:'8px 10px'}}>Locataire</th>
            <th style={{padding:'8px 10px',textAlign:'center'}}>Nuitées</th>
            <th style={{padding:'8px 10px',textAlign:'center'}}>Adultes<br/><span style={{fontWeight:400,fontSize:9,color:'var(--si)'}}>assujettis</span></th>
            <th style={{padding:'8px 10px',textAlign:'center'}}>Mineurs<br/><span style={{fontWeight:400,fontSize:9,color:'var(--si)'}}>non assuj.</span></th>
            <th style={{padding:'8px 10px'}}>Provenance</th>
            <th style={{padding:'8px 10px',textAlign:'right'}}>Prix nuit HT</th>
            <th style={{padding:'8px 10px',textAlign:'right'}}>Prix vente HT</th>
            <th style={{padding:'8px 10px',textAlign:'right'}}>Taxe séjour</th>
            <th style={{padding:'8px 10px'}}>Statut taxe</th>
          </tr>
        </thead>
        <tbody>
          {lignes.map(({s,bien,calc,taxe,prov})=>{
            const cli=mode==='admin'?(clients||[]).find(c=>c.id===bien.cid):null;
            const prixVente=Math.round(calc.prixNuitee*Number(s.nuitees||0)*100)/100;
            const statut=s.nonAssujettiTS
              ?<span style={{color:'var(--si)',fontWeight:600}}>Non assujetti</span>
              :(s.taxeCollecteeParOTA
                ?<span style={{color:'var(--bl)',fontWeight:600}}>Prélevée par {s.ota||'OTA'}</span>
                :<span style={{color:'var(--or)',fontWeight:600}}>À régler (arrivée)</span>);
            return(<tr key={s.id} style={{borderTop:'1px solid var(--li)'}}>
              <td style={{padding:'8px 10px'}}>{s.dateArrivee}<span style={{color:'var(--si)'}}> → {s.dateDepart}</span></td>
              {mode==='admin'&&<td style={{padding:'8px 10px'}}>{cli?(cli.name||'—'):'—'}</td>}
              <td style={{padding:'8px 10px',fontWeight:600}}>{bien.name}</td>
              <td style={{padding:'8px 10px'}}>{s.nomLocataire||'—'}</td>
              <td style={{padding:'8px 10px',textAlign:'center'}}>{s.nuitees||0}</td>
              <td style={{padding:'8px 10px',textAlign:'center'}}>{s.adultes||0}</td>
              <td style={{padding:'8px 10px',textAlign:'center'}}>{s.enfants||0}</td>
              <td style={{padding:'8px 10px'}}>{prov}</td>
              <td style={{padding:'8px 10px',textAlign:'right'}}>{feur(calc.prixNuitee)}</td>
              <td style={{padding:'8px 10px',textAlign:'right'}}>{feur(prixVente)}</td>
              <td style={{padding:'8px 10px',textAlign:'right',fontWeight:700}}>{taxe>0?feur(taxe):'—'}</td>
              <td style={{padding:'8px 10px'}}>{statut}</td>
            </tr>);
          })}
        </tbody>
        <tfoot>
          <tr style={{borderTop:'2px solid var(--ink)',background:'var(--cr)',fontWeight:700}}>
            <td style={{padding:'8px 10px'}} colSpan={mode==='admin'?4:3}>TOTAL — {moisLabel}</td>
            <td style={{padding:'8px 10px',textAlign:'center'}}>{T.nuitees}</td>
            <td style={{padding:'8px 10px',textAlign:'center'}}>{T.adultes}</td>
            <td style={{padding:'8px 10px',textAlign:'center'}}>{T.enfants}</td>
            <td colSpan={3}></td>
            <td style={{padding:'8px 10px',textAlign:'right'}}>{feur(T.taxeTotale)}</td>
            <td style={{padding:'8px 10px',fontSize:11,fontWeight:400,color:'var(--si)'}}>
              <span style={{color:'var(--or)'}}>Arrivée : {feur(T.taxeArrivee)}</span><br/>
              <span style={{color:'var(--bl)'}}>OTA : {feur(T.taxeOTA)}</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>}
  </div>);
}



// Compte les factures émises non payées depuis plus de joursRetard jours.
// Utilisé par App.jsx pour le badge nav.
function nbFacturesEnRetard(factures, joursRetard=7){
  if(!Array.isArray(factures))return 0;
  const limitMs=joursRetard*24*60*60*1000;
  return factures.filter(f=>
    f.statut==='emise'&&
    f.dateEmission&&
    (Date.now()-new Date(f.dateEmission).getTime())>limitMs
  ).length;
}

export { AideFacturation, exportRecapPDF, RecapAnnuel, JustifsFacture, AvoirFacture, EnvoiFactureModal, RelanceFactureModal, ImportFactureExterneModal, FacturationPrestations, SecFacturation, ClientRecapView, nextCasier, OTBadge, TaxeSejourView, nbFacturesEnRetard };
